import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PersonaType = /*#__PURE__*/function (PersonaType) {
  PersonaType[PersonaType["PERSONA_TYPE_UNSET"] = 0] = "PERSONA_TYPE_UNSET";
  PersonaType[PersonaType["PERSONA_TYPE_PARTNER"] = 1] = "PERSONA_TYPE_PARTNER";
  PersonaType[PersonaType["PERSONA_TYPE_SALES_PERSON"] = 2] = "PERSONA_TYPE_SALES_PERSON";
  PersonaType[PersonaType["PERSONA_TYPE_DIGITAL_AGENT"] = 3] = "PERSONA_TYPE_DIGITAL_AGENT";
  PersonaType[PersonaType["PERSONA_TYPE_SMB"] = 4] = "PERSONA_TYPE_SMB";
  return PersonaType;
}(PersonaType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var KeyValueField = /*#__PURE__*/function (KeyValueField) {
  KeyValueField[KeyValueField["KEY_VALUE_FIELD_UNSET"] = 0] = "KEY_VALUE_FIELD_UNSET";
  KeyValueField[KeyValueField["KEY_VALUE_FIELD_DATA"] = 1] = "KEY_VALUE_FIELD_DATA";
  KeyValueField[KeyValueField["KEY_VALUE_FIELD_METADATA"] = 2] = "KEY_VALUE_FIELD_METADATA";
  return KeyValueField;
}(KeyValueField || {});
var Metric = /*#__PURE__*/function (Metric) {
  Metric[Metric["METRIC_NAMESPACE"] = 0] = "METRIC_NAMESPACE";
  Metric[Metric["METRIC_TYPE"] = 1] = "METRIC_TYPE";
  Metric[Metric["METRIC_TAG"] = 2] = "METRIC_TAG";
  Metric[Metric["METRIC_STATUS"] = 3] = "METRIC_STATUS";
  Metric[Metric["METRIC_ASSIGNEE"] = 4] = "METRIC_ASSIGNEE";
  Metric[Metric["METRIC_OLDEST_DUE_DATE"] = 5] = "METRIC_OLDEST_DUE_DATE";
  Metric[Metric["METRIC_STATUS_PER_TYPE"] = 6] = "METRIC_STATUS_PER_TYPE";
  Metric[Metric["METRIC_TYPE_PER_ASSIGNEE"] = 7] = "METRIC_TYPE_PER_ASSIGNEE";
  Metric[Metric["METRIC_STATUS_PER_ASSIGNEE_PER_TYPE"] = 8] = "METRIC_STATUS_PER_ASSIGNEE_PER_TYPE";
  Metric[Metric["METRIC_UNUSED"] = 9] = "METRIC_UNUSED";
  Metric[Metric["METRIC_STATUS_PER_ASSIGNEE"] = 10] = "METRIC_STATUS_PER_ASSIGNEE";
  Metric[Metric["METRIC_PARTNER"] = 11] = "METRIC_PARTNER";
  Metric[Metric["METRIC_PER_DAY"] = 12] = "METRIC_PER_DAY";
  Metric[Metric["METRIC_FULFILLING_PARTNER"] = 13] = "METRIC_FULFILLING_PARTNER";
  Metric[Metric["METRIC_TYPE_PER_DAY"] = 14] = "METRIC_TYPE_PER_DAY";
  Metric[Metric["METRIC_TAG_PER_DAY"] = 15] = "METRIC_TAG_PER_DAY";
  Metric[Metric["METRIC_COUNT_BY_DATE_RANGE"] = 16] = "METRIC_COUNT_BY_DATE_RANGE";
  Metric[Metric["METRIC_TASKS_COMPLETED_BY_DELAY"] = 17] = "METRIC_TASKS_COMPLETED_BY_DELAY";
  Metric[Metric["METRIC_TASKS_OVERDUE_BY_DELAY"] = 18] = "METRIC_TASKS_OVERDUE_BY_DELAY";
  return Metric;
}(Metric || {});
var RangeField = /*#__PURE__*/function (RangeField) {
  RangeField[RangeField["RANGE_FIELD_DUE_DATE"] = 0] = "RANGE_FIELD_DUE_DATE";
  RangeField[RangeField["RANGE_FIELD_COMPLETION_DATE"] = 1] = "RANGE_FIELD_COMPLETION_DATE";
  RangeField[RangeField["RANGE_FIELD_CREATED_DATE"] = 2] = "RANGE_FIELD_CREATED_DATE";
  return RangeField;
}(RangeField || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 0] = "SORT_DIRECTION_DESCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ExportColumns = /*#__PURE__*/function (ExportColumns) {
  ExportColumns[ExportColumns["EXPORT_COLUMNS_UNSET"] = 0] = "EXPORT_COLUMNS_UNSET";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_TITLE"] = 1] = "EXPORT_COLUMNS_TITLE";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_ACCOUNT"] = 2] = "EXPORT_COLUMNS_ACCOUNT";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_ADDRESS"] = 3] = "EXPORT_COLUMNS_ADDRESS";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_STATUS"] = 4] = "EXPORT_COLUMNS_STATUS";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_ASSIGNEE"] = 5] = "EXPORT_COLUMNS_ASSIGNEE";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_DUE_DATE"] = 6] = "EXPORT_COLUMNS_DUE_DATE";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_CREATED_DATE"] = 7] = "EXPORT_COLUMNS_CREATED_DATE";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_COMPLETION_DATE"] = 8] = "EXPORT_COLUMNS_COMPLETION_DATE";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_UPDATED"] = 9] = "EXPORT_COLUMNS_UPDATED";
  ExportColumns[ExportColumns["EXPORT_COLUMNS_PARTNER"] = 10] = "EXPORT_COLUMNS_PARTNER";
  return ExportColumns;
}(ExportColumns || {});
var ExportTypes = /*#__PURE__*/function (ExportTypes) {
  ExportTypes[ExportTypes["EXPORT_TYPES_UNSET"] = 0] = "EXPORT_TYPES_UNSET";
  ExportTypes[ExportTypes["EXPORT_TYPES_CSV"] = 1] = "EXPORT_TYPES_CSV";
  return ExportTypes;
}(ExportTypes || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccountSocialService = /*#__PURE__*/function (AccountSocialService) {
  AccountSocialService[AccountSocialService["ACCOUNT_SOCIAL_SERVICE_UNDEFINED"] = 0] = "ACCOUNT_SOCIAL_SERVICE_UNDEFINED";
  AccountSocialService[AccountSocialService["ACCOUNT_SOCIAL_SERVICE_FACEBOOK"] = 1] = "ACCOUNT_SOCIAL_SERVICE_FACEBOOK";
  AccountSocialService[AccountSocialService["ACCOUNT_SOCIAL_SERVICE_GMB"] = 2] = "ACCOUNT_SOCIAL_SERVICE_GMB";
  return AccountSocialService;
}(AccountSocialService || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ProductFilterOperator = /*#__PURE__*/function (ProductFilterOperator) {
  ProductFilterOperator[ProductFilterOperator["PRODUCT_FILTER_OPERATOR_UNSET"] = 0] = "PRODUCT_FILTER_OPERATOR_UNSET";
  ProductFilterOperator[ProductFilterOperator["PRODUCT_FILTER_OPERATOR_OR"] = 1] = "PRODUCT_FILTER_OPERATOR_OR";
  ProductFilterOperator[ProductFilterOperator["PRODUCT_FILTER_OPERATOR_AND"] = 2] = "PRODUCT_FILTER_OPERATOR_AND";
  return ProductFilterOperator;
}(ProductFilterOperator || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DateField = /*#__PURE__*/function (DateField) {
  DateField[DateField["DATE_FIELD_INVALID"] = 0] = "DATE_FIELD_INVALID";
  DateField[DateField["DATE_FIELD_DUE"] = 1] = "DATE_FIELD_DUE";
  DateField[DateField["DATE_FIELD_CREATED"] = 2] = "DATE_FIELD_CREATED";
  DateField[DateField["DATE_FIELD_COMPLETED"] = 3] = "DATE_FIELD_COMPLETED";
  DateField[DateField["DATE_FIELD_DELETED"] = 4] = "DATE_FIELD_DELETED";
  return DateField;
}(DateField || {});
var FuzzyRangeField = /*#__PURE__*/function (FuzzyRangeField) {
  FuzzyRangeField[FuzzyRangeField["FUZZY_RANGE_FIELD_INVALID"] = 0] = "FUZZY_RANGE_FIELD_INVALID";
  FuzzyRangeField[FuzzyRangeField["FUZZY_RANGE_FIELD_RUNTIME_COMPLETE_LATE"] = 1] = "FUZZY_RANGE_FIELD_RUNTIME_COMPLETE_LATE";
  FuzzyRangeField[FuzzyRangeField["FUZZY_RANGE_FIELD_RUNTIME_OVERDUE_DAYS"] = 2] = "FUZZY_RANGE_FIELD_RUNTIME_OVERDUE_DAYS";
  return FuzzyRangeField;
}(FuzzyRangeField || {});
var FuzzySortDirection = /*#__PURE__*/function (FuzzySortDirection) {
  FuzzySortDirection[FuzzySortDirection["FUZZY_SORT_DIRECTION_DESCENDING"] = 0] = "FUZZY_SORT_DIRECTION_DESCENDING";
  FuzzySortDirection[FuzzySortDirection["FUZZY_SORT_DIRECTION_ASCENDING"] = 1] = "FUZZY_SORT_DIRECTION_ASCENDING";
  return FuzzySortDirection;
}(FuzzySortDirection || {});
var Operator = /*#__PURE__*/function (Operator) {
  Operator[Operator["OPERATOR_INVALID"] = 0] = "OPERATOR_INVALID";
  Operator[Operator["OPERATOR_AND"] = 1] = "OPERATOR_AND";
  Operator[Operator["OPERATOR_OR"] = 2] = "OPERATOR_OR";
  return Operator;
}(Operator || {});
var RuntimeField = /*#__PURE__*/function (RuntimeField) {
  RuntimeField[RuntimeField["RUNTIME_FIELD_INVALID"] = 0] = "RUNTIME_FIELD_INVALID";
  RuntimeField[RuntimeField["RUNTIME_FIELD_COMPLETE_LATE"] = 1] = "RUNTIME_FIELD_COMPLETE_LATE";
  RuntimeField[RuntimeField["RUNTIME_FIELD_OVERDUE_DAYS"] = 2] = "RUNTIME_FIELD_OVERDUE_DAYS";
  return RuntimeField;
}(RuntimeField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var HydratedConversationPersonaType = /*#__PURE__*/function (HydratedConversationPersonaType) {
  HydratedConversationPersonaType[HydratedConversationPersonaType["HYDRATED_CONVERSATION_PERSONA_TYPE_UNSET"] = 0] = "HYDRATED_CONVERSATION_PERSONA_TYPE_UNSET";
  HydratedConversationPersonaType[HydratedConversationPersonaType["HYDRATED_CONVERSATION_PERSONA_TYPE_PARTNER"] = 1] = "HYDRATED_CONVERSATION_PERSONA_TYPE_PARTNER";
  HydratedConversationPersonaType[HydratedConversationPersonaType["HYDRATED_CONVERSATION_PERSONA_TYPE_SALES_PERSON"] = 2] = "HYDRATED_CONVERSATION_PERSONA_TYPE_SALES_PERSON";
  HydratedConversationPersonaType[HydratedConversationPersonaType["HYDRATED_CONVERSATION_PERSONA_TYPE_DIGITAL_AGENT"] = 3] = "HYDRATED_CONVERSATION_PERSONA_TYPE_DIGITAL_AGENT";
  HydratedConversationPersonaType[HydratedConversationPersonaType["HYDRATED_CONVERSATION_PERSONA_TYPE_SMB"] = 4] = "HYDRATED_CONVERSATION_PERSONA_TYPE_SMB";
  return HydratedConversationPersonaType;
}(HydratedConversationPersonaType || {});
var HydratedRangeField = /*#__PURE__*/function (HydratedRangeField) {
  HydratedRangeField[HydratedRangeField["HYDRATED_RANGE_FIELD_DUE_DATE"] = 0] = "HYDRATED_RANGE_FIELD_DUE_DATE";
  HydratedRangeField[HydratedRangeField["HYDRATED_RANGE_FIELD_COMPLETION_DATE"] = 1] = "HYDRATED_RANGE_FIELD_COMPLETION_DATE";
  HydratedRangeField[HydratedRangeField["HYDRATED_RANGE_FIELD_CREATED_DATE"] = 2] = "HYDRATED_RANGE_FIELD_CREATED_DATE";
  return HydratedRangeField;
}(HydratedRangeField || {});
var HydratedSortDirection = /*#__PURE__*/function (HydratedSortDirection) {
  HydratedSortDirection[HydratedSortDirection["HYDRATED_SORT_DIRECTION_DESCENDING"] = 0] = "HYDRATED_SORT_DIRECTION_DESCENDING";
  HydratedSortDirection[HydratedSortDirection["HYDRATED_SORT_DIRECTION_ASCENDING"] = 1] = "HYDRATED_SORT_DIRECTION_ASCENDING";
  return HydratedSortDirection;
}(HydratedSortDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RecurringTaskExpires = /*#__PURE__*/function (RecurringTaskExpires) {
  RecurringTaskExpires[RecurringTaskExpires["RECURRING_TASK_EXPIRES_NEVER"] = 0] = "RECURRING_TASK_EXPIRES_NEVER";
  RecurringTaskExpires[RecurringTaskExpires["RECURRING_TASK_EXPIRES_OCCURRENCES"] = 1] = "RECURRING_TASK_EXPIRES_OCCURRENCES";
  RecurringTaskExpires[RecurringTaskExpires["RECURRING_TASK_EXPIRES_EXPIRATION_DATE"] = 2] = "RECURRING_TASK_EXPIRES_EXPIRATION_DATE";
  return RecurringTaskExpires;
}(RecurringTaskExpires || {});
var RecurringTaskFrequencies = /*#__PURE__*/function (RecurringTaskFrequencies) {
  RecurringTaskFrequencies[RecurringTaskFrequencies["RECURRING_TASK_FREQUENCIES_UNSET"] = 0] = "RECURRING_TASK_FREQUENCIES_UNSET";
  RecurringTaskFrequencies[RecurringTaskFrequencies["RECURRING_TASK_FREQUENCIES_DAILY"] = 1] = "RECURRING_TASK_FREQUENCIES_DAILY";
  RecurringTaskFrequencies[RecurringTaskFrequencies["RECURRING_TASK_FREQUENCIES_WEEKLY"] = 2] = "RECURRING_TASK_FREQUENCIES_WEEKLY";
  RecurringTaskFrequencies[RecurringTaskFrequencies["RECURRING_TASK_FREQUENCIES_MONTHLY"] = 3] = "RECURRING_TASK_FREQUENCIES_MONTHLY";
  RecurringTaskFrequencies[RecurringTaskFrequencies["RECURRING_TASK_FREQUENCIES_YEARLY"] = 4] = "RECURRING_TASK_FREQUENCIES_YEARLY";
  RecurringTaskFrequencies[RecurringTaskFrequencies["RECURRING_TASK_FREQUENCIES_CUSTOM"] = 5] = "RECURRING_TASK_FREQUENCIES_CUSTOM";
  return RecurringTaskFrequencies;
}(RecurringTaskFrequencies || {});
var RecurringTaskTypes = /*#__PURE__*/function (RecurringTaskTypes) {
  RecurringTaskTypes[RecurringTaskTypes["RECURRING_TASK_TYPES_UNSET"] = 0] = "RECURRING_TASK_TYPES_UNSET";
  RecurringTaskTypes[RecurringTaskTypes["RECURRING_TASK_TYPES_TASK"] = 1] = "RECURRING_TASK_TYPES_TASK";
  RecurringTaskTypes[RecurringTaskTypes["RECURRING_TASK_TYPES_PROJECT"] = 2] = "RECURRING_TASK_TYPES_PROJECT";
  return RecurringTaskTypes;
}(RecurringTaskTypes || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AuxiliaryDataFieldType = /*#__PURE__*/function (AuxiliaryDataFieldType) {
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INVALID"] = 0] = "AUXILIARY_DATA_FIELD_TYPE_INVALID";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_STRING"] = 1] = "AUXILIARY_DATA_FIELD_TYPE_STRING";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INTEGER"] = 2] = "AUXILIARY_DATA_FIELD_TYPE_INTEGER";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DATE"] = 3] = "AUXILIARY_DATA_FIELD_TYPE_DATE";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DROPDOWN"] = 4] = "AUXILIARY_DATA_FIELD_TYPE_DROPDOWN";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_CURRENCY"] = 5] = "AUXILIARY_DATA_FIELD_TYPE_CURRENCY";
  return AuxiliaryDataFieldType;
}(AuxiliaryDataFieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActivityTypes = /*#__PURE__*/function (ActivityTypes) {
  ActivityTypes[ActivityTypes["ACTIVITY_TYPES_UNSET"] = 0] = "ACTIVITY_TYPES_UNSET";
  ActivityTypes[ActivityTypes["ACTIVITY_TYPES_EMAIL"] = 1] = "ACTIVITY_TYPES_EMAIL";
  ActivityTypes[ActivityTypes["ACTIVITY_TYPES_MEETING"] = 2] = "ACTIVITY_TYPES_MEETING";
  ActivityTypes[ActivityTypes["ACTIVITY_TYPES_CALL"] = 3] = "ACTIVITY_TYPES_CALL";
  return ActivityTypes;
}(ActivityTypes || {});
var CommentType = /*#__PURE__*/function (CommentType) {
  CommentType[CommentType["COMMENT_TYPE_UNDEFINED"] = 0] = "COMMENT_TYPE_UNDEFINED";
  CommentType[CommentType["COMMENT_TYPE_PUBLIC"] = 1] = "COMMENT_TYPE_PUBLIC";
  CommentType[CommentType["COMMENT_TYPE_PRIVATE"] = 2] = "COMMENT_TYPE_PRIVATE";
  return CommentType;
}(CommentType || {});
var ConversationTypes = /*#__PURE__*/function (ConversationTypes) {
  ConversationTypes[ConversationTypes["CONVERSATION_TYPES_UNSET"] = 0] = "CONVERSATION_TYPES_UNSET";
  ConversationTypes[ConversationTypes["CONVERSATION_TYPES_PROJECT_TRACKER_FEEDBACK"] = 1] = "CONVERSATION_TYPES_PROJECT_TRACKER_FEEDBACK";
  ConversationTypes[ConversationTypes["CONVERSATION_TYPES_PROJECT_TRACKER_APPROVAL"] = 2] = "CONVERSATION_TYPES_PROJECT_TRACKER_APPROVAL";
  ConversationTypes[ConversationTypes["CONVERSATION_TYPES_TAGGING"] = 3] = "CONVERSATION_TYPES_TAGGING";
  return ConversationTypes;
}(ConversationTypes || {});
var PlatformLocation = /*#__PURE__*/function (PlatformLocation) {
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_UNDEFINED"] = 0] = "PLATFORM_LOCATION_UNDEFINED";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_TASK_MANAGER"] = 1] = "PLATFORM_LOCATION_TASK_MANAGER";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_BUSINESS_APP"] = 2] = "PLATFORM_LOCATION_BUSINESS_APP";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_PARTNER_CENTER"] = 3] = "PLATFORM_LOCATION_PARTNER_CENTER";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_SALES_CENTER"] = 4] = "PLATFORM_LOCATION_SALES_CENTER";
  return PlatformLocation;
}(PlatformLocation || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$n(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccessPermissions {
  static fromProto(proto) {
    let m = new AccessPermissions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.read !== 'undefined') {
      toReturn['read'] = this.read;
    }
    if (typeof this.write !== 'undefined') {
      toReturn['write'] = this.write;
    }
    if (typeof this.delete !== 'undefined') {
      toReturn['delete'] = this.delete;
    }
    return toReturn;
  }
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    if (proto.filePermissions) {
      m.filePermissions = AccessPermissions.fromProto(proto.filePermissions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.uploadingPersonaType !== 'undefined') {
      toReturn['uploadingPersonaType'] = this.uploadingPersonaType;
    }
    if (typeof this.filePermissions !== 'undefined' && this.filePermissions !== null) {
      toReturn['filePermissions'] = 'toApiJson' in this.filePermissions ? this.filePermissions.toApiJson() : this.filePermissions;
    }
    return toReturn;
  }
}
class Conversation {
  static fromProto(proto) {
    let m = new Conversation();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.persona) {
      m.persona = enumStringToValue$n(PersonaType, proto.persona);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sendFrom !== 'undefined') {
      toReturn['sendFrom'] = this.sendFrom;
    }
    if (typeof this.sendTo !== 'undefined') {
      toReturn['sendTo'] = this.sendTo;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.persona !== 'undefined') {
      toReturn['persona'] = this.persona;
    }
    return toReturn;
  }
}
class History {
  static fromProto(proto) {
    let m = new History();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class KeyValuesKeyValue {
  static fromProto(proto) {
    let m = new KeyValuesKeyValue();
    m = Object.assign(m, proto);
    if (proto.values) {
      m.values = proto.values.map(KeyValuesKeyValueValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    return toReturn;
  }
}
class KeyValues {
  static fromProto(proto) {
    let m = new KeyValues();
    m = Object.assign(m, proto);
    if (proto.keyValues) {
      m.keyValues = proto.keyValues.map(KeyValuesKeyValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyValues !== 'undefined' && this.keyValues !== null) {
      toReturn['keyValues'] = 'toApiJson' in this.keyValues ? this.keyValues.toApiJson() : this.keyValues;
    }
    return toReturn;
  }
}
class Task {
  static fromProto(proto) {
    let m = new Task();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.history) {
      m.history = proto.history.map(History.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.completionDate) {
      m.completionDate = new Date(proto.completionDate);
    }
    if (proto.subtasks) {
      m.subtasks = proto.subtasks.map(TaskIdentity.fromProto);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.conversations) {
      m.conversations = proto.conversations.map(Conversation.fromProto);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.attachment) {
      m.attachment = proto.attachment.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.history !== 'undefined' && this.history !== null) {
      toReturn['history'] = 'toApiJson' in this.history ? this.history.toApiJson() : this.history;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.completionDate !== 'undefined' && this.completionDate !== null) {
      toReturn['completionDate'] = 'toApiJson' in this.completionDate ? this.completionDate.toApiJson() : this.completionDate;
    }
    if (typeof this.subtasks !== 'undefined' && this.subtasks !== null) {
      toReturn['subtasks'] = 'toApiJson' in this.subtasks ? this.subtasks.toApiJson() : this.subtasks;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    return toReturn;
  }
}
class TaskIdentity {
  static fromProto(proto) {
    let m = new TaskIdentity();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPath !== 'undefined') {
      toReturn['parentPath'] = this.parentPath;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    return toReturn;
  }
}
class TaskTree {
  static fromProto(proto) {
    let m = new TaskTree();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.history) {
      m.history = proto.history.map(History.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.completionDate) {
      m.completionDate = new Date(proto.completionDate);
    }
    if (proto.subtasks) {
      m.subtasks = proto.subtasks.map(TaskTree.fromProto);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.conversations) {
      m.conversations = proto.conversations.map(Conversation.fromProto);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.attachment) {
      m.attachment = proto.attachment.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.history !== 'undefined' && this.history !== null) {
      toReturn['history'] = 'toApiJson' in this.history ? this.history.toApiJson() : this.history;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.completionDate !== 'undefined' && this.completionDate !== null) {
      toReturn['completionDate'] = 'toApiJson' in this.completionDate ? this.completionDate.toApiJson() : this.completionDate;
    }
    if (typeof this.subtasks !== 'undefined' && this.subtasks !== null) {
      toReturn['subtasks'] = 'toApiJson' in this.subtasks ? this.subtasks.toApiJson() : this.subtasks;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    return toReturn;
  }
}
class KeyValuesKeyValueValue {
  static fromProto(proto) {
    let m = new KeyValuesKeyValueValue();
    m = Object.assign(m, proto);
    if (proto.int64Value) {
      m.int64Value = parseInt(proto.int64Value, 10);
    }
    if (proto.timeValue) {
      m.timeValue = new Date(proto.timeValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.int64Value !== 'undefined') {
      toReturn['int64Value'] = this.int64Value;
    }
    if (typeof this.boolValue !== 'undefined') {
      toReturn['boolValue'] = this.boolValue;
    }
    if (typeof this.doubleValue !== 'undefined') {
      toReturn['doubleValue'] = this.doubleValue;
    }
    if (typeof this.timeValue !== 'undefined' && this.timeValue !== null) {
      toReturn['timeValue'] = 'toApiJson' in this.timeValue ? this.timeValue.toApiJson() : this.timeValue;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
function enumStringToValue$m(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddAssigneeRequest {
  static fromProto(proto) {
    let m = new AddAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddAttachmentRequest {
  static fromProto(proto) {
    let m = new AddAttachmentRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.attachment) {
      m.attachment = Attachment.fromProto(proto.attachment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddConversationRequest {
  static fromProto(proto) {
    let m = new AddConversationRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.persona) {
      m.persona = enumStringToValue$m(PersonaType, proto.persona);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.sendFrom !== 'undefined') {
      toReturn['sendFrom'] = this.sendFrom;
    }
    if (typeof this.sendTo !== 'undefined') {
      toReturn['sendTo'] = this.sendTo;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.persona !== 'undefined') {
      toReturn['persona'] = this.persona;
    }
    return toReturn;
  }
}
class AddCustomTagsRequest {
  static fromProto(proto) {
    let m = new AddCustomTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddHistoryRequest {
  static fromProto(proto) {
    let m = new AddHistoryRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddMultiAssigneeRequest {
  static fromProto(proto) {
    let m = new AddMultiAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.addRequests) {
      m.addRequests = proto.addRequests.map(AddAssigneeRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addRequests !== 'undefined' && this.addRequests !== null) {
      toReturn['addRequests'] = 'toApiJson' in this.addRequests ? this.addRequests.toApiJson() : this.addRequests;
    }
    return toReturn;
  }
}
class AddMultipleSubtasksRequest {
  static fromProto(proto) {
    let m = new AddMultipleSubtasksRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.subtaskRequests) {
      m.subtaskRequests = proto.subtaskRequests.map(AddSubtaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.subtaskRequests !== 'undefined' && this.subtaskRequests !== null) {
      toReturn['subtaskRequests'] = 'toApiJson' in this.subtaskRequests ? this.subtaskRequests.toApiJson() : this.subtaskRequests;
    }
    return toReturn;
  }
}
class AddSubtaskRequest {
  static fromProto(proto) {
    let m = new AddSubtaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddTagsRequest {
  static fromProto(proto) {
    let m = new AddTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class CommandResponse {
  static fromProto(proto) {
    let m = new CommandResponse();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class CountMetricResponse {
  static fromProto(proto) {
    let m = new CountMetricResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class DeleteMultiTaskRequest {
  static fromProto(proto) {
    let m = new DeleteMultiTaskRequest();
    m = Object.assign(m, proto);
    if (proto.deleteRequests) {
      m.deleteRequests = proto.deleteRequests.map(DeleteTaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.deleteRequests !== 'undefined' && this.deleteRequests !== null) {
      toReturn['deleteRequests'] = 'toApiJson' in this.deleteRequests ? this.deleteRequests.toApiJson() : this.deleteRequests;
    }
    return toReturn;
  }
}
class DeleteTaskRequest {
  static fromProto(proto) {
    let m = new DeleteTaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class MultiCommandRequestEvent {
  static fromProto(proto) {
    let m = new MultiCommandRequestEvent();
    m = Object.assign(m, proto);
    if (proto.generate) {
      m.generate = GenerateTaskRequest.fromProto(proto.generate);
    }
    if (proto.addSubtask) {
      m.addSubtask = AddSubtaskRequest.fromProto(proto.addSubtask);
    }
    if (proto.setTitle) {
      m.setTitle = SetTitleRequest.fromProto(proto.setTitle);
    }
    if (proto.setType) {
      m.setType = SetTypeRequest.fromProto(proto.setType);
    }
    if (proto.addAssignee) {
      m.addAssignee = AddAssigneeRequest.fromProto(proto.addAssignee);
    }
    if (proto.removeAssignee) {
      m.removeAssignee = RemoveAssigneeRequest.fromProto(proto.removeAssignee);
    }
    if (proto.setDueDate) {
      m.setDueDate = SetDueDateRequest.fromProto(proto.setDueDate);
    }
    if (proto.setStatus) {
      m.setStatus = SetStatusRequest.fromProto(proto.setStatus);
    }
    if (proto.setKeyValue) {
      m.setKeyValue = SetKeyValue.fromProto(proto.setKeyValue);
    }
    if (proto.addHistory) {
      m.addHistory = AddHistoryRequest.fromProto(proto.addHistory);
    }
    if (proto.addConversation) {
      m.addConversation = AddConversationRequest.fromProto(proto.addConversation);
    }
    if (proto.addTags) {
      m.addTags = AddTagsRequest.fromProto(proto.addTags);
    }
    if (proto.removeTags) {
      m.removeTags = RemoveTagsRequest.fromProto(proto.removeTags);
    }
    if (proto.setNotes) {
      m.setNotes = SetNotesRequest.fromProto(proto.setNotes);
    }
    if (proto.setDescription) {
      m.setDescription = SetDescriptionRequest.fromProto(proto.setDescription);
    }
    if (proto.delete) {
      m.delete = DeleteTaskRequest.fromProto(proto.delete);
    }
    if (proto.restore) {
      m.restore = RestoreTaskRequest.fromProto(proto.restore);
    }
    if (proto.reorder) {
      m.reorder = ReorderSubtaskRequest.fromProto(proto.reorder);
    }
    if (proto.addAttachment) {
      m.addAttachment = AddAttachmentRequest.fromProto(proto.addAttachment);
    }
    if (proto.removeAttachment) {
      m.removeAttachment = RemoveAttachmentRequest.fromProto(proto.removeAttachment);
    }
    if (proto.addCustomTags) {
      m.addCustomTags = AddCustomTagsRequest.fromProto(proto.addCustomTags);
    }
    if (proto.removeCustomTags) {
      m.removeCustomTags = RemoveCustomTagsRequest.fromProto(proto.removeCustomTags);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.generate !== 'undefined' && this.generate !== null) {
      toReturn['generate'] = 'toApiJson' in this.generate ? this.generate.toApiJson() : this.generate;
    }
    if (typeof this.addSubtask !== 'undefined' && this.addSubtask !== null) {
      toReturn['addSubtask'] = 'toApiJson' in this.addSubtask ? this.addSubtask.toApiJson() : this.addSubtask;
    }
    if (typeof this.setTitle !== 'undefined' && this.setTitle !== null) {
      toReturn['setTitle'] = 'toApiJson' in this.setTitle ? this.setTitle.toApiJson() : this.setTitle;
    }
    if (typeof this.setType !== 'undefined' && this.setType !== null) {
      toReturn['setType'] = 'toApiJson' in this.setType ? this.setType.toApiJson() : this.setType;
    }
    if (typeof this.addAssignee !== 'undefined' && this.addAssignee !== null) {
      toReturn['addAssignee'] = 'toApiJson' in this.addAssignee ? this.addAssignee.toApiJson() : this.addAssignee;
    }
    if (typeof this.removeAssignee !== 'undefined' && this.removeAssignee !== null) {
      toReturn['removeAssignee'] = 'toApiJson' in this.removeAssignee ? this.removeAssignee.toApiJson() : this.removeAssignee;
    }
    if (typeof this.setDueDate !== 'undefined' && this.setDueDate !== null) {
      toReturn['setDueDate'] = 'toApiJson' in this.setDueDate ? this.setDueDate.toApiJson() : this.setDueDate;
    }
    if (typeof this.setStatus !== 'undefined' && this.setStatus !== null) {
      toReturn['setStatus'] = 'toApiJson' in this.setStatus ? this.setStatus.toApiJson() : this.setStatus;
    }
    if (typeof this.setKeyValue !== 'undefined' && this.setKeyValue !== null) {
      toReturn['setKeyValue'] = 'toApiJson' in this.setKeyValue ? this.setKeyValue.toApiJson() : this.setKeyValue;
    }
    if (typeof this.addHistory !== 'undefined' && this.addHistory !== null) {
      toReturn['addHistory'] = 'toApiJson' in this.addHistory ? this.addHistory.toApiJson() : this.addHistory;
    }
    if (typeof this.addConversation !== 'undefined' && this.addConversation !== null) {
      toReturn['addConversation'] = 'toApiJson' in this.addConversation ? this.addConversation.toApiJson() : this.addConversation;
    }
    if (typeof this.addTags !== 'undefined' && this.addTags !== null) {
      toReturn['addTags'] = 'toApiJson' in this.addTags ? this.addTags.toApiJson() : this.addTags;
    }
    if (typeof this.removeTags !== 'undefined' && this.removeTags !== null) {
      toReturn['removeTags'] = 'toApiJson' in this.removeTags ? this.removeTags.toApiJson() : this.removeTags;
    }
    if (typeof this.setNotes !== 'undefined' && this.setNotes !== null) {
      toReturn['setNotes'] = 'toApiJson' in this.setNotes ? this.setNotes.toApiJson() : this.setNotes;
    }
    if (typeof this.setDescription !== 'undefined' && this.setDescription !== null) {
      toReturn['setDescription'] = 'toApiJson' in this.setDescription ? this.setDescription.toApiJson() : this.setDescription;
    }
    if (typeof this.delete !== 'undefined' && this.delete !== null) {
      toReturn['delete'] = 'toApiJson' in this.delete ? this.delete.toApiJson() : this.delete;
    }
    if (typeof this.restore !== 'undefined' && this.restore !== null) {
      toReturn['restore'] = 'toApiJson' in this.restore ? this.restore.toApiJson() : this.restore;
    }
    if (typeof this.reorder !== 'undefined' && this.reorder !== null) {
      toReturn['reorder'] = 'toApiJson' in this.reorder ? this.reorder.toApiJson() : this.reorder;
    }
    if (typeof this.addAttachment !== 'undefined' && this.addAttachment !== null) {
      toReturn['addAttachment'] = 'toApiJson' in this.addAttachment ? this.addAttachment.toApiJson() : this.addAttachment;
    }
    if (typeof this.removeAttachment !== 'undefined' && this.removeAttachment !== null) {
      toReturn['removeAttachment'] = 'toApiJson' in this.removeAttachment ? this.removeAttachment.toApiJson() : this.removeAttachment;
    }
    if (typeof this.addCustomTags !== 'undefined' && this.addCustomTags !== null) {
      toReturn['addCustomTags'] = 'toApiJson' in this.addCustomTags ? this.addCustomTags.toApiJson() : this.addCustomTags;
    }
    if (typeof this.removeCustomTags !== 'undefined' && this.removeCustomTags !== null) {
      toReturn['removeCustomTags'] = 'toApiJson' in this.removeCustomTags ? this.removeCustomTags.toApiJson() : this.removeCustomTags;
    }
    return toReturn;
  }
}
class GenerateTaskRequest {
  static fromProto(proto) {
    let m = new GenerateTaskRequest();
    m = Object.assign(m, proto);
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class GetMetricsFilters {
  static fromProto(proto) {
    let m = new GetMetricsFilters();
    m = Object.assign(m, proto);
    if (proto.rangeStart) {
      m.rangeStart = new Date(proto.rangeStart);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = new Date(proto.rangeEnd);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.dateRangeField) {
      m.dateRangeField = enumStringToValue$m(RangeField, proto.dateRangeField);
    }
    if (proto.metadataGroups) {
      m.metadataGroups = GroupedMetadata.fromProto(proto.metadataGroups);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPathFuzzy !== 'undefined') {
      toReturn['parentPathFuzzy'] = this.parentPathFuzzy;
    }
    if (typeof this.parentPathExact !== 'undefined') {
      toReturn['parentPathExact'] = this.parentPathExact;
    }
    if (typeof this.titleFuzzy !== 'undefined') {
      toReturn['titleFuzzy'] = this.titleFuzzy;
    }
    if (typeof this.titleExact !== 'undefined') {
      toReturn['titleExact'] = this.titleExact;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.rangeStart !== 'undefined' && this.rangeStart !== null) {
      toReturn['rangeStart'] = 'toApiJson' in this.rangeStart ? this.rangeStart.toApiJson() : this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined' && this.rangeEnd !== null) {
      toReturn['rangeEnd'] = 'toApiJson' in this.rangeEnd ? this.rangeEnd.toApiJson() : this.rangeEnd;
    }
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.dateRangeField !== 'undefined') {
      toReturn['dateRangeField'] = this.dateRangeField;
    }
    if (typeof this.access !== 'undefined') {
      toReturn['access'] = this.access;
    }
    if (typeof this.metadataGroups !== 'undefined' && this.metadataGroups !== null) {
      toReturn['metadataGroups'] = 'toApiJson' in this.metadataGroups ? this.metadataGroups.toApiJson() : this.metadataGroups;
    }
    return toReturn;
  }
}
class GetMetricsRequest {
  static fromProto(proto) {
    let m = new GetMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.requests) {
      m.requests = proto.requests.map(GetMetricsRequestMetricRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requests !== 'undefined' && this.requests !== null) {
      toReturn['requests'] = 'toApiJson' in this.requests ? this.requests.toApiJson() : this.requests;
    }
    return toReturn;
  }
}
class GetMetricsResponse {
  static fromProto(proto) {
    let m = new GetMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = proto.metrics.map(v => enumStringToValue$m(Metric, v));
    }
    if (proto.responses) {
      m.responses = proto.responses.map(MetricResponses.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metrics !== 'undefined') {
      toReturn['metrics'] = this.metrics;
    }
    if (typeof this.responses !== 'undefined' && this.responses !== null) {
      toReturn['responses'] = 'toApiJson' in this.responses ? this.responses.toApiJson() : this.responses;
    }
    if (typeof this.names !== 'undefined') {
      toReturn['names'] = this.names;
    }
    return toReturn;
  }
}
class GetTaskRequest {
  static fromProto(proto) {
    let m = new GetTaskRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.returnDeleted !== 'undefined') {
      toReturn['returnDeleted'] = this.returnDeleted;
    }
    return toReturn;
  }
}
class GetTaskResponse {
  static fromProto(proto) {
    let m = new GetTaskResponse();
    m = Object.assign(m, proto);
    if (proto.task) {
      m.task = Task.fromProto(proto.task);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.task !== 'undefined' && this.task !== null) {
      toReturn['task'] = 'toApiJson' in this.task ? this.task.toApiJson() : this.task;
    }
    return toReturn;
  }
}
class GetTasksRequest {
  static fromProto(proto) {
    let m = new GetTasksRequest();
    m = Object.assign(m, proto);
    if (proto.identities) {
      m.identities = proto.identities.map(TaskIdentity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identities !== 'undefined' && this.identities !== null) {
      toReturn['identities'] = 'toApiJson' in this.identities ? this.identities.toApiJson() : this.identities;
    }
    if (typeof this.returnDeleted !== 'undefined') {
      toReturn['returnDeleted'] = this.returnDeleted;
    }
    if (typeof this.excludeDeleted !== 'undefined') {
      toReturn['excludeDeleted'] = this.excludeDeleted;
    }
    return toReturn;
  }
}
class GetTasksResponse {
  static fromProto(proto) {
    let m = new GetTasksResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(Task.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    return toReturn;
  }
}
class GetTreeRequest {
  static fromProto(proto) {
    let m = new GetTreeRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    return toReturn;
  }
}
class GetTreeResponse {
  static fromProto(proto) {
    let m = new GetTreeResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = TaskTree.fromProto(proto.tasks);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    return toReturn;
  }
}
class GroupedMetadata {
  static fromProto(proto) {
    let m = new GroupedMetadata();
    m = Object.assign(m, proto);
    if (proto.metadataGroup) {
      m.metadataGroup = proto.metadataGroup.map(KeyValues.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metadataGroup !== 'undefined' && this.metadataGroup !== null) {
      toReturn['metadataGroup'] = 'toApiJson' in this.metadataGroup ? this.metadataGroup.toApiJson() : this.metadataGroup;
    }
    return toReturn;
  }
}
class GroupedTags {
  static fromProto(proto) {
    let m = new GroupedTags();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(TagGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class GetMetricsRequestMetricRequest {
  static fromProto(proto) {
    let m = new GetMetricsRequestMetricRequest();
    m = Object.assign(m, proto);
    if (proto.metric) {
      m.metric = enumStringToValue$m(Metric, proto.metric);
    }
    if (proto.filters) {
      m.filters = GetMetricsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metric !== 'undefined') {
      toReturn['metric'] = this.metric;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class MetricResponsesMetricResponse {
  static fromProto(proto) {
    let m = new MetricResponsesMetricResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = CountMetricResponse.fromProto(proto.count);
    }
    if (proto.value) {
      m.value = ValueMetricResponse.fromProto(proto.value);
    }
    if (proto.subMetricResponses) {
      m.subMetricResponses = proto.subMetricResponses.map(MetricResponses.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined' && this.count !== null) {
      toReturn['count'] = 'toApiJson' in this.count ? this.count.toApiJson() : this.count;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    if (typeof this.subMetricResponses !== 'undefined' && this.subMetricResponses !== null) {
      toReturn['subMetricResponses'] = 'toApiJson' in this.subMetricResponses ? this.subMetricResponses.toApiJson() : this.subMetricResponses;
    }
    return toReturn;
  }
}
class MetricResponses {
  static fromProto(proto) {
    let m = new MetricResponses();
    m = Object.assign(m, proto);
    if (proto.metricResponses) {
      m.metricResponses = proto.metricResponses.map(MetricResponsesMetricResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricResponses !== 'undefined' && this.metricResponses !== null) {
      toReturn['metricResponses'] = 'toApiJson' in this.metricResponses ? this.metricResponses.toApiJson() : this.metricResponses;
    }
    return toReturn;
  }
}
class MultiCommandRequest {
  static fromProto(proto) {
    let m = new MultiCommandRequest();
    m = Object.assign(m, proto);
    if (proto.events) {
      m.events = proto.events.map(MultiCommandRequestEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.events !== 'undefined' && this.events !== null) {
      toReturn['events'] = 'toApiJson' in this.events ? this.events.toApiJson() : this.events;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class MultiCommandResponsesMultiCommandResponse {
  static fromProto(proto) {
    let m = new MultiCommandResponsesMultiCommandResponse();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    return toReturn;
  }
}
class MultiCommandResponses {
  static fromProto(proto) {
    let m = new MultiCommandResponses();
    m = Object.assign(m, proto);
    if (proto.responses) {
      m.responses = proto.responses.map(MultiCommandResponsesMultiCommandResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.responses !== 'undefined' && this.responses !== null) {
      toReturn['responses'] = 'toApiJson' in this.responses ? this.responses.toApiJson() : this.responses;
    }
    return toReturn;
  }
}
class MultiSearchTaskRequest {
  static fromProto(proto) {
    let m = new MultiSearchTaskRequest();
    m = Object.assign(m, proto);
    if (proto.searchRequests) {
      m.searchRequests = proto.searchRequests.map(SearchTaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchRequests !== 'undefined' && this.searchRequests !== null) {
      toReturn['searchRequests'] = 'toApiJson' in this.searchRequests ? this.searchRequests.toApiJson() : this.searchRequests;
    }
    return toReturn;
  }
}
class RemoveAssigneeRequest {
  static fromProto(proto) {
    let m = new RemoveAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RemoveAttachmentRequest {
  static fromProto(proto) {
    let m = new RemoveAttachmentRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.attachment) {
      m.attachment = Attachment.fromProto(proto.attachment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RemoveCustomTagsRequest {
  static fromProto(proto) {
    let m = new RemoveCustomTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RemoveMultiAssigneeRequest {
  static fromProto(proto) {
    let m = new RemoveMultiAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.removeRequests) {
      m.removeRequests = proto.removeRequests.map(RemoveAssigneeRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.removeRequests !== 'undefined' && this.removeRequests !== null) {
      toReturn['removeRequests'] = 'toApiJson' in this.removeRequests ? this.removeRequests.toApiJson() : this.removeRequests;
    }
    return toReturn;
  }
}
class RemoveTagsRequest {
  static fromProto(proto) {
    let m = new RemoveTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class ReorderSubtaskRequest {
  static fromProto(proto) {
    let m = new ReorderSubtaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.currentPosition) {
      m.currentPosition = parseInt(proto.currentPosition, 10);
    }
    if (proto.newPosition) {
      m.newPosition = parseInt(proto.newPosition, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.currentPosition !== 'undefined') {
      toReturn['currentPosition'] = this.currentPosition;
    }
    if (typeof this.newPosition !== 'undefined') {
      toReturn['newPosition'] = this.newPosition;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RestoreMultiTaskRequest {
  static fromProto(proto) {
    let m = new RestoreMultiTaskRequest();
    m = Object.assign(m, proto);
    if (proto.restoreRequests) {
      m.restoreRequests = proto.restoreRequests.map(RestoreTaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.restoreRequests !== 'undefined' && this.restoreRequests !== null) {
      toReturn['restoreRequests'] = 'toApiJson' in this.restoreRequests ? this.restoreRequests.toApiJson() : this.restoreRequests;
    }
    return toReturn;
  }
}
class RestoreTaskRequest {
  static fromProto(proto) {
    let m = new RestoreTaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SearchTaskRequest {
  static fromProto(proto) {
    let m = new SearchTaskRequest();
    m = Object.assign(m, proto);
    if (proto.rangeStart) {
      m.rangeStart = new Date(proto.rangeStart);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = new Date(proto.rangeEnd);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$m(SortDirection, proto.sortDirection);
    }
    if (proto.dateRangeField) {
      m.dateRangeField = enumStringToValue$m(RangeField, proto.dateRangeField);
    }
    if (proto.sorts) {
      m.sorts = proto.sorts.map(Sort.fromProto);
    }
    if (proto.tagGroups) {
      m.tagGroups = GroupedTags.fromProto(proto.tagGroups);
    }
    if (proto.metadataGroups) {
      m.metadataGroups = GroupedMetadata.fromProto(proto.metadataGroups);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPathFuzzy !== 'undefined') {
      toReturn['parentPathFuzzy'] = this.parentPathFuzzy;
    }
    if (typeof this.parentPathExact !== 'undefined') {
      toReturn['parentPathExact'] = this.parentPathExact;
    }
    if (typeof this.titleFuzzy !== 'undefined') {
      toReturn['titleFuzzy'] = this.titleFuzzy;
    }
    if (typeof this.titleExact !== 'undefined') {
      toReturn['titleExact'] = this.titleExact;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.rangeStart !== 'undefined' && this.rangeStart !== null) {
      toReturn['rangeStart'] = 'toApiJson' in this.rangeStart ? this.rangeStart.toApiJson() : this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined' && this.rangeEnd !== null) {
      toReturn['rangeEnd'] = 'toApiJson' in this.rangeEnd ? this.rangeEnd.toApiJson() : this.rangeEnd;
    }
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    if (typeof this.dateRangeField !== 'undefined') {
      toReturn['dateRangeField'] = this.dateRangeField;
    }
    if (typeof this.access !== 'undefined') {
      toReturn['access'] = this.access;
    }
    if (typeof this.sorts !== 'undefined' && this.sorts !== null) {
      toReturn['sorts'] = 'toApiJson' in this.sorts ? this.sorts.toApiJson() : this.sorts;
    }
    if (typeof this.excludeHistory !== 'undefined') {
      toReturn['excludeHistory'] = this.excludeHistory;
    }
    if (typeof this.deletedOnly !== 'undefined') {
      toReturn['deletedOnly'] = this.deletedOnly;
    }
    if (typeof this.tagGroups !== 'undefined' && this.tagGroups !== null) {
      toReturn['tagGroups'] = 'toApiJson' in this.tagGroups ? this.tagGroups.toApiJson() : this.tagGroups;
    }
    if (typeof this.metadataGroups !== 'undefined' && this.metadataGroups !== null) {
      toReturn['metadataGroups'] = 'toApiJson' in this.metadataGroups ? this.metadataGroups.toApiJson() : this.metadataGroups;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    return toReturn;
  }
}
class SearchTaskResponse {
  static fromProto(proto) {
    let m = new SearchTaskResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(Task.fromProto);
    }
    if (proto.hits) {
      m.hits = parseInt(proto.hits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.hits !== 'undefined') {
      toReturn['hits'] = this.hits;
    }
    return toReturn;
  }
}
class SetDescriptionRequest {
  static fromProto(proto) {
    let m = new SetDescriptionRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetDueDateRequest {
  static fromProto(proto) {
    let m = new SetDueDateRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetKeyValue {
  static fromProto(proto) {
    let m = new SetKeyValue();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.keyValueData) {
      m.keyValueData = KeyValues.fromProto(proto.keyValueData);
    }
    if (proto.field) {
      m.field = enumStringToValue$m(KeyValueField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.keyValueData !== 'undefined' && this.keyValueData !== null) {
      toReturn['keyValueData'] = 'toApiJson' in this.keyValueData ? this.keyValueData.toApiJson() : this.keyValueData;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class SetKeyValuesRequest {
  static fromProto(proto) {
    let m = new SetKeyValuesRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.keyValueData) {
      m.keyValueData = KeyValues.fromProto(proto.keyValueData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.keyValueData !== 'undefined' && this.keyValueData !== null) {
      toReturn['keyValueData'] = 'toApiJson' in this.keyValueData ? this.keyValueData.toApiJson() : this.keyValueData;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetMultiDueDateRequest {
  static fromProto(proto) {
    let m = new SetMultiDueDateRequest();
    m = Object.assign(m, proto);
    if (proto.dueDateRequests) {
      m.dueDateRequests = proto.dueDateRequests.map(SetDueDateRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dueDateRequests !== 'undefined' && this.dueDateRequests !== null) {
      toReturn['dueDateRequests'] = 'toApiJson' in this.dueDateRequests ? this.dueDateRequests.toApiJson() : this.dueDateRequests;
    }
    return toReturn;
  }
}
class SetMultiNotesRequest {
  static fromProto(proto) {
    let m = new SetMultiNotesRequest();
    m = Object.assign(m, proto);
    if (proto.notesRequests) {
      m.notesRequests = proto.notesRequests.map(SetNotesRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notesRequests !== 'undefined' && this.notesRequests !== null) {
      toReturn['notesRequests'] = 'toApiJson' in this.notesRequests ? this.notesRequests.toApiJson() : this.notesRequests;
    }
    return toReturn;
  }
}
class SetMultiStatusRequest {
  static fromProto(proto) {
    let m = new SetMultiStatusRequest();
    m = Object.assign(m, proto);
    if (proto.statusRequests) {
      m.statusRequests = proto.statusRequests.map(SetStatusRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusRequests !== 'undefined' && this.statusRequests !== null) {
      toReturn['statusRequests'] = 'toApiJson' in this.statusRequests ? this.statusRequests.toApiJson() : this.statusRequests;
    }
    return toReturn;
  }
}
class SetNotesRequest {
  static fromProto(proto) {
    let m = new SetNotesRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetStatusRequest {
  static fromProto(proto) {
    let m = new SetStatusRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetTitleRequest {
  static fromProto(proto) {
    let m = new SetTitleRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetTypeRequest {
  static fromProto(proto) {
    let m = new SetTypeRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class Sort {
  static fromProto(proto) {
    let m = new Sort();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$m(SortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class TagGroup {
  static fromProto(proto) {
    let m = new TagGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class ValueMetricResponse {
  static fromProto(proto) {
    let m = new ValueMetricResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$l(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$k(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddGroupMembersRequest {
  static fromProto(proto) {
    let m = new AddGroupMembersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.members !== 'undefined') {
      toReturn['members'] = this.members;
    }
    return toReturn;
  }
}
class CreateGroupRequest {
  static fromProto(proto) {
    let m = new CreateGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.membertype !== 'undefined') {
      toReturn['membertype'] = this.membertype;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class CreateGroupResponse {
  static fromProto(proto) {
    let m = new CreateGroupResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class DeleteGroupRequest {
  static fromProto(proto) {
    let m = new DeleteGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    return toReturn;
  }
}
class GroupGetMultiRequest {
  static fromProto(proto) {
    let m = new GroupGetMultiRequest();
    m = Object.assign(m, proto);
    if (proto.paths) {
      m.paths = proto.paths.map(Path.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined' && this.paths !== null) {
      toReturn['paths'] = 'toApiJson' in this.paths ? this.paths.toApiJson() : this.paths;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GroupGetMultiResponse {
  static fromProto(proto) {
    let m = new GroupGetMultiResponse();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(TaskManagerGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class ListGroupsByMembersResponseGroupsEntry {
  static fromProto(proto) {
    let m = new ListGroupsByMembersResponseGroupsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = TaskManagerGroupList.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class ListGroupMembersRequest {
  static fromProto(proto) {
    let m = new ListGroupMembersRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListGroupMembersResponse {
  static fromProto(proto) {
    let m = new ListGroupMembersResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.members !== 'undefined') {
      toReturn['members'] = this.members;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListGroupRequest {
  static fromProto(proto) {
    let m = new ListGroupRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.memberType !== 'undefined') {
      toReturn['memberType'] = this.memberType;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListGroupResponse {
  static fromProto(proto) {
    let m = new ListGroupResponse();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(TaskManagerGroup.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListGroupsByMembersRequest {
  static fromProto(proto) {
    let m = new ListGroupsByMembersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.members !== 'undefined') {
      toReturn['members'] = this.members;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListGroupsByMembersResponse {
  static fromProto(proto) {
    let m = new ListGroupsByMembersResponse();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = Object.keys(proto.groups).reduce((obj, k) => {
        obj[k] = TaskManagerGroupList.fromProto(proto.groups[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class Path {
  static fromProto(proto) {
    let m = new Path();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nodes !== 'undefined') {
      toReturn['nodes'] = this.nodes;
    }
    return toReturn;
  }
}
class RemoveGroupMembersRequest {
  static fromProto(proto) {
    let m = new RemoveGroupMembersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.members !== 'undefined') {
      toReturn['members'] = this.members;
    }
    return toReturn;
  }
}
class TaskManagerGroup {
  static fromProto(proto) {
    let m = new TaskManagerGroup();
    m = Object.assign(m, proto);
    if (proto.membersCount) {
      m.membersCount = parseInt(proto.membersCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.membersCount !== 'undefined') {
      toReturn['membersCount'] = this.membersCount;
    }
    return toReturn;
  }
}
class TaskManagerGroupList {
  static fromProto(proto) {
    let m = new TaskManagerGroupList();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(TaskManagerGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class UpdateGroupNameRequest {
  static fromProto(proto) {
    let m = new UpdateGroupNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
function enumStringToValue$j(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class UpdateTemplateRequestCommand {
  static fromProto(proto) {
    let m = new UpdateTemplateRequestCommand();
    m = Object.assign(m, proto);
    if (proto.daysToComplete) {
      m.daysToComplete = parseInt(proto.daysToComplete, 10);
    }
    if (proto.assigneesToAdd) {
      m.assigneesToAdd = MultiString.fromProto(proto.assigneesToAdd);
    }
    if (proto.assigneesToRemove) {
      m.assigneesToRemove = MultiString.fromProto(proto.assigneesToRemove);
    }
    if (proto.tagsToAdd) {
      m.tagsToAdd = MultiString.fromProto(proto.tagsToAdd);
    }
    if (proto.tagsToRemove) {
      m.tagsToRemove = MultiString.fromProto(proto.tagsToRemove);
    }
    if (proto.reorder) {
      m.reorder = ReorderSubtask.fromProto(proto.reorder);
    }
    if (proto.addSubtask) {
      m.addSubtask = Template.fromProto(proto.addSubtask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.daysToComplete !== 'undefined') {
      toReturn['daysToComplete'] = this.daysToComplete;
    }
    if (typeof this.assigneesToAdd !== 'undefined' && this.assigneesToAdd !== null) {
      toReturn['assigneesToAdd'] = 'toApiJson' in this.assigneesToAdd ? this.assigneesToAdd.toApiJson() : this.assigneesToAdd;
    }
    if (typeof this.assigneesToRemove !== 'undefined' && this.assigneesToRemove !== null) {
      toReturn['assigneesToRemove'] = 'toApiJson' in this.assigneesToRemove ? this.assigneesToRemove.toApiJson() : this.assigneesToRemove;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tagsToAdd !== 'undefined' && this.tagsToAdd !== null) {
      toReturn['tagsToAdd'] = 'toApiJson' in this.tagsToAdd ? this.tagsToAdd.toApiJson() : this.tagsToAdd;
    }
    if (typeof this.tagsToRemove !== 'undefined' && this.tagsToRemove !== null) {
      toReturn['tagsToRemove'] = 'toApiJson' in this.tagsToRemove ? this.tagsToRemove.toApiJson() : this.tagsToRemove;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.reorder !== 'undefined' && this.reorder !== null) {
      toReturn['reorder'] = 'toApiJson' in this.reorder ? this.reorder.toApiJson() : this.reorder;
    }
    if (typeof this.addSubtask !== 'undefined' && this.addSubtask !== null) {
      toReturn['addSubtask'] = 'toApiJson' in this.addSubtask ? this.addSubtask.toApiJson() : this.addSubtask;
    }
    if (typeof this.associatedProductId !== 'undefined') {
      toReturn['associatedProductId'] = this.associatedProductId;
    }
    if (typeof this.nextTaskLocked !== 'undefined') {
      toReturn['nextTaskLocked'] = this.nextTaskLocked;
    }
    if (typeof this.isVisible !== 'undefined') {
      toReturn['isVisible'] = this.isVisible;
    }
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    return toReturn;
  }
}
class CreateTemplateRequest {
  static fromProto(proto) {
    let m = new CreateTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class DeleteTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TemplateIdentity.fromProto(proto.identity);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class GetTemplateRequest {
  static fromProto(proto) {
    let m = new GetTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TemplateIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    return toReturn;
  }
}
class GetTemplateResponse {
  static fromProto(proto) {
    let m = new GetTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class ListTemplatesRequest {
  static fromProto(proto) {
    let m = new ListTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListTemplatesResponse {
  static fromProto(proto) {
    let m = new ListTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(Template.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class MultiString {
  static fromProto(proto) {
    let m = new MultiString();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ReorderSubtask {
  static fromProto(proto) {
    let m = new ReorderSubtask();
    m = Object.assign(m, proto);
    if (proto.currentPosition) {
      m.currentPosition = parseInt(proto.currentPosition, 10);
    }
    if (proto.newPosition) {
      m.newPosition = parseInt(proto.newPosition, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currentPosition !== 'undefined') {
      toReturn['currentPosition'] = this.currentPosition;
    }
    if (typeof this.newPosition !== 'undefined') {
      toReturn['newPosition'] = this.newPosition;
    }
    return toReturn;
  }
}
class Template {
  static fromProto(proto) {
    let m = new Template();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TemplateIdentity.fromProto(proto.identity);
    }
    if (proto.daysToComplete) {
      m.daysToComplete = parseInt(proto.daysToComplete, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.daysToComplete !== 'undefined') {
      toReturn['daysToComplete'] = this.daysToComplete;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.templateType !== 'undefined') {
      toReturn['templateType'] = this.templateType;
    }
    if (typeof this.associatedProductId !== 'undefined') {
      toReturn['associatedProductId'] = this.associatedProductId;
    }
    if (typeof this.nextTaskLocked !== 'undefined') {
      toReturn['nextTaskLocked'] = this.nextTaskLocked;
    }
    if (typeof this.subtaskIds !== 'undefined') {
      toReturn['subtaskIds'] = this.subtaskIds;
    }
    if (typeof this.isVisible !== 'undefined') {
      toReturn['isVisible'] = this.isVisible;
    }
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    return toReturn;
  }
}
class TemplateIdentity {
  static fromProto(proto) {
    let m = new TemplateIdentity();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPath !== 'undefined') {
      toReturn['parentPath'] = this.parentPath;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class UpdateTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TemplateIdentity.fromProto(proto.identity);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.commands) {
      m.commands = proto.commands.map(UpdateTemplateRequestCommand.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.commands !== 'undefined' && this.commands !== null) {
      toReturn['commands'] = 'toApiJson' in this.commands ? this.commands.toApiJson() : this.commands;
    }
    return toReturn;
  }
}
function enumStringToValue$i(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateTaskStatusRequest {
  static fromProto(proto) {
    let m = new CreateTaskStatusRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = TaskStatus.fromProto(proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    return toReturn;
  }
}
class CreateTaskStatusResponse {
  static fromProto(proto) {
    let m = new CreateTaskStatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class DeleteTaskStatusRequest {
  static fromProto(proto) {
    let m = new DeleteTaskStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class GetTaskStatusRequest {
  static fromProto(proto) {
    let m = new GetTaskStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    return toReturn;
  }
}
class GetTaskStatusResponse {
  static fromProto(proto) {
    let m = new GetTaskStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = TaskStatus.fromProto(proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    return toReturn;
  }
}
class ListTaskStatusesRequest {
  static fromProto(proto) {
    let m = new ListTaskStatusesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListTaskStatusesResponse {
  static fromProto(proto) {
    let m = new ListTaskStatusesResponse();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(TaskStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statuses !== 'undefined' && this.statuses !== null) {
      toReturn['statuses'] = 'toApiJson' in this.statuses ? this.statuses.toApiJson() : this.statuses;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class TaskStatus {
  static fromProto(proto) {
    let m = new TaskStatus();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    if (typeof this.textColour !== 'undefined') {
      toReturn['textColour'] = this.textColour;
    }
    if (typeof this.backgroundColour !== 'undefined') {
      toReturn['backgroundColour'] = this.backgroundColour;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    return toReturn;
  }
}
class UpdateTaskStatusRequest {
  static fromProto(proto) {
    let m = new UpdateTaskStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    if (typeof this.textColour !== 'undefined') {
      toReturn['textColour'] = this.textColour;
    }
    if (typeof this.backgroundColour !== 'undefined') {
      toReturn['backgroundColour'] = this.backgroundColour;
    }
    return toReturn;
  }
}
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ExportProjectsRequest {
  static fromProto(proto) {
    let m = new ExportProjectsRequest();
    m = Object.assign(m, proto);
    if (proto.exportType) {
      m.exportType = enumStringToValue$h(ExportTypes, proto.exportType);
    }
    if (proto.filters) {
      m.filters = ProjectSubtaskCountRequest.fromProto(proto.filters);
    }
    if (proto.columns) {
      m.columns = proto.columns.map(v => enumStringToValue$h(ExportColumns, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exportType !== 'undefined') {
      toReturn['exportType'] = this.exportType;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.columns !== 'undefined') {
      toReturn['columns'] = this.columns;
    }
    return toReturn;
  }
}
class ProjectSubtaskCount {
  static fromProto(proto) {
    let m = new ProjectSubtaskCount();
    m = Object.assign(m, proto);
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.completedDate) {
      m.completedDate = new Date(proto.completedDate);
    }
    if (proto.completedSubtasks) {
      m.completedSubtasks = parseInt(proto.completedSubtasks, 10);
    }
    if (proto.totalSubtasks) {
      m.totalSubtasks = parseInt(proto.totalSubtasks, 10);
    }
    if (proto.createdDate) {
      m.createdDate = new Date(proto.createdDate);
    }
    if (proto.updatedDate) {
      m.updatedDate = new Date(proto.updatedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.projectId !== 'undefined') {
      toReturn['projectId'] = this.projectId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.completedDate !== 'undefined' && this.completedDate !== null) {
      toReturn['completedDate'] = 'toApiJson' in this.completedDate ? this.completedDate.toApiJson() : this.completedDate;
    }
    if (typeof this.completedSubtasks !== 'undefined') {
      toReturn['completedSubtasks'] = this.completedSubtasks;
    }
    if (typeof this.totalSubtasks !== 'undefined') {
      toReturn['totalSubtasks'] = this.totalSubtasks;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.createdDate !== 'undefined' && this.createdDate !== null) {
      toReturn['createdDate'] = 'toApiJson' in this.createdDate ? this.createdDate.toApiJson() : this.createdDate;
    }
    if (typeof this.updatedDate !== 'undefined' && this.updatedDate !== null) {
      toReturn['updatedDate'] = 'toApiJson' in this.updatedDate ? this.updatedDate.toApiJson() : this.updatedDate;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ProjectSubtaskCountRequest {
  static fromProto(proto) {
    let m = new ProjectSubtaskCountRequest();
    m = Object.assign(m, proto);
    if (proto.dateRangeStart) {
      m.dateRangeStart = new Date(proto.dateRangeStart);
    }
    if (proto.dateRangeEnd) {
      m.dateRangeEnd = new Date(proto.dateRangeEnd);
    }
    if (proto.dateField) {
      m.dateField = enumStringToValue$h(RangeField, proto.dateField);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.dateRangeStart !== 'undefined' && this.dateRangeStart !== null) {
      toReturn['dateRangeStart'] = 'toApiJson' in this.dateRangeStart ? this.dateRangeStart.toApiJson() : this.dateRangeStart;
    }
    if (typeof this.dateRangeEnd !== 'undefined' && this.dateRangeEnd !== null) {
      toReturn['dateRangeEnd'] = 'toApiJson' in this.dateRangeEnd ? this.dateRangeEnd.toApiJson() : this.dateRangeEnd;
    }
    if (typeof this.dateField !== 'undefined') {
      toReturn['dateField'] = this.dateField;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
class ProjectSubtaskCountResponse {
  static fromProto(proto) {
    let m = new ProjectSubtaskCountResponse();
    m = Object.assign(m, proto);
    if (proto.projectSubtaskCount) {
      m.projectSubtaskCount = proto.projectSubtaskCount.map(ProjectSubtaskCount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.projectSubtaskCount !== 'undefined' && this.projectSubtaskCount !== null) {
      toReturn['projectSubtaskCount'] = 'toApiJson' in this.projectSubtaskCount ? this.projectSubtaskCount.toApiJson() : this.projectSubtaskCount;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateDigitalAgentRequest {
  static fromProto(proto) {
    let m = new CreateDigitalAgentRequest();
    m = Object.assign(m, proto);
    if (proto.partnerPermissions) {
      m.partnerPermissions = Object.keys(proto.partnerPermissions).reduce((obj, k) => {
        obj[k] = Permissions.fromProto(proto.partnerPermissions[k]);
        return obj;
      }, {});
    }
    if (proto.welcomeEmailOptions) {
      m.welcomeEmailOptions = WelcomeEmailOptions.fromProto(proto.welcomeEmailOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.agentEmail !== 'undefined') {
      toReturn['agentEmail'] = this.agentEmail;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.sendWelcome !== 'undefined') {
      toReturn['sendWelcome'] = this.sendWelcome;
    }
    if (typeof this.partnerPermissions !== 'undefined' && this.partnerPermissions !== null) {
      toReturn['partnerPermissions'] = 'toApiJson' in this.partnerPermissions ? this.partnerPermissions.toApiJson() : this.partnerPermissions;
    }
    if (typeof this.welcomeEmailOptions !== 'undefined' && this.welcomeEmailOptions !== null) {
      toReturn['welcomeEmailOptions'] = 'toApiJson' in this.welcomeEmailOptions ? this.welcomeEmailOptions.toApiJson() : this.welcomeEmailOptions;
    }
    return toReturn;
  }
}
class DeleteUserRequest {
  static fromProto(proto) {
    let m = new DeleteUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class DigitalAgent {
  static fromProto(proto) {
    let m = new DigitalAgent();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.partnerPermissions) {
      m.partnerPermissions = Object.keys(proto.partnerPermissions).reduce((obj, k) => {
        obj[k] = Permissions.fromProto(proto.partnerPermissions[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.accessiblePartnerIds !== 'undefined') {
      toReturn['accessiblePartnerIds'] = this.accessiblePartnerIds;
    }
    if (typeof this.partnerPermissions !== 'undefined' && this.partnerPermissions !== null) {
      toReturn['partnerPermissions'] = 'toApiJson' in this.partnerPermissions ? this.partnerPermissions.toApiJson() : this.partnerPermissions;
    }
    if (typeof this.profilePictureUrl !== 'undefined') {
      toReturn['profilePictureUrl'] = this.profilePictureUrl;
    }
    return toReturn;
  }
}
class GetDigitalAgentsBySubjectIdsRequest {
  static fromProto(proto) {
    let m = new GetDigitalAgentsBySubjectIdsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.subjectIds !== 'undefined') {
      toReturn['subjectIds'] = this.subjectIds;
    }
    return toReturn;
  }
}
class GetDigitalAgentsBySubjectIdsResponse {
  static fromProto(proto) {
    let m = new GetDigitalAgentsBySubjectIdsResponse();
    m = Object.assign(m, proto);
    if (proto.digitalAgents) {
      m.digitalAgents = proto.digitalAgents.map(DigitalAgent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.digitalAgents !== 'undefined' && this.digitalAgents !== null) {
      toReturn['digitalAgents'] = 'toApiJson' in this.digitalAgents ? this.digitalAgents.toApiJson() : this.digitalAgents;
    }
    return toReturn;
  }
}
class GetDigitalAgentsByUserIdsRequest {
  static fromProto(proto) {
    let m = new GetDigitalAgentsByUserIdsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    return toReturn;
  }
}
class GetDigitalAgentsByUserIdsResponse {
  static fromProto(proto) {
    let m = new GetDigitalAgentsByUserIdsResponse();
    m = Object.assign(m, proto);
    if (proto.digitalAgents) {
      m.digitalAgents = proto.digitalAgents.map(DigitalAgent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.digitalAgents !== 'undefined' && this.digitalAgents !== null) {
      toReturn['digitalAgents'] = 'toApiJson' in this.digitalAgents ? this.digitalAgents.toApiJson() : this.digitalAgents;
    }
    return toReturn;
  }
}
class GetMultiUserInfoExternalRequest {
  static fromProto(proto) {
    let m = new GetMultiUserInfoExternalRequest();
    m = Object.assign(m, proto);
    if (proto.userParams) {
      m.userParams = proto.userParams.map(UserParam.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userParams !== 'undefined' && this.userParams !== null) {
      toReturn['userParams'] = 'toApiJson' in this.userParams ? this.userParams.toApiJson() : this.userParams;
    }
    return toReturn;
  }
}
class GetMultiUserInfoExternalResponse {
  static fromProto(proto) {
    let m = new GetMultiUserInfoExternalResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = Object.keys(proto.users).reduce((obj, k) => {
        obj[k] = UserInfo.fromProto(proto.users[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    return toReturn;
  }
}
class ListAssigneesForPartnerRequest {
  static fromProto(proto) {
    let m = new ListAssigneesForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.onlyIncludeSameNamespace !== 'undefined') {
      toReturn['onlyIncludeSameNamespace'] = this.onlyIncludeSameNamespace;
    }
    return toReturn;
  }
}
class ListAssigneesForPartnerResponse {
  static fromProto(proto) {
    let m = new ListAssigneesForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.digitalAgents) {
      m.digitalAgents = proto.digitalAgents.map(DigitalAgent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.digitalAgents !== 'undefined' && this.digitalAgents !== null) {
      toReturn['digitalAgents'] = 'toApiJson' in this.digitalAgents ? this.digitalAgents.toApiJson() : this.digitalAgents;
    }
    return toReturn;
  }
}
class UpdateDigitalAgentRequestPartnerPermissionsEntry {
  static fromProto(proto) {
    let m = new UpdateDigitalAgentRequestPartnerPermissionsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Permissions.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class DigitalAgentPartnerPermissionsEntry {
  static fromProto(proto) {
    let m = new DigitalAgentPartnerPermissionsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Permissions.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class CreateDigitalAgentRequestPartnerPermissionsEntry {
  static fromProto(proto) {
    let m = new CreateDigitalAgentRequestPartnerPermissionsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Permissions.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Permissions {
  static fromProto(proto) {
    let m = new Permissions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canAccess !== 'undefined') {
      toReturn['canAccess'] = this.canAccess;
    }
    if (typeof this.isManager !== 'undefined') {
      toReturn['isManager'] = this.isManager;
    }
    return toReturn;
  }
}
class ResetEmailOptions {
  static fromProto(proto) {
    let m = new ResetEmailOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.usePlatformDefaultDomain !== 'undefined') {
      toReturn['usePlatformDefaultDomain'] = this.usePlatformDefaultDomain;
    }
    return toReturn;
  }
}
class SendWelcomeEmailRequest {
  static fromProto(proto) {
    let m = new SendWelcomeEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.usePlatformDefaultDomain !== 'undefined') {
      toReturn['usePlatformDefaultDomain'] = this.usePlatformDefaultDomain;
    }
    return toReturn;
  }
}
class UpdateDigitalAgentRequest {
  static fromProto(proto) {
    let m = new UpdateDigitalAgentRequest();
    m = Object.assign(m, proto);
    if (proto.partnerPermissions) {
      m.partnerPermissions = Object.keys(proto.partnerPermissions).reduce((obj, k) => {
        obj[k] = Permissions.fromProto(proto.partnerPermissions[k]);
        return obj;
      }, {});
    }
    if (proto.resetEmailOptions) {
      m.resetEmailOptions = ResetEmailOptions.fromProto(proto.resetEmailOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.agentEmail !== 'undefined') {
      toReturn['agentEmail'] = this.agentEmail;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.sendResetEmail !== 'undefined') {
      toReturn['sendResetEmail'] = this.sendResetEmail;
    }
    if (typeof this.partnerPermissions !== 'undefined' && this.partnerPermissions !== null) {
      toReturn['partnerPermissions'] = 'toApiJson' in this.partnerPermissions ? this.partnerPermissions.toApiJson() : this.partnerPermissions;
    }
    if (typeof this.resetEmailOptions !== 'undefined' && this.resetEmailOptions !== null) {
      toReturn['resetEmailOptions'] = 'toApiJson' in this.resetEmailOptions ? this.resetEmailOptions.toApiJson() : this.resetEmailOptions;
    }
    return toReturn;
  }
}
class UserInfo {
  static fromProto(proto) {
    let m = new UserInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    return toReturn;
  }
}
class UserParam {
  static fromProto(proto) {
    let m = new UserParam();
    m = Object.assign(m, proto);
    if (proto.personaType) {
      m.personaType = enumStringToValue$g(PersonaType, proto.personaType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.personaType !== 'undefined') {
      toReturn['personaType'] = this.personaType;
    }
    return toReturn;
  }
}
class GetMultiUserInfoExternalResponseUsersEntry {
  static fromProto(proto) {
    let m = new GetMultiUserInfoExternalResponseUsersEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = UserInfo.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class WelcomeEmailOptions {
  static fromProto(proto) {
    let m = new WelcomeEmailOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.usePlatformDefaultDomain !== 'undefined') {
      toReturn['usePlatformDefaultDomain'] = this.usePlatformDefaultDomain;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateCustomTagRequest {
  static fromProto(proto) {
    let m = new CreateCustomTagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tagName !== 'undefined') {
      toReturn['tagName'] = this.tagName;
    }
    return toReturn;
  }
}
class CreateCustomTagResponse {
  static fromProto(proto) {
    let m = new CreateCustomTagResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    return toReturn;
  }
}
class CustomTag {
  static fromProto(proto) {
    let m = new CustomTag();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    if (typeof this.tagName !== 'undefined') {
      toReturn['tagName'] = this.tagName;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    return toReturn;
  }
}
class DeleteCustomTagRequest {
  static fromProto(proto) {
    let m = new DeleteCustomTagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    return toReturn;
  }
}
class GetCustomTagRequest {
  static fromProto(proto) {
    let m = new GetCustomTagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    return toReturn;
  }
}
class GetCustomTagResponse {
  static fromProto(proto) {
    let m = new GetCustomTagResponse();
    m = Object.assign(m, proto);
    if (proto.tag) {
      m.tag = CustomTag.fromProto(proto.tag);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tag !== 'undefined' && this.tag !== null) {
      toReturn['tag'] = 'toApiJson' in this.tag ? this.tag.toApiJson() : this.tag;
    }
    return toReturn;
  }
}
class GetMultiCustomTagRequest {
  static fromProto(proto) {
    let m = new GetMultiCustomTagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tagIds !== 'undefined') {
      toReturn['tagIds'] = this.tagIds;
    }
    return toReturn;
  }
}
class GetMultiCustomTagResponse {
  static fromProto(proto) {
    let m = new GetMultiCustomTagResponse();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(CustomTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class ListCustomTagsRequest {
  static fromProto(proto) {
    let m = new ListCustomTagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListCustomTagsResponse {
  static fromProto(proto) {
    let m = new ListCustomTagsResponse();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(CustomTag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class UpdateCustomTagRequest {
  static fromProto(proto) {
    let m = new UpdateCustomTagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tagId !== 'undefined') {
      toReturn['tagId'] = this.tagId;
    }
    if (typeof this.newTagName !== 'undefined') {
      toReturn['newTagName'] = this.newTagName;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddProductsRequest {
  static fromProto(proto) {
    let m = new AddProductsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    return toReturn;
  }
}
class BusinessFulfillmentSetting {
  static fromProto(proto) {
    let m = new BusinessFulfillmentSetting();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class CreateBusinessFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new CreateBusinessFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    return toReturn;
  }
}
class CreateProductFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new CreateProductFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.ownerPartnerId !== 'undefined') {
      toReturn['ownerPartnerId'] = this.ownerPartnerId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class DeleteBusinessFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new DeleteBusinessFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class DeleteProductFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new DeleteProductFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    return toReturn;
  }
}
class GetBusinessFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new GetBusinessFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetBusinessFulfillmentSettingResponse {
  static fromProto(proto) {
    let m = new GetBusinessFulfillmentSettingResponse();
    m = Object.assign(m, proto);
    if (proto.setting) {
      m.setting = BusinessFulfillmentSetting.fromProto(proto.setting);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.setting !== 'undefined' && this.setting !== null) {
      toReturn['setting'] = 'toApiJson' in this.setting ? this.setting.toApiJson() : this.setting;
    }
    return toReturn;
  }
}
class GetMultiProductFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new GetMultiProductFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    if (proto.settingIds) {
      m.settingIds = proto.settingIds.map(ProductFulfillmentSettingKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.settingIds !== 'undefined' && this.settingIds !== null) {
      toReturn['settingIds'] = 'toApiJson' in this.settingIds ? this.settingIds.toApiJson() : this.settingIds;
    }
    return toReturn;
  }
}
class GetMultiProductFulfillmentSettingResponse {
  static fromProto(proto) {
    let m = new GetMultiProductFulfillmentSettingResponse();
    m = Object.assign(m, proto);
    if (proto.settings) {
      m.settings = proto.settings.map(ProductFulfillmentSetting.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    return toReturn;
  }
}
class LookupProductFulfillmentSettingRequest {
  static fromProto(proto) {
    let m = new LookupProductFulfillmentSettingRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class LookupProductFulfillmentSettingResponse {
  static fromProto(proto) {
    let m = new LookupProductFulfillmentSettingResponse();
    m = Object.assign(m, proto);
    if (proto.settings) {
      m.settings = proto.settings.map(ProductFulfillmentSetting.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ProductFulfillmentSetting {
  static fromProto(proto) {
    let m = new ProductFulfillmentSetting();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.ownerPartnerId !== 'undefined') {
      toReturn['ownerPartnerId'] = this.ownerPartnerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class ProductFulfillmentSettingKey {
  static fromProto(proto) {
    let m = new ProductFulfillmentSettingKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    return toReturn;
  }
}
class RemoveProductsRequest {
  static fromProto(proto) {
    let m = new RemoveProductsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    return toReturn;
  }
}
class SetFulfillingPartnerRequest {
  static fromProto(proto) {
    let m = new SetFulfillingPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    return toReturn;
  }
}
class SetTemplateRequest {
  static fromProto(proto) {
    let m = new SetTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Salesperson {
  static fromProto(proto) {
    let m = new Salesperson();
    m = Object.assign(m, proto);
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.photoUrlHttps !== 'undefined') {
      toReturn['photoUrlHttps'] = this.photoUrlHttps;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.isSalesManager !== 'undefined') {
      toReturn['isSalesManager'] = this.isSalesManager;
    }
    if (typeof this.meetingBookingUrl !== 'undefined') {
      toReturn['meetingBookingUrl'] = this.meetingBookingUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountGroup {
  static fromProto(proto) {
    let m = new AccountGroup();
    m = Object.assign(m, proto);
    if (proto.napData) {
      m.napData = NAPData.fromProto(proto.napData);
    }
    if (proto.externalIdentifiers) {
      m.externalIdentifiers = ExternalIdentifiers.fromProto(proto.externalIdentifiers);
    }
    if (proto.contactDetails) {
      m.contactDetails = ContactDetails.fromProto(proto.contactDetails);
    }
    if (proto.salesperson) {
      m.salesperson = Salesperson.fromProto(proto.salesperson);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    if (typeof this.externalIdentifiers !== 'undefined' && this.externalIdentifiers !== null) {
      toReturn['externalIdentifiers'] = 'toApiJson' in this.externalIdentifiers ? this.externalIdentifiers.toApiJson() : this.externalIdentifiers;
    }
    if (typeof this.contactDetails !== 'undefined' && this.contactDetails !== null) {
      toReturn['contactDetails'] = 'toApiJson' in this.contactDetails ? this.contactDetails.toApiJson() : this.contactDetails;
    }
    if (typeof this.salesperson !== 'undefined' && this.salesperson !== null) {
      toReturn['salesperson'] = 'toApiJson' in this.salesperson ? this.salesperson.toApiJson() : this.salesperson;
    }
    return toReturn;
  }
}
class ListCommitmentDatesResponseCommitmentDateEntry {
  static fromProto(proto) {
    let m = new ListCommitmentDatesResponseCommitmentDateEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = new Date(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class ConciergeAccount {
  static fromProto(proto) {
    let m = new ConciergeAccount();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.conciergeAccountId !== 'undefined') {
      toReturn['conciergeAccountId'] = this.conciergeAccountId;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.isCollectingTasks !== 'undefined') {
      toReturn['isCollectingTasks'] = this.isCollectingTasks;
    }
    if (typeof this.isBilling !== 'undefined') {
      toReturn['isBilling'] = this.isBilling;
    }
    if (typeof this.qaTasksEnabled !== 'undefined') {
      toReturn['qaTasksEnabled'] = this.qaTasksEnabled;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.market !== 'undefined') {
      toReturn['market'] = this.market;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.willDeactivate !== 'undefined') {
      toReturn['willDeactivate'] = this.willDeactivate;
    }
    return toReturn;
  }
}
class ContactDetails {
  static fromProto(proto) {
    let m = new ContactDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class CreateConciergeAccountRequest {
  static fromProto(proto) {
    let m = new CreateConciergeAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    return toReturn;
  }
}
class DeactivateConciergeAccountRequest {
  static fromProto(proto) {
    let m = new DeactivateConciergeAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ExternalIdentifiers {
  static fromProto(proto) {
    let m = new ExternalIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.jobId !== 'undefined') {
      toReturn['jobId'] = this.jobId;
    }
    if (typeof this.customerIdentifier !== 'undefined') {
      toReturn['customerIdentifier'] = this.customerIdentifier;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.actionLists !== 'undefined') {
      toReturn['actionLists'] = this.actionLists;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.taxIds !== 'undefined') {
      toReturn['taxIds'] = this.taxIds;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    return toReturn;
  }
}
class GetAccountListingSourcesSettingsRequest {
  static fromProto(proto) {
    let m = new GetAccountListingSourcesSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetPurchasingPartnerAccountRequest {
  static fromProto(proto) {
    let m = new GetPurchasingPartnerAccountRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchasingPartnerId !== 'undefined') {
      toReturn['purchasingPartnerId'] = this.purchasingPartnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetPurchasingPartnerAccountResponse {
  static fromProto(proto) {
    let m = new GetPurchasingPartnerAccountResponse();
    m = Object.assign(m, proto);
    if (proto.accountGroup) {
      m.accountGroup = AccountGroup.fromProto(proto.accountGroup);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn['accountGroup'] = 'toApiJson' in this.accountGroup ? this.accountGroup.toApiJson() : this.accountGroup;
    }
    return toReturn;
  }
}
class GetPurchasingPartnerConciergeAccountRequest {
  static fromProto(proto) {
    let m = new GetPurchasingPartnerConciergeAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchasingPartnerId !== 'undefined') {
      toReturn['purchasingPartnerId'] = this.purchasingPartnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetPurchasingPartnerConciergeAccountResponse {
  static fromProto(proto) {
    let m = new GetPurchasingPartnerConciergeAccountResponse();
    m = Object.assign(m, proto);
    if (proto.conciergeAccount) {
      m.conciergeAccount = ConciergeAccount.fromProto(proto.conciergeAccount);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conciergeAccount !== 'undefined' && this.conciergeAccount !== null) {
      toReturn['conciergeAccount'] = 'toApiJson' in this.conciergeAccount ? this.conciergeAccount.toApiJson() : this.conciergeAccount;
    }
    return toReturn;
  }
}
class GetSalesOrderFormSubmissionInfoRequest {
  static fromProto(proto) {
    let m = new GetSalesOrderFormSubmissionInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    return toReturn;
  }
}
class GetSalesOrderFormSubmissionInfoResponse {
  static fromProto(proto) {
    let m = new GetSalesOrderFormSubmissionInfoResponse();
    m = Object.assign(m, proto);
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(SalesOrderFormSubmissionField.fromProto);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(SalesOrderFormSubmissionField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    return toReturn;
  }
}
class GetTaskAccountsRequest {
  static fromProto(proto) {
    let m = new GetTaskAccountsRequest();
    m = Object.assign(m, proto);
    if (proto.identities) {
      m.identities = proto.identities.map(TaskIdentity.fromProto);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identities !== 'undefined' && this.identities !== null) {
      toReturn['identities'] = 'toApiJson' in this.identities ? this.identities.toApiJson() : this.identities;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetTaskAccountsResponse {
  static fromProto(proto) {
    let m = new GetTaskAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = proto.accounts.map(AccountGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    return toReturn;
  }
}
class GetTaskConciergeAccountRequest {
  static fromProto(proto) {
    let m = new GetTaskConciergeAccountRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    return toReturn;
  }
}
class GetTaskConciergeAccountResponse {
  static fromProto(proto) {
    let m = new GetTaskConciergeAccountResponse();
    m = Object.assign(m, proto);
    if (proto.conciergeAccount) {
      m.conciergeAccount = ConciergeAccount.fromProto(proto.conciergeAccount);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conciergeAccount !== 'undefined' && this.conciergeAccount !== null) {
      toReturn['conciergeAccount'] = 'toApiJson' in this.conciergeAccount ? this.conciergeAccount.toApiJson() : this.conciergeAccount;
    }
    return toReturn;
  }
}
class ListAccountSocialServicesRequest {
  static fromProto(proto) {
    let m = new ListAccountSocialServicesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    return toReturn;
  }
}
class ListAccountSocialServicesResponse {
  static fromProto(proto) {
    let m = new ListAccountSocialServicesResponse();
    m = Object.assign(m, proto);
    if (proto.socialServices) {
      m.socialServices = proto.socialServices.map(v => enumStringToValue$a(AccountSocialService, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServices !== 'undefined') {
      toReturn['socialServices'] = this.socialServices;
    }
    return toReturn;
  }
}
class ListCommitmentDatesRequest {
  static fromProto(proto) {
    let m = new ListCommitmentDatesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListCommitmentDatesResponse {
  static fromProto(proto) {
    let m = new ListCommitmentDatesResponse();
    m = Object.assign(m, proto);
    if (proto.commitmentDate) {
      m.commitmentDate = Object.keys(proto.commitmentDate).reduce((obj, k) => {
        obj[k] = new Date(proto.commitmentDate[k]);
        return obj;
      }, {});
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commitmentDate !== 'undefined' && this.commitmentDate !== null) {
      toReturn['commitmentDate'] = 'toApiJson' in this.commitmentDate ? this.commitmentDate.toApiJson() : this.commitmentDate;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class NAPData {
  static fromProto(proto) {
    let m = new NAPData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.workNumber !== 'undefined') {
      toReturn['workNumber'] = this.workNumber;
    }
    if (typeof this.callTrackingNumber !== 'undefined') {
      toReturn['callTrackingNumber'] = this.callTrackingNumber;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.serviceAreaBusiness !== 'undefined') {
      toReturn['serviceAreaBusiness'] = this.serviceAreaBusiness;
    }
    return toReturn;
  }
}
class PauseConciergeAccountRequest {
  static fromProto(proto) {
    let m = new PauseConciergeAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class SalesOrderFormSubmissionField {
  static fromProto(proto) {
    let m = new SalesOrderFormSubmissionField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    return toReturn;
  }
}
class SetAccountNoteRequest {
  static fromProto(proto) {
    let m = new SetAccountNoteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.note !== 'undefined') {
      toReturn['note'] = this.note;
    }
    return toReturn;
  }
}
class SourceSetting {
  static fromProto(proto) {
    let m = new SourceSetting();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceTypeId !== 'undefined') {
      toReturn['sourceTypeId'] = this.sourceTypeId;
    }
    if (typeof this.hasListingsFlag !== 'undefined') {
      toReturn['hasListingsFlag'] = this.hasListingsFlag;
    }
    if (typeof this.iconClass16px !== 'undefined') {
      toReturn['iconClass16px'] = this.iconClass16px;
    }
    if (typeof this.iconClass32px !== 'undefined') {
      toReturn['iconClass32px'] = this.iconClass32px;
    }
    if (typeof this.hasReviewsFlag !== 'undefined') {
      toReturn['hasReviewsFlag'] = this.hasReviewsFlag;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.enabledFlag !== 'undefined') {
      toReturn['enabledFlag'] = this.enabledFlag;
    }
    if (typeof this.visibilityEnabled !== 'undefined') {
      toReturn['visibilityEnabled'] = this.visibilityEnabled;
    }
    if (typeof this.socializeEnabled !== 'undefined') {
      toReturn['socializeEnabled'] = this.socializeEnabled;
    }
    if (typeof this.descriptionHtml !== 'undefined') {
      toReturn['descriptionHtml'] = this.descriptionHtml;
    }
    if (typeof this.reviewsEnabled !== 'undefined') {
      toReturn['reviewsEnabled'] = this.reviewsEnabled;
    }
    if (typeof this.sourceTypeName !== 'undefined') {
      toReturn['sourceTypeName'] = this.sourceTypeName;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.iconUrl32px !== 'undefined') {
      toReturn['iconUrl32px'] = this.iconUrl32px;
    }
    if (typeof this.listingsVerified !== 'undefined') {
      toReturn['listingsVerified'] = this.listingsVerified;
    }
    if (typeof this.anchorDataWarning !== 'undefined') {
      toReturn['anchorDataWarning'] = this.anchorDataWarning;
    }
    return toReturn;
  }
}
class SourceSettingsResponse {
  static fromProto(proto) {
    let m = new SourceSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.sourceSettings) {
      m.sourceSettings = proto.sourceSettings.map(SourceSetting.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceSettings !== 'undefined' && this.sourceSettings !== null) {
      toReturn['sourceSettings'] = 'toApiJson' in this.sourceSettings ? this.sourceSettings.toApiJson() : this.sourceSettings;
    }
    return toReturn;
  }
}
class UpdateAccountListingSourceRequest {
  static fromProto(proto) {
    let m = new UpdateAccountListingSourceRequest();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class UpdateAccountMultiListingSourceRequest {
  static fromProto(proto) {
    let m = new UpdateAccountMultiListingSourceRequest();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetOwnedAppIDsByPartnerIDRequest {
  static fromProto(proto) {
    let m = new GetOwnedAppIDsByPartnerIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetOwnedAppIDsByPartnerIDResponse {
  static fromProto(proto) {
    let m = new GetOwnedAppIDsByPartnerIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class ListAccountsRequest {
  static fromProto(proto) {
    let m = new ListAccountsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.productFilterOperator) {
      m.productFilterOperator = enumStringToValue$9(ProductFilterOperator, proto.productFilterOperator);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.productFilterOperator !== 'undefined') {
      toReturn['productFilterOperator'] = this.productFilterOperator;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAccountsResponse {
  static fromProto(proto) {
    let m = new ListAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.businesses) {
      m.businesses = proto.businesses.map(AccountGroup.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businesses !== 'undefined' && this.businesses !== null) {
      toReturn['businesses'] = 'toApiJson' in this.businesses ? this.businesses.toApiJson() : this.businesses;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetAccountProductDetailsRequest {
  static fromProto(proto) {
    let m = new GetAccountProductDetailsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetAccountProductDetailsResponse {
  static fromProto(proto) {
    let m = new GetAccountProductDetailsResponse();
    m = Object.assign(m, proto);
    if (proto.productDetails) {
      m.productDetails = proto.productDetails.map(ProductDetails.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productDetails !== 'undefined' && this.productDetails !== null) {
      toReturn['productDetails'] = 'toApiJson' in this.productDetails ? this.productDetails.toApiJson() : this.productDetails;
    }
    return toReturn;
  }
}
class GetAccountVendorProductDetailsRequest {
  static fromProto(proto) {
    let m = new GetAccountVendorProductDetailsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    return toReturn;
  }
}
class ListProductsRequest {
  static fromProto(proto) {
    let m = new ListProductsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListProductsResponse {
  static fromProto(proto) {
    let m = new ListProductsResponse();
    m = Object.assign(m, proto);
    if (proto.product) {
      m.product = proto.product.map(Product.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.product !== 'undefined' && this.product !== null) {
      toReturn['product'] = 'toApiJson' in this.product ? this.product.toApiJson() : this.product;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Product {
  static fromProto(proto) {
    let m = new Product();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.productIcon !== 'undefined') {
      toReturn['productIcon'] = this.productIcon;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    return toReturn;
  }
}
class ProductDetails {
  static fromProto(proto) {
    let m = new ProductDetails();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = parseInt(proto.status, 10);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    if (proto.activationDate) {
      m.activationDate = new Date(proto.activationDate);
    }
    if (proto.commitmentDate) {
      m.commitmentDate = new Date(proto.commitmentDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.isExpired !== 'undefined') {
      toReturn['isExpired'] = this.isExpired;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.ssoEnabled !== 'undefined') {
      toReturn['ssoEnabled'] = this.ssoEnabled;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    if (typeof this.activationDate !== 'undefined' && this.activationDate !== null) {
      toReturn['activationDate'] = 'toApiJson' in this.activationDate ? this.activationDate.toApiJson() : this.activationDate;
    }
    if (typeof this.commitmentDate !== 'undefined' && this.commitmentDate !== null) {
      toReturn['commitmentDate'] = 'toApiJson' in this.commitmentDate ? this.commitmentDate.toApiJson() : this.commitmentDate;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ChildNode {
  static fromProto(proto) {
    let m = new ChildNode();
    m = Object.assign(m, proto);
    if (proto.operatorNode) {
      m.operatorNode = OperatorNode.fromProto(proto.operatorNode);
    }
    if (proto.filters) {
      m.filters = Filters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operatorNode !== 'undefined' && this.operatorNode !== null) {
      toReturn['operatorNode'] = 'toApiJson' in this.operatorNode ? this.operatorNode.toApiJson() : this.operatorNode;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class DateFilter {
  static fromProto(proto) {
    let m = new DateFilter();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = enumStringToValue$7(DateField, proto.field);
    }
    if (proto.rangeStart) {
      m.rangeStart = new Date(proto.rangeStart);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = new Date(proto.rangeEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.rangeStart !== 'undefined' && this.rangeStart !== null) {
      toReturn['rangeStart'] = 'toApiJson' in this.rangeStart ? this.rangeStart.toApiJson() : this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined' && this.rangeEnd !== null) {
      toReturn['rangeEnd'] = 'toApiJson' in this.rangeEnd ? this.rangeEnd.toApiJson() : this.rangeEnd;
    }
    return toReturn;
  }
}
class Filters {
  static fromProto(proto) {
    let m = new Filters();
    m = Object.assign(m, proto);
    if (proto.dateFilters) {
      m.dateFilters = proto.dateFilters.map(DateFilter.fromProto);
    }
    if (proto.rangeFilters) {
      m.rangeFilters = proto.rangeFilters.map(FuzzyRangeFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fuzzyText !== 'undefined') {
      toReturn['fuzzyText'] = this.fuzzyText;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.parentTaskIds !== 'undefined') {
      toReturn['parentTaskIds'] = this.parentTaskIds;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.dateFilters !== 'undefined' && this.dateFilters !== null) {
      toReturn['dateFilters'] = 'toApiJson' in this.dateFilters ? this.dateFilters.toApiJson() : this.dateFilters;
    }
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.assigneeIds !== 'undefined') {
      toReturn['assigneeIds'] = this.assigneeIds;
    }
    if (typeof this.taskIds !== 'undefined') {
      toReturn['taskIds'] = this.taskIds;
    }
    if (typeof this.customTagIds !== 'undefined') {
      toReturn['customTagIds'] = this.customTagIds;
    }
    if (typeof this.rangeFilters !== 'undefined' && this.rangeFilters !== null) {
      toReturn['rangeFilters'] = 'toApiJson' in this.rangeFilters ? this.rangeFilters.toApiJson() : this.rangeFilters;
    }
    return toReturn;
  }
}
class FuzzyRangeFilter {
  static fromProto(proto) {
    let m = new FuzzyRangeFilter();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = enumStringToValue$7(FuzzyRangeField, proto.field);
    }
    if (proto.rangeStart) {
      m.rangeStart = parseInt(proto.rangeStart, 10);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = parseInt(proto.rangeEnd, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.rangeStart !== 'undefined') {
      toReturn['rangeStart'] = this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined') {
      toReturn['rangeEnd'] = this.rangeEnd;
    }
    return toReturn;
  }
}
class FuzzySort {
  static fromProto(proto) {
    let m = new FuzzySort();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$7(FuzzySortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class FuzzyTaskSearchRequest {
  static fromProto(proto) {
    let m = new FuzzyTaskSearchRequest();
    m = Object.assign(m, proto);
    if (proto.root) {
      m.root = OperatorNode.fromProto(proto.root);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.sorts) {
      m.sorts = proto.sorts.map(FuzzySort.fromProto);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = ProjectionFilter.fromProto(proto.projectionFilter);
    }
    if (proto.runtimeFields) {
      m.runtimeFields = proto.runtimeFields.map(v => enumStringToValue$7(RuntimeField, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.root !== 'undefined' && this.root !== null) {
      toReturn['root'] = 'toApiJson' in this.root ? this.root.toApiJson() : this.root;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.sorts !== 'undefined' && this.sorts !== null) {
      toReturn['sorts'] = 'toApiJson' in this.sorts ? this.sorts.toApiJson() : this.sorts;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.runtimeFields !== 'undefined') {
      toReturn['runtimeFields'] = this.runtimeFields;
    }
    return toReturn;
  }
}
class FuzzyTaskSearchResponse {
  static fromProto(proto) {
    let m = new FuzzyTaskSearchResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(Task.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class OperatorNode {
  static fromProto(proto) {
    let m = new OperatorNode();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$7(Operator, proto.operator);
    }
    if (proto.children) {
      m.children = proto.children.map(ChildNode.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.children !== 'undefined' && this.children !== null) {
      toReturn['children'] = 'toApiJson' in this.children ? this.children.toApiJson() : this.children;
    }
    return toReturn;
  }
}
class ProjectionFilter {
  static fromProto(proto) {
    let m = new ProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.history !== 'undefined') {
      toReturn['history'] = this.history;
    }
    if (typeof this.deletedOnly !== 'undefined') {
      toReturn['deletedOnly'] = this.deletedOnly;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountData {
  static fromProto(proto) {
    let m = new AccountData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    return toReturn;
  }
}
class AccountSalespersonData {
  static fromProto(proto) {
    let m = new AccountSalespersonData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class FuzzySearchHydratedTasksRequest {
  static fromProto(proto) {
    let m = new FuzzySearchHydratedTasksRequest();
    m = Object.assign(m, proto);
    if (proto.request) {
      m.request = FuzzyTaskSearchRequest.fromProto(proto.request);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = HydratedTaskProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.request !== 'undefined' && this.request !== null) {
      toReturn['request'] = 'toApiJson' in this.request ? this.request.toApiJson() : this.request;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class FuzzySearchHydratedTasksResponse {
  static fromProto(proto) {
    let m = new FuzzySearchHydratedTasksResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(HydratedTask.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class GetHydratedTaskRequest {
  static fromProto(proto) {
    let m = new GetHydratedTaskRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = HydratedTaskIdentity.fromProto(proto.identity);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = HydratedTaskProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetHydratedTaskResponse {
  static fromProto(proto) {
    let m = new GetHydratedTaskResponse();
    m = Object.assign(m, proto);
    if (proto.task) {
      m.task = HydratedTask.fromProto(proto.task);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.task !== 'undefined' && this.task !== null) {
      toReturn['task'] = 'toApiJson' in this.task ? this.task.toApiJson() : this.task;
    }
    return toReturn;
  }
}
class GetMultiHydratedTaskRequest {
  static fromProto(proto) {
    let m = new GetMultiHydratedTaskRequest();
    m = Object.assign(m, proto);
    if (proto.identities) {
      m.identities = proto.identities.map(HydratedTaskIdentity.fromProto);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = HydratedTaskProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identities !== 'undefined' && this.identities !== null) {
      toReturn['identities'] = 'toApiJson' in this.identities ? this.identities.toApiJson() : this.identities;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetMultiHydratedTaskResponse {
  static fromProto(proto) {
    let m = new GetMultiHydratedTaskResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(HydratedTask.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    return toReturn;
  }
}
class HydratedAccessPermissions {
  static fromProto(proto) {
    let m = new HydratedAccessPermissions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.read !== 'undefined') {
      toReturn['read'] = this.read;
    }
    if (typeof this.write !== 'undefined') {
      toReturn['write'] = this.write;
    }
    if (typeof this.delete !== 'undefined') {
      toReturn['delete'] = this.delete;
    }
    return toReturn;
  }
}
class HydratedAttachment {
  static fromProto(proto) {
    let m = new HydratedAttachment();
    m = Object.assign(m, proto);
    if (proto.filePermissions) {
      m.filePermissions = HydratedAccessPermissions.fromProto(proto.filePermissions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.uploadingPersonaType !== 'undefined') {
      toReturn['uploadingPersonaType'] = this.uploadingPersonaType;
    }
    if (typeof this.filePermissions !== 'undefined' && this.filePermissions !== null) {
      toReturn['filePermissions'] = 'toApiJson' in this.filePermissions ? this.filePermissions.toApiJson() : this.filePermissions;
    }
    return toReturn;
  }
}
class HydratedGroupedMetadata {
  static fromProto(proto) {
    let m = new HydratedGroupedMetadata();
    m = Object.assign(m, proto);
    if (proto.metadataGroup) {
      m.metadataGroup = proto.metadataGroup.map(HydratedKeyValues.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metadataGroup !== 'undefined' && this.metadataGroup !== null) {
      toReturn['metadataGroup'] = 'toApiJson' in this.metadataGroup ? this.metadataGroup.toApiJson() : this.metadataGroup;
    }
    return toReturn;
  }
}
class HydratedGroupedTags {
  static fromProto(proto) {
    let m = new HydratedGroupedTags();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(HydratedTagGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class HydratedKeyValue {
  static fromProto(proto) {
    let m = new HydratedKeyValue();
    m = Object.assign(m, proto);
    if (proto.values) {
      m.values = proto.values.map(HydratedValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    return toReturn;
  }
}
class HydratedKeyValues {
  static fromProto(proto) {
    let m = new HydratedKeyValues();
    m = Object.assign(m, proto);
    if (proto.keyValues) {
      m.keyValues = proto.keyValues.map(HydratedKeyValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyValues !== 'undefined' && this.keyValues !== null) {
      toReturn['keyValues'] = 'toApiJson' in this.keyValues ? this.keyValues.toApiJson() : this.keyValues;
    }
    return toReturn;
  }
}
class HydratedSort {
  static fromProto(proto) {
    let m = new HydratedSort();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$6(HydratedSortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class HydratedTagGroup {
  static fromProto(proto) {
    let m = new HydratedTagGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class HydratedTask {
  static fromProto(proto) {
    let m = new HydratedTask();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = HydratedTaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.history) {
      m.history = proto.history.map(HydratedTaskHistory.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.completionDate) {
      m.completionDate = new Date(proto.completionDate);
    }
    if (proto.subtasks) {
      m.subtasks = proto.subtasks.map(HydratedTaskIdentity.fromProto);
    }
    if (proto.data) {
      m.data = HydratedKeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = HydratedKeyValues.fromProto(proto.metadata);
    }
    if (proto.conversations) {
      m.conversations = proto.conversations.map(HydratedTaskConversation.fromProto);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.attachment) {
      m.attachment = proto.attachment.map(HydratedAttachment.fromProto);
    }
    if (proto.accountData) {
      m.accountData = AccountData.fromProto(proto.accountData);
    }
    if (proto.partnerData) {
      m.partnerData = PartnerData.fromProto(proto.partnerData);
    }
    if (proto.marketData) {
      m.marketData = MarketData.fromProto(proto.marketData);
    }
    if (proto.accountSalespersonData) {
      m.accountSalespersonData = AccountSalespersonData.fromProto(proto.accountSalespersonData);
    }
    if (proto.parentData) {
      m.parentData = ParentData.fromProto(proto.parentData);
    }
    if (proto.projectStatusData) {
      m.projectStatusData = ProjectStatusData.fromProto(proto.projectStatusData);
    }
    if (proto.projectCommentsCountData) {
      m.projectCommentsCountData = ProjectCommentsCountData.fromProto(proto.projectCommentsCountData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.history !== 'undefined' && this.history !== null) {
      toReturn['history'] = 'toApiJson' in this.history ? this.history.toApiJson() : this.history;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.completionDate !== 'undefined' && this.completionDate !== null) {
      toReturn['completionDate'] = 'toApiJson' in this.completionDate ? this.completionDate.toApiJson() : this.completionDate;
    }
    if (typeof this.subtasks !== 'undefined' && this.subtasks !== null) {
      toReturn['subtasks'] = 'toApiJson' in this.subtasks ? this.subtasks.toApiJson() : this.subtasks;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.accountData !== 'undefined' && this.accountData !== null) {
      toReturn['accountData'] = 'toApiJson' in this.accountData ? this.accountData.toApiJson() : this.accountData;
    }
    if (typeof this.partnerData !== 'undefined' && this.partnerData !== null) {
      toReturn['partnerData'] = 'toApiJson' in this.partnerData ? this.partnerData.toApiJson() : this.partnerData;
    }
    if (typeof this.marketData !== 'undefined' && this.marketData !== null) {
      toReturn['marketData'] = 'toApiJson' in this.marketData ? this.marketData.toApiJson() : this.marketData;
    }
    if (typeof this.accountSalespersonData !== 'undefined' && this.accountSalespersonData !== null) {
      toReturn['accountSalespersonData'] = 'toApiJson' in this.accountSalespersonData ? this.accountSalespersonData.toApiJson() : this.accountSalespersonData;
    }
    if (typeof this.parentData !== 'undefined' && this.parentData !== null) {
      toReturn['parentData'] = 'toApiJson' in this.parentData ? this.parentData.toApiJson() : this.parentData;
    }
    if (typeof this.projectStatusData !== 'undefined' && this.projectStatusData !== null) {
      toReturn['projectStatusData'] = 'toApiJson' in this.projectStatusData ? this.projectStatusData.toApiJson() : this.projectStatusData;
    }
    if (typeof this.projectCommentsCountData !== 'undefined' && this.projectCommentsCountData !== null) {
      toReturn['projectCommentsCountData'] = 'toApiJson' in this.projectCommentsCountData ? this.projectCommentsCountData.toApiJson() : this.projectCommentsCountData;
    }
    return toReturn;
  }
}
class HydratedTaskConversation {
  static fromProto(proto) {
    let m = new HydratedTaskConversation();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.persona) {
      m.persona = enumStringToValue$6(HydratedConversationPersonaType, proto.persona);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sendFrom !== 'undefined') {
      toReturn['sendFrom'] = this.sendFrom;
    }
    if (typeof this.sendTo !== 'undefined') {
      toReturn['sendTo'] = this.sendTo;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.persona !== 'undefined') {
      toReturn['persona'] = this.persona;
    }
    return toReturn;
  }
}
class HydratedTaskHistory {
  static fromProto(proto) {
    let m = new HydratedTaskHistory();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class HydratedTaskIdentity {
  static fromProto(proto) {
    let m = new HydratedTaskIdentity();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPath !== 'undefined') {
      toReturn['parentPath'] = this.parentPath;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    return toReturn;
  }
}
class HydratedTaskProjectionFilter {
  static fromProto(proto) {
    let m = new HydratedTaskProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeHistory !== 'undefined') {
      toReturn['includeHistory'] = this.includeHistory;
    }
    if (typeof this.includeConversations !== 'undefined') {
      toReturn['includeConversations'] = this.includeConversations;
    }
    if (typeof this.includeAccountData !== 'undefined') {
      toReturn['includeAccountData'] = this.includeAccountData;
    }
    if (typeof this.includePartnerData !== 'undefined') {
      toReturn['includePartnerData'] = this.includePartnerData;
    }
    if (typeof this.includeMarketData !== 'undefined') {
      toReturn['includeMarketData'] = this.includeMarketData;
    }
    if (typeof this.includeAccountSalespersonData !== 'undefined') {
      toReturn['includeAccountSalespersonData'] = this.includeAccountSalespersonData;
    }
    if (typeof this.includeParentData !== 'undefined') {
      toReturn['includeParentData'] = this.includeParentData;
    }
    if (typeof this.includeProjectStatusData !== 'undefined') {
      toReturn['includeProjectStatusData'] = this.includeProjectStatusData;
    }
    if (typeof this.includeProjectCommentsCountData !== 'undefined') {
      toReturn['includeProjectCommentsCountData'] = this.includeProjectCommentsCountData;
    }
    return toReturn;
  }
}
class HydratedValue {
  static fromProto(proto) {
    let m = new HydratedValue();
    m = Object.assign(m, proto);
    if (proto.int64Value) {
      m.int64Value = parseInt(proto.int64Value, 10);
    }
    if (proto.timeValue) {
      m.timeValue = new Date(proto.timeValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.int64Value !== 'undefined') {
      toReturn['int64Value'] = this.int64Value;
    }
    if (typeof this.boolValue !== 'undefined') {
      toReturn['boolValue'] = this.boolValue;
    }
    if (typeof this.doubleValue !== 'undefined') {
      toReturn['doubleValue'] = this.doubleValue;
    }
    if (typeof this.timeValue !== 'undefined' && this.timeValue !== null) {
      toReturn['timeValue'] = 'toApiJson' in this.timeValue ? this.timeValue.toApiJson() : this.timeValue;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class MarketData {
  static fromProto(proto) {
    let m = new MarketData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ParentData {
  static fromProto(proto) {
    let m = new ParentData();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = HydratedTaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.parentTitle !== 'undefined') {
      toReturn['parentTitle'] = this.parentTitle;
    }
    return toReturn;
  }
}
class PartnerData {
  static fromProto(proto) {
    let m = new PartnerData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ProjectCommentsCountData {
  static fromProto(proto) {
    let m = new ProjectCommentsCountData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalComments !== 'undefined') {
      toReturn['totalComments'] = this.totalComments;
    }
    return toReturn;
  }
}
class ProjectStatusData {
  static fromProto(proto) {
    let m = new ProjectStatusData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.completedSubtaskCount !== 'undefined') {
      toReturn['completedSubtaskCount'] = this.completedSubtaskCount;
    }
    if (typeof this.totalSubtaskCount !== 'undefined') {
      toReturn['totalSubtaskCount'] = this.totalSubtaskCount;
    }
    if (typeof this.hasOverdueSubtasks !== 'undefined') {
      toReturn['hasOverdueSubtasks'] = this.hasOverdueSubtasks;
    }
    return toReturn;
  }
}
class SearchHydratedTaskRequest {
  static fromProto(proto) {
    let m = new SearchHydratedTaskRequest();
    m = Object.assign(m, proto);
    if (proto.rangeStart) {
      m.rangeStart = new Date(proto.rangeStart);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = new Date(proto.rangeEnd);
    }
    if (proto.metadata) {
      m.metadata = HydratedKeyValues.fromProto(proto.metadata);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.dateRangeField) {
      m.dateRangeField = enumStringToValue$6(HydratedRangeField, proto.dateRangeField);
    }
    if (proto.sorts) {
      m.sorts = proto.sorts.map(HydratedSort.fromProto);
    }
    if (proto.tagGroups) {
      m.tagGroups = HydratedGroupedTags.fromProto(proto.tagGroups);
    }
    if (proto.metadataGroups) {
      m.metadataGroups = HydratedGroupedMetadata.fromProto(proto.metadataGroups);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = HydratedTaskProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPathFuzzy !== 'undefined') {
      toReturn['parentPathFuzzy'] = this.parentPathFuzzy;
    }
    if (typeof this.parentPathExact !== 'undefined') {
      toReturn['parentPathExact'] = this.parentPathExact;
    }
    if (typeof this.titleFuzzy !== 'undefined') {
      toReturn['titleFuzzy'] = this.titleFuzzy;
    }
    if (typeof this.titleExact !== 'undefined') {
      toReturn['titleExact'] = this.titleExact;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.rangeStart !== 'undefined' && this.rangeStart !== null) {
      toReturn['rangeStart'] = 'toApiJson' in this.rangeStart ? this.rangeStart.toApiJson() : this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined' && this.rangeEnd !== null) {
      toReturn['rangeEnd'] = 'toApiJson' in this.rangeEnd ? this.rangeEnd.toApiJson() : this.rangeEnd;
    }
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.dateRangeField !== 'undefined') {
      toReturn['dateRangeField'] = this.dateRangeField;
    }
    if (typeof this.access !== 'undefined') {
      toReturn['access'] = this.access;
    }
    if (typeof this.sorts !== 'undefined' && this.sorts !== null) {
      toReturn['sorts'] = 'toApiJson' in this.sorts ? this.sorts.toApiJson() : this.sorts;
    }
    if (typeof this.excludeHistory !== 'undefined') {
      toReturn['excludeHistory'] = this.excludeHistory;
    }
    if (typeof this.deletedOnly !== 'undefined') {
      toReturn['deletedOnly'] = this.deletedOnly;
    }
    if (typeof this.tagGroups !== 'undefined' && this.tagGroups !== null) {
      toReturn['tagGroups'] = 'toApiJson' in this.tagGroups ? this.tagGroups.toApiJson() : this.tagGroups;
    }
    if (typeof this.metadataGroups !== 'undefined' && this.metadataGroups !== null) {
      toReturn['metadataGroups'] = 'toApiJson' in this.metadataGroups ? this.metadataGroups.toApiJson() : this.metadataGroups;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class SearchHydratedTaskResponse {
  static fromProto(proto) {
    let m = new SearchHydratedTaskResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(HydratedTask.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CanUserAccessVendorPartnerRequest {
  static fromProto(proto) {
    let m = new CanUserAccessVendorPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.vendorPartnerId !== 'undefined') {
      toReturn['vendorPartnerId'] = this.vendorPartnerId;
    }
    return toReturn;
  }
}
class CanUserAccessVendorPartnerResponse {
  static fromProto(proto) {
    let m = new CanUserAccessVendorPartnerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canAccess !== 'undefined') {
      toReturn['canAccess'] = this.canAccess;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateRecurringTaskRequest {
  static fromProto(proto) {
    let m = new CreateRecurringTaskRequest();
    m = Object.assign(m, proto);
    if (proto.recurringTask) {
      m.recurringTask = RecurringTask.fromProto(proto.recurringTask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTask !== 'undefined' && this.recurringTask !== null) {
      toReturn['recurringTask'] = 'toApiJson' in this.recurringTask ? this.recurringTask.toApiJson() : this.recurringTask;
    }
    return toReturn;
  }
}
class CreateRecurringTaskResponse {
  static fromProto(proto) {
    let m = new CreateRecurringTaskResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    return toReturn;
  }
}
class DeleteRecurringTaskRequest {
  static fromProto(proto) {
    let m = new DeleteRecurringTaskRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetRecurringTaskRequest {
  static fromProto(proto) {
    let m = new GetRecurringTaskRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = RecurringTaskProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetRecurringTaskResponse {
  static fromProto(proto) {
    let m = new GetRecurringTaskResponse();
    m = Object.assign(m, proto);
    if (proto.recurringTask) {
      m.recurringTask = RecurringTask.fromProto(proto.recurringTask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTask !== 'undefined' && this.recurringTask !== null) {
      toReturn['recurringTask'] = 'toApiJson' in this.recurringTask ? this.recurringTask.toApiJson() : this.recurringTask;
    }
    return toReturn;
  }
}
class MonthlyRecurringOptions {
  static fromProto(proto) {
    let m = new MonthlyRecurringOptions();
    m = Object.assign(m, proto);
    if (proto.dayOfMonth) {
      m.dayOfMonth = parseInt(proto.dayOfMonth, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dayOfMonth !== 'undefined') {
      toReturn['dayOfMonth'] = this.dayOfMonth;
    }
    if (typeof this.isLastDayOfMonth !== 'undefined') {
      toReturn['isLastDayOfMonth'] = this.isLastDayOfMonth;
    }
    return toReturn;
  }
}
class RecurringTask {
  static fromProto(proto) {
    let m = new RecurringTask();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$4(RecurringTaskTypes, proto.type);
    }
    if (proto.initialCreationDate) {
      m.initialCreationDate = new Date(proto.initialCreationDate);
    }
    if (proto.nextCreationDate) {
      m.nextCreationDate = new Date(proto.nextCreationDate);
    }
    if (proto.nextDueDate) {
      m.nextDueDate = new Date(proto.nextDueDate);
    }
    if (proto.daysToComplete) {
      m.daysToComplete = parseInt(proto.daysToComplete, 10);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$4(RecurringTaskFrequencies, proto.frequency);
    }
    if (proto.frequencyOffset) {
      m.frequencyOffset = parseInt(proto.frequencyOffset, 10);
    }
    if (proto.weeklyOptions) {
      m.weeklyOptions = WeeklyRecurringOptions.fromProto(proto.weeklyOptions);
    }
    if (proto.monthlyOptions) {
      m.monthlyOptions = MonthlyRecurringOptions.fromProto(proto.monthlyOptions);
    }
    if (proto.yearlyOptions) {
      m.yearlyOptions = YearlyRecurringOptions.fromProto(proto.yearlyOptions);
    }
    if (proto.expires) {
      m.expires = enumStringToValue$4(RecurringTaskExpires, proto.expires);
    }
    if (proto.occurrences) {
      m.occurrences = parseInt(proto.occurrences, 10);
    }
    if (proto.expiryDate) {
      m.expiryDate = new Date(proto.expiryDate);
    }
    if (proto.templateInfo) {
      m.templateInfo = TemplateInfo.fromProto(proto.templateInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.initialCreationDate !== 'undefined' && this.initialCreationDate !== null) {
      toReturn['initialCreationDate'] = 'toApiJson' in this.initialCreationDate ? this.initialCreationDate.toApiJson() : this.initialCreationDate;
    }
    if (typeof this.nextCreationDate !== 'undefined' && this.nextCreationDate !== null) {
      toReturn['nextCreationDate'] = 'toApiJson' in this.nextCreationDate ? this.nextCreationDate.toApiJson() : this.nextCreationDate;
    }
    if (typeof this.nextDueDate !== 'undefined' && this.nextDueDate !== null) {
      toReturn['nextDueDate'] = 'toApiJson' in this.nextDueDate ? this.nextDueDate.toApiJson() : this.nextDueDate;
    }
    if (typeof this.daysToComplete !== 'undefined') {
      toReturn['daysToComplete'] = this.daysToComplete;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.publicNote !== 'undefined') {
      toReturn['publicNote'] = this.publicNote;
    }
    if (typeof this.privateNote !== 'undefined') {
      toReturn['privateNote'] = this.privateNote;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.frequencyOffset !== 'undefined') {
      toReturn['frequencyOffset'] = this.frequencyOffset;
    }
    if (typeof this.weeklyOptions !== 'undefined' && this.weeklyOptions !== null) {
      toReturn['weeklyOptions'] = 'toApiJson' in this.weeklyOptions ? this.weeklyOptions.toApiJson() : this.weeklyOptions;
    }
    if (typeof this.monthlyOptions !== 'undefined' && this.monthlyOptions !== null) {
      toReturn['monthlyOptions'] = 'toApiJson' in this.monthlyOptions ? this.monthlyOptions.toApiJson() : this.monthlyOptions;
    }
    if (typeof this.yearlyOptions !== 'undefined' && this.yearlyOptions !== null) {
      toReturn['yearlyOptions'] = 'toApiJson' in this.yearlyOptions ? this.yearlyOptions.toApiJson() : this.yearlyOptions;
    }
    if (typeof this.expires !== 'undefined') {
      toReturn['expires'] = this.expires;
    }
    if (typeof this.occurrences !== 'undefined') {
      toReturn['occurrences'] = this.occurrences;
    }
    if (typeof this.expiryDate !== 'undefined' && this.expiryDate !== null) {
      toReturn['expiryDate'] = 'toApiJson' in this.expiryDate ? this.expiryDate.toApiJson() : this.expiryDate;
    }
    if (typeof this.templateInfo !== 'undefined' && this.templateInfo !== null) {
      toReturn['templateInfo'] = 'toApiJson' in this.templateInfo ? this.templateInfo.toApiJson() : this.templateInfo;
    }
    return toReturn;
  }
}
class RecurringTaskProjectionFilter {
  static fromProto(proto) {
    let m = new RecurringTaskProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeTemplateOwnerId !== 'undefined') {
      toReturn['includeTemplateOwnerId'] = this.includeTemplateOwnerId;
    }
    if (typeof this.includeFullTemplate !== 'undefined') {
      toReturn['includeFullTemplate'] = this.includeFullTemplate;
    }
    return toReturn;
  }
}
class SearchRecurringTaskRequest {
  static fromProto(proto) {
    let m = new SearchRecurringTaskRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = RecurringTaskProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class SearchRecurringTaskResponse {
  static fromProto(proto) {
    let m = new SearchRecurringTaskResponse();
    m = Object.assign(m, proto);
    if (proto.recurringTasks) {
      m.recurringTasks = proto.recurringTasks.map(RecurringTask.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTasks !== 'undefined' && this.recurringTasks !== null) {
      toReturn['recurringTasks'] = 'toApiJson' in this.recurringTasks ? this.recurringTasks.toApiJson() : this.recurringTasks;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class TemplateInfo {
  static fromProto(proto) {
    let m = new TemplateInfo();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateOwnerId !== 'undefined') {
      toReturn['templateOwnerId'] = this.templateOwnerId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class UpdateRecurringTaskRequest {
  static fromProto(proto) {
    let m = new UpdateRecurringTaskRequest();
    m = Object.assign(m, proto);
    if (proto.recurringTask) {
      m.recurringTask = RecurringTask.fromProto(proto.recurringTask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTask !== 'undefined' && this.recurringTask !== null) {
      toReturn['recurringTask'] = 'toApiJson' in this.recurringTask ? this.recurringTask.toApiJson() : this.recurringTask;
    }
    return toReturn;
  }
}
class UpdateRecurringTaskResponse {
  static fromProto(proto) {
    let m = new UpdateRecurringTaskResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringTaskId !== 'undefined') {
      toReturn['recurringTaskId'] = this.recurringTaskId;
    }
    return toReturn;
  }
}
class WeeklyRecurringOptions {
  static fromProto(proto) {
    let m = new WeeklyRecurringOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onSunday !== 'undefined') {
      toReturn['onSunday'] = this.onSunday;
    }
    if (typeof this.onMonday !== 'undefined') {
      toReturn['onMonday'] = this.onMonday;
    }
    if (typeof this.onTuesday !== 'undefined') {
      toReturn['onTuesday'] = this.onTuesday;
    }
    if (typeof this.onWednesday !== 'undefined') {
      toReturn['onWednesday'] = this.onWednesday;
    }
    if (typeof this.onThursday !== 'undefined') {
      toReturn['onThursday'] = this.onThursday;
    }
    if (typeof this.onFriday !== 'undefined') {
      toReturn['onFriday'] = this.onFriday;
    }
    if (typeof this.onSaturday !== 'undefined') {
      toReturn['onSaturday'] = this.onSaturday;
    }
    return toReturn;
  }
}
class YearlyRecurringOptions {
  static fromProto(proto) {
    let m = new YearlyRecurringOptions();
    m = Object.assign(m, proto);
    if (proto.dayOfYear) {
      m.dayOfYear = new Date(proto.dayOfYear);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dayOfYear !== 'undefined' && this.dayOfYear !== null) {
      toReturn['dayOfYear'] = 'toApiJson' in this.dayOfYear ? this.dayOfYear.toApiJson() : this.dayOfYear;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddSocialPostSubtaskRequest {
  static fromProto(proto) {
    let m = new AddSocialPostSubtaskRequest();
    m = Object.assign(m, proto);
    if (proto.posts) {
      m.posts = proto.posts.map(Post.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.parentTaskId !== 'undefined') {
      toReturn['parentTaskId'] = this.parentTaskId;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    return toReturn;
  }
}
class Post {
  static fromProto(proto) {
    let m = new Post();
    m = Object.assign(m, proto);
    if (proto.scheduledDateTime) {
      m.scheduledDateTime = new Date(proto.scheduledDateTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.ssid !== 'undefined') {
      toReturn['ssid'] = this.ssid;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.socialPostId !== 'undefined') {
      toReturn['socialPostId'] = this.socialPostId;
    }
    if (typeof this.scheduledDateTime !== 'undefined' && this.scheduledDateTime !== null) {
      toReturn['scheduledDateTime'] = 'toApiJson' in this.scheduledDateTime ? this.scheduledDateTime.toApiJson() : this.scheduledDateTime;
    }
    if (typeof this.imageUrls !== 'undefined') {
      toReturn['imageUrls'] = this.imageUrls;
    }
    return toReturn;
  }
}
class SendCalendarForClientFeedbackExternalRequest {
  static fromProto(proto) {
    let m = new SendCalendarForClientFeedbackExternalRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.parentTaskId !== 'undefined') {
      toReturn['parentTaskId'] = this.parentTaskId;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.socialCalendarReportUrl !== 'undefined') {
      toReturn['socialCalendarReportUrl'] = this.socialCalendarReportUrl;
    }
    if (typeof this.emailMessage !== 'undefined') {
      toReturn['emailMessage'] = this.emailMessage;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class AuxiliaryDataFieldSchema {
  static fromProto(proto) {
    let m = new AuxiliaryDataFieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$2(AuxiliaryDataFieldType, proto.fieldType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class AuxiliaryDataObjectID {
  static fromProto(proto) {
    let m = new AuxiliaryDataObjectID();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.objectId !== 'undefined') {
      toReturn['objectId'] = this.objectId;
    }
    return toReturn;
  }
}
class CreateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldDataUpsertOperation {
  static fromProto(proto) {
    let m = new FieldDataUpsertOperation();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.currencyValue) {
      m.currencyValue = parseInt(proto.currencyValue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldDataId !== 'undefined') {
      toReturn['fieldDataId'] = this.fieldDataId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dropdownValue !== 'undefined') {
      toReturn['dropdownValue'] = this.dropdownValue;
    }
    if (typeof this.currencyValue !== 'undefined') {
      toReturn['currencyValue'] = this.currencyValue;
    }
    if (typeof this.deleteValue !== 'undefined') {
      toReturn['deleteValue'] = this.deleteValue;
    }
    return toReturn;
  }
}
class FieldSchemaIdentifier {
  static fromProto(proto) {
    let m = new FieldSchemaIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(FieldSchemaIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListAuxiliaryDataFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class UpdateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new UpsertAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.fieldDataUpsertOperations) {
      m.fieldDataUpsertOperations = proto.fieldDataUpsertOperations.map(FieldDataUpsertOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldDataUpsertOperations !== 'undefined' && this.fieldDataUpsertOperations !== null) {
      toReturn['fieldDataUpsertOperations'] = 'toApiJson' in this.fieldDataUpsertOperations ? this.fieldDataUpsertOperations.toApiJson() : this.fieldDataUpsertOperations;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountChangedRequest {
  static fromProto(proto) {
    let m = new AccountChangedRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.fieldChanged !== 'undefined') {
      toReturn['fieldChanged'] = this.fieldChanged;
    }
    if (typeof this.newValue !== 'undefined') {
      toReturn['newValue'] = this.newValue;
    }
    return toReturn;
  }
}
class Activity {
  static fromProto(proto) {
    let m = new Activity();
    m = Object.assign(m, proto);
    if (proto.activityType) {
      m.activityType = enumStringToValue$1(ActivityTypes, proto.activityType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.dateHappened) {
      m.dateHappened = new Date(proto.dateHappened);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activityType !== 'undefined') {
      toReturn['activityType'] = this.activityType;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.creatorUserId !== 'undefined') {
      toReturn['creatorUserId'] = this.creatorUserId;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.dateHappenedKey !== 'undefined') {
      toReturn['dateHappenedKey'] = this.dateHappenedKey;
    }
    if (typeof this.dateHappened !== 'undefined' && this.dateHappened !== null) {
      toReturn['dateHappened'] = 'toApiJson' in this.dateHappened ? this.dateHappened.toApiJson() : this.dateHappened;
    }
    if (typeof this.activityId !== 'undefined') {
      toReturn['activityId'] = this.activityId;
    }
    if (typeof this.receivers !== 'undefined') {
      toReturn['receivers'] = this.receivers;
    }
    return toReturn;
  }
}
class AddCommentRequest {
  static fromProto(proto) {
    let m = new AddCommentRequest();
    m = Object.assign(m, proto);
    if (proto.taskIdentity) {
      m.taskIdentity = TaskIdentity.fromProto(proto.taskIdentity);
    }
    if (proto.commentType) {
      m.commentType = enumStringToValue$1(CommentType, proto.commentType);
    }
    if (proto.location) {
      m.location = enumStringToValue$1(PlatformLocation, proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskIdentity !== 'undefined' && this.taskIdentity !== null) {
      toReturn['taskIdentity'] = 'toApiJson' in this.taskIdentity ? this.taskIdentity.toApiJson() : this.taskIdentity;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.commentType !== 'undefined') {
      toReturn['commentType'] = this.commentType;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class AddConversationWithNotificationRequest {
  static fromProto(proto) {
    let m = new AddConversationWithNotificationRequest();
    m = Object.assign(m, proto);
    if (proto.addConversationRequest) {
      m.addConversationRequest = AddConversationRequest.fromProto(proto.addConversationRequest);
    }
    if (proto.conversationType) {
      m.conversationType = enumStringToValue$1(ConversationTypes, proto.conversationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addConversationRequest !== 'undefined' && this.addConversationRequest !== null) {
      toReturn['addConversationRequest'] = 'toApiJson' in this.addConversationRequest ? this.addConversationRequest.toApiJson() : this.addConversationRequest;
    }
    if (typeof this.conversationType !== 'undefined') {
      toReturn['conversationType'] = this.conversationType;
    }
    return toReturn;
  }
}
class AskQuestionRequest {
  static fromProto(proto) {
    let m = new AskQuestionRequest();
    m = Object.assign(m, proto);
    if (proto.persona) {
      m.persona = enumStringToValue$1(PersonaType, proto.persona);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.question !== 'undefined') {
      toReturn['question'] = this.question;
    }
    if (typeof this.askerUserId !== 'undefined') {
      toReturn['askerUserId'] = this.askerUserId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.persona !== 'undefined') {
      toReturn['persona'] = this.persona;
    }
    return toReturn;
  }
}
class Comment {
  static fromProto(proto) {
    let m = new Comment();
    m = Object.assign(m, proto);
    if (proto.messageCreated) {
      m.messageCreated = new Date(proto.messageCreated);
    }
    if (proto.commentType) {
      m.commentType = enumStringToValue$1(CommentType, proto.commentType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderName !== 'undefined') {
      toReturn['senderName'] = this.senderName;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.messageType !== 'undefined') {
      toReturn['messageType'] = this.messageType;
    }
    if (typeof this.messageText !== 'undefined') {
      toReturn['messageText'] = this.messageText;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.messageCreated !== 'undefined' && this.messageCreated !== null) {
      toReturn['messageCreated'] = 'toApiJson' in this.messageCreated ? this.messageCreated.toApiJson() : this.messageCreated;
    }
    if (typeof this.externalMessageId !== 'undefined') {
      toReturn['externalMessageId'] = this.externalMessageId;
    }
    if (typeof this.commentType !== 'undefined') {
      toReturn['commentType'] = this.commentType;
    }
    if (typeof this.senderImageUrl !== 'undefined') {
      toReturn['senderImageUrl'] = this.senderImageUrl;
    }
    return toReturn;
  }
}
class CommentProjectionFilter {
  static fromProto(proto) {
    let m = new CommentProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.retrieveSubtasks !== 'undefined') {
      toReturn['retrieveSubtasks'] = this.retrieveSubtasks;
    }
    if (typeof this.retrievePrivate !== 'undefined') {
      toReturn['retrievePrivate'] = this.retrievePrivate;
    }
    return toReturn;
  }
}
class CreateActivityRequest {
  static fromProto(proto) {
    let m = new CreateActivityRequest();
    m = Object.assign(m, proto);
    if (proto.activity) {
      m.activity = Activity.fromProto(proto.activity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activity !== 'undefined' && this.activity !== null) {
      toReturn['activity'] = 'toApiJson' in this.activity ? this.activity.toApiJson() : this.activity;
    }
    return toReturn;
  }
}
class CreateActivityResponse {
  static fromProto(proto) {
    let m = new CreateActivityResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activityId !== 'undefined') {
      toReturn['activityId'] = this.activityId;
    }
    return toReturn;
  }
}
class CreateMultiProjectFromTemplateRequest {
  static fromProto(proto) {
    let m = new CreateMultiProjectFromTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.createReq) {
      m.createReq = proto.createReq.map(CreateProjectFromTemplateRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.createReq !== 'undefined' && this.createReq !== null) {
      toReturn['createReq'] = 'toApiJson' in this.createReq ? this.createReq.toApiJson() : this.createReq;
    }
    return toReturn;
  }
}
class CreateProjectFromTemplateRequest {
  static fromProto(proto) {
    let m = new CreateProjectFromTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.parentIds !== 'undefined') {
      toReturn['parentIds'] = this.parentIds;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.triggeredByRecurringTask !== 'undefined') {
      toReturn['triggeredByRecurringTask'] = this.triggeredByRecurringTask;
    }
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.fulfillmentOrderId !== 'undefined') {
      toReturn['fulfillmentOrderId'] = this.fulfillmentOrderId;
    }
    return toReturn;
  }
}
class CreateProjectFromTemplateSynchronousResponse {
  static fromProto(proto) {
    let m = new CreateProjectFromTemplateSynchronousResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.projectId !== 'undefined') {
      toReturn['projectId'] = this.projectId;
    }
    return toReturn;
  }
}
class CreateTemplateFromProjectResponse {
  static fromProto(proto) {
    let m = new CreateTemplateFromProjectResponse();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class DecryptNotesRequest {
  static fromProto(proto) {
    let m = new DecryptNotesRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.encryptedNote !== 'undefined') {
      toReturn['encryptedNote'] = this.encryptedNote;
    }
    return toReturn;
  }
}
class DecryptNotesResponse {
  static fromProto(proto) {
    let m = new DecryptNotesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.decryptedNote !== 'undefined') {
      toReturn['decryptedNote'] = this.decryptedNote;
    }
    return toReturn;
  }
}
class EncryptNotesRequest {
  static fromProto(proto) {
    let m = new EncryptNotesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class EncryptNotesResponse {
  static fromProto(proto) {
    let m = new EncryptNotesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.encryptedNote !== 'undefined') {
      toReturn['encryptedNote'] = this.encryptedNote;
    }
    return toReturn;
  }
}
class GenerateFileUploadUrlRequest {
  static fromProto(proto) {
    let m = new GenerateFileUploadUrlRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    return toReturn;
  }
}
class GenerateFileUploadUrlResponse {
  static fromProto(proto) {
    let m = new GenerateFileUploadUrlResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.uploadUrl !== 'undefined') {
      toReturn['uploadUrl'] = this.uploadUrl;
    }
    if (typeof this.shareableUrl !== 'undefined') {
      toReturn['shareableUrl'] = this.shareableUrl;
    }
    return toReturn;
  }
}
class GetActivityRequest {
  static fromProto(proto) {
    let m = new GetActivityRequest();
    m = Object.assign(m, proto);
    if (proto.dateHappened) {
      m.dateHappened = new Date(proto.dateHappened);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activityId !== 'undefined') {
      toReturn['activityId'] = this.activityId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dateHappened !== 'undefined' && this.dateHappened !== null) {
      toReturn['dateHappened'] = 'toApiJson' in this.dateHappened ? this.dateHappened.toApiJson() : this.dateHappened;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetActivityResponse {
  static fromProto(proto) {
    let m = new GetActivityResponse();
    m = Object.assign(m, proto);
    if (proto.activity) {
      m.activity = Activity.fromProto(proto.activity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activity !== 'undefined' && this.activity !== null) {
      toReturn['activity'] = 'toApiJson' in this.activity ? this.activity.toApiJson() : this.activity;
    }
    return toReturn;
  }
}
class GetAttachmentUrlRequest {
  static fromProto(proto) {
    let m = new GetAttachmentUrlRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.attachmentId !== 'undefined') {
      toReturn['attachmentId'] = this.attachmentId;
    }
    return toReturn;
  }
}
class GetAttachmentUrlResponse {
  static fromProto(proto) {
    let m = new GetAttachmentUrlResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    return toReturn;
  }
}
class GetCommentCountRequest {
  static fromProto(proto) {
    let m = new GetCommentCountRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = CommentProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetCommentCountResponse {
  static fromProto(proto) {
    let m = new GetCommentCountResponse();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.comments) {
      m.comments = parseInt(proto.comments, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.comments !== 'undefined') {
      toReturn['comments'] = this.comments;
    }
    return toReturn;
  }
}
class GetFulfilledPartnersRequest {
  static fromProto(proto) {
    let m = new GetFulfilledPartnersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fulfillingPartnerId !== 'undefined') {
      toReturn['fulfillingPartnerId'] = this.fulfillingPartnerId;
    }
    return toReturn;
  }
}
class GetFulfilledPartnersResponse {
  static fromProto(proto) {
    let m = new GetFulfilledPartnersResponse();
    m = Object.assign(m, proto);
    if (proto.partnerBrands) {
      m.partnerBrands = proto.partnerBrands.map(PartnerBranding.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerBrands !== 'undefined' && this.partnerBrands !== null) {
      toReturn['partnerBrands'] = 'toApiJson' in this.partnerBrands ? this.partnerBrands.toApiJson() : this.partnerBrands;
    }
    return toReturn;
  }
}
class GetMeetingHostRequest {
  static fromProto(proto) {
    let m = new GetMeetingHostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskManagerHostId !== 'undefined') {
      toReturn['taskManagerHostId'] = this.taskManagerHostId;
    }
    return toReturn;
  }
}
class GetMeetingHostResponse {
  static fromProto(proto) {
    let m = new GetMeetingHostResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.agencyName !== 'undefined') {
      toReturn['agencyName'] = this.agencyName;
    }
    if (typeof this.displayProfileUrl !== 'undefined') {
      toReturn['displayProfileUrl'] = this.displayProfileUrl;
    }
    if (typeof this.displayLogoUrl !== 'undefined') {
      toReturn['displayLogoUrl'] = this.displayLogoUrl;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.schedulerUrl !== 'undefined') {
      toReturn['schedulerUrl'] = this.schedulerUrl;
    }
    return toReturn;
  }
}
class GetMultiCommentCountRequest {
  static fromProto(proto) {
    let m = new GetMultiCommentCountRequest();
    m = Object.assign(m, proto);
    if (proto.identities) {
      m.identities = proto.identities.map(TaskIdentity.fromProto);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = CommentProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identities !== 'undefined' && this.identities !== null) {
      toReturn['identities'] = 'toApiJson' in this.identities ? this.identities.toApiJson() : this.identities;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetMultiCommentCountResponse {
  static fromProto(proto) {
    let m = new GetMultiCommentCountResponse();
    m = Object.assign(m, proto);
    if (proto.commentCounts) {
      m.commentCounts = proto.commentCounts.map(GetCommentCountResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentCounts !== 'undefined' && this.commentCounts !== null) {
      toReturn['commentCounts'] = 'toApiJson' in this.commentCounts ? this.commentCounts.toApiJson() : this.commentCounts;
    }
    return toReturn;
  }
}
class GetProductEntryUrlRequest {
  static fromProto(proto) {
    let m = new GetProductEntryUrlRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    return toReturn;
  }
}
class GetProductEntryUrlResponse {
  static fromProto(proto) {
    let m = new GetProductEntryUrlResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    return toReturn;
  }
}
class GetSalesPersonBySubjectIDRequest {
  static fromProto(proto) {
    let m = new GetSalesPersonBySubjectIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class GetSalesPersonBySubjectIDResponse {
  static fromProto(proto) {
    let m = new GetSalesPersonBySubjectIDResponse();
    m = Object.assign(m, proto);
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.photoUrlHttps !== 'undefined') {
      toReturn['photoUrlHttps'] = this.photoUrlHttps;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    return toReturn;
  }
}
class GetTaskHistoryRequest {
  static fromProto(proto) {
    let m = new GetTaskHistoryRequest();
    m = Object.assign(m, proto);
    if (proto.taskIdentity) {
      m.taskIdentity = TaskIdentity.fromProto(proto.taskIdentity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskIdentity !== 'undefined' && this.taskIdentity !== null) {
      toReturn['taskIdentity'] = 'toApiJson' in this.taskIdentity ? this.taskIdentity.toApiJson() : this.taskIdentity;
    }
    return toReturn;
  }
}
class GetTaskHistoryResponse {
  static fromProto(proto) {
    let m = new GetTaskHistoryResponse();
    m = Object.assign(m, proto);
    if (proto.histories) {
      m.histories = proto.histories.map(TaskHistory.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.histories !== 'undefined' && this.histories !== null) {
      toReturn['histories'] = 'toApiJson' in this.histories ? this.histories.toApiJson() : this.histories;
    }
    return toReturn;
  }
}
class ListActivitiesRequest {
  static fromProto(proto) {
    let m = new ListActivitiesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListActivitiesResponse {
  static fromProto(proto) {
    let m = new ListActivitiesResponse();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(Activity.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class LoadCommentsRequest {
  static fromProto(proto) {
    let m = new LoadCommentsRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = CommentProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class LoadCommentsResponse {
  static fromProto(proto) {
    let m = new LoadCommentsResponse();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(Comment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    return toReturn;
  }
}
class NotifyReviewCommentRequest {
  static fromProto(proto) {
    let m = new NotifyReviewCommentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    if (typeof this.reviewCommentMessage !== 'undefined') {
      toReturn['reviewCommentMessage'] = this.reviewCommentMessage;
    }
    return toReturn;
  }
}
class PartnerBranding {
  static fromProto(proto) {
    let m = new PartnerBranding();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    return toReturn;
  }
}
class RespondToSocialCommentRequest {
  static fromProto(proto) {
    let m = new RespondToSocialCommentRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.socialPostId !== 'undefined') {
      toReturn['socialPostId'] = this.socialPostId;
    }
    if (typeof this.socialCommentId !== 'undefined') {
      toReturn['socialCommentId'] = this.socialCommentId;
    }
    if (typeof this.respondingUserId !== 'undefined') {
      toReturn['respondingUserId'] = this.respondingUserId;
    }
    if (typeof this.response !== 'undefined') {
      toReturn['response'] = this.response;
    }
    return toReturn;
  }
}
class RespondToSocialCommentResponse {
  static fromProto(proto) {
    let m = new RespondToSocialCommentResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialCommentId !== 'undefined') {
      toReturn['socialCommentId'] = this.socialCommentId;
    }
    return toReturn;
  }
}
class RestoreParentAndChildrenMultiRequest {
  static fromProto(proto) {
    let m = new RestoreParentAndChildrenMultiRequest();
    m = Object.assign(m, proto);
    if (proto.parentTaskIdentities) {
      m.parentTaskIdentities = proto.parentTaskIdentities.map(TaskIdentity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.parentTaskIdentities !== 'undefined' && this.parentTaskIdentities !== null) {
      toReturn['parentTaskIdentities'] = 'toApiJson' in this.parentTaskIdentities ? this.parentTaskIdentities.toApiJson() : this.parentTaskIdentities;
    }
    return toReturn;
  }
}
class SendEmailRequest {
  static fromProto(proto) {
    let m = new SendEmailRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.digitalAgentId !== 'undefined') {
      toReturn['digitalAgentId'] = this.digitalAgentId;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.recipients !== 'undefined') {
      toReturn['recipients'] = this.recipients;
    }
    if (typeof this.ccRecipients !== 'undefined') {
      toReturn['ccRecipients'] = this.ccRecipients;
    }
    if (typeof this.bccRecipients !== 'undefined') {
      toReturn['bccRecipients'] = this.bccRecipients;
    }
    return toReturn;
  }
}
class SendFeedbackRequest {
  static fromProto(proto) {
    let m = new SendFeedbackRequest();
    m = Object.assign(m, proto);
    if (proto.conversationType) {
      m.conversationType = enumStringToValue$1(ConversationTypes, proto.conversationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPath !== 'undefined') {
      toReturn['parentPath'] = this.parentPath;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.sendFrom !== 'undefined') {
      toReturn['sendFrom'] = this.sendFrom;
    }
    if (typeof this.sendTo !== 'undefined') {
      toReturn['sendTo'] = this.sendTo;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.conversationType !== 'undefined') {
      toReturn['conversationType'] = this.conversationType;
    }
    return toReturn;
  }
}
class SendNotificationRequest {
  static fromProto(proto) {
    let m = new SendNotificationRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notificationId !== 'undefined') {
      toReturn['notificationId'] = this.notificationId;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class SendNotificationResponse {
  static fromProto(proto) {
    let m = new SendNotificationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class SetMeetingTaskInfoRequest {
  static fromProto(proto) {
    let m = new SetMeetingTaskInfoRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.meetingSource) {
      m.meetingSource = parseInt(proto.meetingSource, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.meetingSource !== 'undefined') {
      toReturn['meetingSource'] = this.meetingSource;
    }
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    return toReturn;
  }
}
class TaskHistory {
  static fromProto(proto) {
    let m = new TaskHistory();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetOrderFormForProjectRequest {
  static fromProto(proto) {
    let m = new GetOrderFormForProjectRequest();
    m = Object.assign(m, proto);
    if (proto.projectIdentity) {
      m.projectIdentity = TaskIdentity.fromProto(proto.projectIdentity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.projectIdentity !== 'undefined' && this.projectIdentity !== null) {
      toReturn['projectIdentity'] = 'toApiJson' in this.projectIdentity ? this.projectIdentity.toApiJson() : this.projectIdentity;
    }
    return toReturn;
  }
}
class GetOrderFormForProjectResponse {
  static fromProto(proto) {
    let m = new GetOrderFormForProjectResponse();
    m = Object.assign(m, proto);
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(OrderFormFieldSubmission.fromProto);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(OrderFormFieldSubmission.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    return toReturn;
  }
}
class OrderFormFieldSubmission {
  static fromProto(proto) {
    let m = new OrderFormFieldSubmission();
    m = Object.assign(m, proto);
    if (proto.answerFile) {
      m.answerFile = proto.answerFile.map(OrderFormFileField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    if (typeof this.answerFile !== 'undefined' && this.answerFile !== null) {
      toReturn['answerFile'] = 'toApiJson' in this.answerFile ? this.answerFile.toApiJson() : this.answerFile;
    }
    return toReturn;
  }
}
class OrderFormFileField {
  static fromProto(proto) {
    let m = new OrderFormFileField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'task-manager-api.vendasta-local.com',
  'test': '',
  'demo': 'task-manager-api-demo.apigateway.co',
  'prod': 'task-manager-api-prod.apigateway.co',
  'production': 'task-manager-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AccountProductDetailsApiService = /*#__PURE__*/(() => {
  class AccountProductDetailsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAccountProductDetails(r) {
      const request = r.toApiJson ? r : new GetAccountProductDetailsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.AccountProductDetails/GetAccountProductDetails", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountProductDetailsResponse.fromProto(resp)));
    }
    getAccountVendorProductDetails(r) {
      const request = r.toApiJson ? r : new GetAccountVendorProductDetailsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.AccountProductDetails/GetAccountVendorProductDetails", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountProductDetailsResponse.fromProto(resp)));
    }
  }
  AccountProductDetailsApiService.ɵfac = function AccountProductDetailsApiService_Factory(t) {
    return new (t || AccountProductDetailsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountProductDetailsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountProductDetailsApiService,
    factory: AccountProductDetailsApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountProductDetailsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AccountsApiService = /*#__PURE__*/(() => {
  class AccountsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTaskAccounts(r) {
      const request = r.toApiJson ? r : new GetTaskAccountsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/GetTaskAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskAccountsResponse.fromProto(resp)));
    }
    getTaskConciergeAccount(r) {
      const request = r.toApiJson ? r : new GetTaskConciergeAccountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/GetTaskConciergeAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskConciergeAccountResponse.fromProto(resp)));
    }
    getPurchasingPartnerConciergeAccount(r) {
      const request = r.toApiJson ? r : new GetPurchasingPartnerConciergeAccountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/GetPurchasingPartnerConciergeAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPurchasingPartnerConciergeAccountResponse.fromProto(resp)));
    }
    getPurchasingPartnerAccount(r) {
      const request = r.toApiJson ? r : new GetPurchasingPartnerAccountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/GetPurchasingPartnerAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPurchasingPartnerAccountResponse.fromProto(resp)));
    }
    setAccountNote(r) {
      const request = r.toApiJson ? r : new SetAccountNoteRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/SetAccountNote", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAccountListingSourcesSettings(r) {
      const request = r.toApiJson ? r : new GetAccountListingSourcesSettingsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/GetAccountListingSourcesSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => SourceSettingsResponse.fromProto(resp)));
    }
    updateAccountListingSource(r) {
      const request = r.toApiJson ? r : new UpdateAccountListingSourceRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/UpdateAccountListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateAccountMultiListingSource(r) {
      const request = r.toApiJson ? r : new UpdateAccountMultiListingSourceRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/UpdateAccountMultiListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAccountSocialServices(r) {
      const request = r.toApiJson ? r : new ListAccountSocialServicesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/ListAccountSocialServices", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAccountSocialServicesResponse.fromProto(resp)));
    }
    listCommitmentDates(r) {
      const request = r.toApiJson ? r : new ListCommitmentDatesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/ListCommitmentDates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCommitmentDatesResponse.fromProto(resp)));
    }
    getSalesOrderFormSubmissionInfo(r) {
      const request = r.toApiJson ? r : new GetSalesOrderFormSubmissionInfoRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/GetSalesOrderFormSubmissionInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesOrderFormSubmissionInfoResponse.fromProto(resp)));
    }
    deactivateConciergeAccount(r) {
      const request = r.toApiJson ? r : new DeactivateConciergeAccountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/DeactivateConciergeAccount", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    pauseConciergeAccount(r) {
      const request = r.toApiJson ? r : new PauseConciergeAccountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/PauseConciergeAccount", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createConciergeAccount(r) {
      const request = r.toApiJson ? r : new CreateConciergeAccountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Accounts/CreateConciergeAccount", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AccountsApiService.ɵfac = function AccountsApiService_Factory(t) {
    return new (t || AccountsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountsApiService,
    factory: AccountsApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BusinessFulfillmentSettingsApiService = /*#__PURE__*/(() => {
  class BusinessFulfillmentSettingsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateBusinessFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.BusinessFulfillmentSettings/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetBusinessFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.BusinessFulfillmentSettings/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessFulfillmentSettingResponse.fromProto(resp)));
    }
    addProducts(r) {
      const request = r.toApiJson ? r : new AddProductsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.BusinessFulfillmentSettings/AddProducts", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeProducts(r) {
      const request = r.toApiJson ? r : new RemoveProductsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.BusinessFulfillmentSettings/RemoveProducts", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteBusinessFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.BusinessFulfillmentSettings/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  BusinessFulfillmentSettingsApiService.ɵfac = function BusinessFulfillmentSettingsApiService_Factory(t) {
    return new (t || BusinessFulfillmentSettingsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BusinessFulfillmentSettingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessFulfillmentSettingsApiService,
    factory: BusinessFulfillmentSettingsApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessFulfillmentSettingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CustomTagsApiService = /*#__PURE__*/(() => {
  class CustomTagsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    addCustomTag(r) {
      const request = r.toApiJson ? r : new AddCustomTagsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/AddCustomTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeCustomTag(r) {
      const request = r.toApiJson ? r : new RemoveCustomTagsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/RemoveCustomTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    getCustomTag(r) {
      const request = r.toApiJson ? r : new GetCustomTagRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/GetCustomTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCustomTagResponse.fromProto(resp)));
    }
    getMultiCustomTag(r) {
      const request = r.toApiJson ? r : new GetMultiCustomTagRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/GetMultiCustomTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCustomTagResponse.fromProto(resp)));
    }
    listCustomTags(r) {
      const request = r.toApiJson ? r : new ListCustomTagsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/ListCustomTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCustomTagsResponse.fromProto(resp)));
    }
    createCustomTag(r) {
      const request = r.toApiJson ? r : new CreateCustomTagRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/CreateCustomTag", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCustomTagResponse.fromProto(resp)));
    }
    updateCustomTag(r) {
      const request = r.toApiJson ? r : new UpdateCustomTagRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/UpdateCustomTag", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteCustomTag(r) {
      const request = r.toApiJson ? r : new DeleteCustomTagRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.CustomTags/DeleteCustomTag", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CustomTagsApiService.ɵfac = function CustomTagsApiService_Factory(t) {
    return new (t || CustomTagsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CustomTagsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomTagsApiService,
    factory: CustomTagsApiService.ɵfac,
    providedIn: 'root'
  });
  return CustomTagsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DigitalAgentsApiService = /*#__PURE__*/(() => {
  class DigitalAgentsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAssigneesForPartner(r) {
      const request = r.toApiJson ? r : new ListAssigneesForPartnerRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/ListAssigneesForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAssigneesForPartnerResponse.fromProto(resp)));
    }
    getDigitalAgentsByUserIds(r) {
      const request = r.toApiJson ? r : new GetDigitalAgentsByUserIdsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/GetDigitalAgentsByUserIds", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDigitalAgentsByUserIdsResponse.fromProto(resp)));
    }
    getDigitalAgentsBySubjectIds(r) {
      const request = r.toApiJson ? r : new GetDigitalAgentsBySubjectIdsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/GetDigitalAgentsBySubjectIds", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDigitalAgentsBySubjectIdsResponse.fromProto(resp)));
    }
    createDigitalAgent(r) {
      const request = r.toApiJson ? r : new CreateDigitalAgentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/CreateDigitalAgent", request.toApiJson(), this.apiOptions()).pipe(map(resp => DigitalAgent.fromProto(resp)));
    }
    updateDigitalAgent(r) {
      const request = r.toApiJson ? r : new UpdateDigitalAgentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/UpdateDigitalAgent", request.toApiJson(), this.apiOptions()).pipe(map(resp => DigitalAgent.fromProto(resp)));
    }
    getMultiUserInfoExternal(r) {
      const request = r.toApiJson ? r : new GetMultiUserInfoExternalRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/GetMultiUserInfoExternal", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiUserInfoExternalResponse.fromProto(resp)));
    }
    deleteUser(r) {
      const request = r.toApiJson ? r : new DeleteUserRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/DeleteUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendWelcomeEmail(r) {
      const request = r.toApiJson ? r : new SendWelcomeEmailRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.DigitalAgents/SendWelcomeEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  DigitalAgentsApiService.ɵfac = function DigitalAgentsApiService_Factory(t) {
    return new (t || DigitalAgentsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  DigitalAgentsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DigitalAgentsApiService,
    factory: DigitalAgentsApiService.ɵfac,
    providedIn: 'root'
  });
  return DigitalAgentsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let GroupApiService = /*#__PURE__*/(() => {
  class GroupApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createGroup(r) {
      const request = r.toApiJson ? r : new CreateGroupRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/CreateGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateGroupResponse.fromProto(resp)));
    }
    addGroupMembers(r) {
      const request = r.toApiJson ? r : new AddGroupMembersRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/AddGroupMembers", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeGroupMembers(r) {
      const request = r.toApiJson ? r : new RemoveGroupMembersRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/RemoveGroupMembers", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listGroupMembers(r) {
      const request = r.toApiJson ? r : new ListGroupMembersRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/ListGroupMembers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGroupMembersResponse.fromProto(resp)));
    }
    listGroup(r) {
      const request = r.toApiJson ? r : new ListGroupRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/ListGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGroupResponse.fromProto(resp)));
    }
    updateGroupName(r) {
      const request = r.toApiJson ? r : new UpdateGroupNameRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/UpdateGroupName", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteGroup(r) {
      const request = r.toApiJson ? r : new DeleteGroupRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/DeleteGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listGroupsByMembers(r) {
      const request = r.toApiJson ? r : new ListGroupsByMembersRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/ListGroupsByMembers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGroupsByMembersResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GroupGetMultiRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Group/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GroupGetMultiResponse.fromProto(resp)));
    }
  }
  GroupApiService.ɵfac = function GroupApiService_Factory(t) {
    return new (t || GroupApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  GroupApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GroupApiService,
    factory: GroupApiService.ɵfac,
    providedIn: 'root'
  });
  return GroupApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MetricsApiService = /*#__PURE__*/(() => {
  class MetricsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getProjectSubtaskCount(r) {
      const request = r.toApiJson ? r : new ProjectSubtaskCountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Metrics/GetProjectSubtaskCount", request.toApiJson(), this.apiOptions()).pipe(map(resp => ProjectSubtaskCountResponse.fromProto(resp)));
    }
    exportProjects(r) {
      const request = r.toApiJson ? r : new ExportProjectsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Metrics/ExportProjects", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  MetricsApiService.ɵfac = function MetricsApiService_Factory(t) {
    return new (t || MetricsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MetricsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MetricsApiService,
    factory: MetricsApiService.ɵfac,
    providedIn: 'root'
  });
  return MetricsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let OrderFormApiService = /*#__PURE__*/(() => {
  class OrderFormApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getOrderFormForProject(r) {
      const request = r.toApiJson ? r : new GetOrderFormForProjectRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.OrderForm/GetOrderFormForProject", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOrderFormForProjectResponse.fromProto(resp)));
    }
  }
  OrderFormApiService.ɵfac = function OrderFormApiService_Factory(t) {
    return new (t || OrderFormApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  OrderFormApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OrderFormApiService,
    factory: OrderFormApiService.ɵfac,
    providedIn: 'root'
  });
  return OrderFormApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProductFulfillmentApiService = /*#__PURE__*/(() => {
  class ProductFulfillmentApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listVndaProducts(r) {
      const request = r.toApiJson ? r : new ListProductsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillment/ListVNDAProducts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListProductsResponse.fromProto(resp)));
    }
  }
  ProductFulfillmentApiService.ɵfac = function ProductFulfillmentApiService_Factory(t) {
    return new (t || ProductFulfillmentApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ProductFulfillmentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProductFulfillmentApiService,
    factory: ProductFulfillmentApiService.ɵfac,
    providedIn: 'root'
  });
  return ProductFulfillmentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProductFulfillmentSettingsApiService = /*#__PURE__*/(() => {
  class ProductFulfillmentSettingsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateProductFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillmentSettings/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiProductFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillmentSettings/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiProductFulfillmentSettingResponse.fromProto(resp)));
    }
    lookup(r) {
      const request = r.toApiJson ? r : new LookupProductFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillmentSettings/Lookup", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupProductFulfillmentSettingResponse.fromProto(resp)));
    }
    setFulfillingPartner(r) {
      const request = r.toApiJson ? r : new SetFulfillingPartnerRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillmentSettings/SetFulfillingPartner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteProductFulfillmentSettingRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillmentSettings/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setTemplate(r) {
      const request = r.toApiJson ? r : new SetTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.ProductFulfillmentSettings/SetTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ProductFulfillmentSettingsApiService.ɵfac = function ProductFulfillmentSettingsApiService_Factory(t) {
    return new (t || ProductFulfillmentSettingsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ProductFulfillmentSettingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProductFulfillmentSettingsApiService,
    factory: ProductFulfillmentSettingsApiService.ɵfac,
    providedIn: 'root'
  });
  return ProductFulfillmentSettingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecurringTasksApiService = /*#__PURE__*/(() => {
  class RecurringTasksApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateRecurringTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.RecurringTasks/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateRecurringTaskResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetRecurringTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.RecurringTasks/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRecurringTaskResponse.fromProto(resp)));
    }
    search(r) {
      const request = r.toApiJson ? r : new SearchRecurringTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.RecurringTasks/Search", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchRecurringTaskResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateRecurringTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.RecurringTasks/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateRecurringTaskResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteRecurringTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.RecurringTasks/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  RecurringTasksApiService.ɵfac = function RecurringTasksApiService_Factory(t) {
    return new (t || RecurringTasksApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  RecurringTasksApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecurringTasksApiService,
    factory: RecurringTasksApiService.ɵfac,
    providedIn: 'root'
  });
  return RecurringTasksApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SocialCalendarApiService = /*#__PURE__*/(() => {
  class SocialCalendarApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendCalendarForClientFeedbackExternal(r) {
      const request = r.toApiJson ? r : new SendCalendarForClientFeedbackExternalRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.SocialCalendar/SendCalendarForClientFeedbackExternal", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addSocialPostSubtask(r) {
      const request = r.toApiJson ? r : new AddSocialPostSubtaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.SocialCalendar/AddSocialPostSubtask", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SocialCalendarApiService.ɵfac = function SocialCalendarApiService_Factory(t) {
    return new (t || SocialCalendarApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SocialCalendarApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialCalendarApiService,
    factory: SocialCalendarApiService.ɵfac,
    providedIn: 'root'
  });
  return SocialCalendarApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TaskAuxiliaryFieldDataApiService = /*#__PURE__*/(() => {
  class TaskAuxiliaryFieldDataApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAuxiliaryData(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldData/ListAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataResponse.fromProto(resp)));
    }
    upsertAuxiliaryData(r) {
      const request = r.toApiJson ? r : new UpsertAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldData/UpsertAuxiliaryData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TaskAuxiliaryFieldDataApiService.ɵfac = function TaskAuxiliaryFieldDataApiService_Factory(t) {
    return new (t || TaskAuxiliaryFieldDataApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskAuxiliaryFieldDataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskAuxiliaryFieldDataApiService,
    factory: TaskAuxiliaryFieldDataApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskAuxiliaryFieldDataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TaskAuxiliaryFieldSchemaApiService = /*#__PURE__*/(() => {
  class TaskAuxiliaryFieldSchemaApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new CreateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/CreateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/GetAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    getMultiAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetMultiAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/GetMultiAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    listAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/ListAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    updateAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UpdateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/UpdateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ArchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/ArchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UnarchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskAuxiliaryFieldSchema/UnarchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TaskAuxiliaryFieldSchemaApiService.ɵfac = function TaskAuxiliaryFieldSchemaApiService_Factory(t) {
    return new (t || TaskAuxiliaryFieldSchemaApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskAuxiliaryFieldSchemaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskAuxiliaryFieldSchemaApiService,
    factory: TaskAuxiliaryFieldSchemaApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskAuxiliaryFieldSchemaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TaskManagerApiService = /*#__PURE__*/(() => {
  class TaskManagerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createProjectFromTemplate(r) {
      const request = r.toApiJson ? r : new CreateProjectFromTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/CreateProjectFromTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    createProjectFromTemplateSynchronous(r) {
      const request = r.toApiJson ? r : new CreateProjectFromTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/CreateProjectFromTemplateSynchronous", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateProjectFromTemplateSynchronousResponse.fromProto(resp)));
    }
    createTemplateFromProject(r) {
      const request = r.toApiJson ? r : new TaskIdentity(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/CreateTemplateFromProject", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTemplateFromProjectResponse.fromProto(resp)));
    }
    createMultiProjectFromTemplate(r) {
      const request = r.toApiJson ? r : new CreateMultiProjectFromTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/CreateMultiProjectFromTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    sendNotification(r) {
      const request = r.toApiJson ? r : new SendNotificationRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SendNotification", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendNotificationResponse.fromProto(resp)));
    }
    createActivity(r) {
      const request = r.toApiJson ? r : new CreateActivityRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/CreateActivity", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateActivityResponse.fromProto(resp)));
    }
    getActivity(r) {
      const request = r.toApiJson ? r : new GetActivityRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetActivity", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetActivityResponse.fromProto(resp)));
    }
    listActivities(r) {
      const request = r.toApiJson ? r : new ListActivitiesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/ListActivities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivitiesResponse.fromProto(resp)));
    }
    sendAccountChangedEvent(r) {
      const request = r.toApiJson ? r : new AccountChangedRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SendAccountChangedEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setMeetingTaskInfo(r) {
      const request = r.toApiJson ? r : new SetMeetingTaskInfoRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetMeetingTaskInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    notifyReviewComment(r) {
      const request = r.toApiJson ? r : new NotifyReviewCommentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/NotifyReviewComment", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMeetingHost(r) {
      const request = r.toApiJson ? r : new GetMeetingHostRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetMeetingHost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMeetingHostResponse.fromProto(resp)));
    }
    askQuestion(r) {
      const request = r.toApiJson ? r : new AskQuestionRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AskQuestion", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendFeedback(r) {
      const request = r.toApiJson ? r : new SendFeedbackRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SendFeedback", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addConversation(r) {
      const request = r.toApiJson ? r : new AddConversationWithNotificationRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    getTaskHistory(r) {
      const request = r.toApiJson ? r : new GetTaskHistoryRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetTaskHistory", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskHistoryResponse.fromProto(resp)));
    }
    getFulfilledPartners(r) {
      const request = r.toApiJson ? r : new GetFulfilledPartnersRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetFulfilledPartners", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFulfilledPartnersResponse.fromProto(resp)));
    }
    generate(r) {
      const request = r.toApiJson ? r : new GenerateTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/Generate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    deleteTask(r) {
      const request = r.toApiJson ? r : new DeleteTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/DeleteTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    deleteTaskMulti(r) {
      const request = r.toApiJson ? r : new DeleteMultiTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/DeleteTaskMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setStatus(r) {
      const request = r.toApiJson ? r : new SetStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setMultiStatus(r) {
      const request = r.toApiJson ? r : new SetMultiStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetMultiStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setStatusMulti(r) {
      const request = r.toApiJson ? r : new SetMultiStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetStatusMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setNotes(r) {
      const request = r.toApiJson ? r : new SetNotesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetNotes", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setNotesMulti(r) {
      const request = r.toApiJson ? r : new SetMultiNotesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetNotesMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setTitle(r) {
      const request = r.toApiJson ? r : new SetTitleRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetTitle", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setDescription(r) {
      const request = r.toApiJson ? r : new SetDescriptionRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetDescription", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setData(r) {
      const request = r.toApiJson ? r : new SetKeyValuesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetData", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setMetadata(r) {
      const request = r.toApiJson ? r : new SetKeyValuesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setDueDate(r) {
      const request = r.toApiJson ? r : new SetDueDateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetDueDate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setDueDateMulti(r) {
      const request = r.toApiJson ? r : new SetMultiDueDateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SetDueDateMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    removeAssignee(r) {
      const request = r.toApiJson ? r : new RemoveAssigneeRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RemoveAssignee", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeAssigneeMulti(r) {
      const request = r.toApiJson ? r : new RemoveMultiAssigneeRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RemoveAssigneeMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    addAssignee(r) {
      const request = r.toApiJson ? r : new AddAssigneeRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddAssignee", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addAssigneeMulti(r) {
      const request = r.toApiJson ? r : new AddMultiAssigneeRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddAssigneeMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    getTask(r) {
      const request = r.toApiJson ? r : new GetTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskResponse.fromProto(resp)));
    }
    getTaskMulti(r) {
      const request = r.toApiJson ? r : new GetTasksRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetTaskMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTasksResponse.fromProto(resp)));
    }
    addSubtask(r) {
      const request = r.toApiJson ? r : new AddSubtaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddSubtask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addSubtaskMulti(r) {
      const request = r.toApiJson ? r : new AddMultipleSubtasksRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddSubtaskMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    restoreTask(r) {
      const request = r.toApiJson ? r : new RestoreTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RestoreTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    restoreTaskMulti(r) {
      const request = r.toApiJson ? r : new RestoreMultiTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RestoreTaskMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    restoreParentAndChildrenMulti(r) {
      const request = r.toApiJson ? r : new RestoreParentAndChildrenMultiRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RestoreParentAndChildrenMulti", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addTags(r) {
      const request = r.toApiJson ? r : new AddTagsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeTags(r) {
      const request = r.toApiJson ? r : new RemoveTagsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RemoveTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    generateFileUploadUrl(r) {
      const request = r.toApiJson ? r : new GenerateFileUploadUrlRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GenerateFileUploadUrl", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateFileUploadUrlResponse.fromProto(resp)));
    }
    addAttachment(r) {
      const request = r.toApiJson ? r : new AddAttachmentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddAttachment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeAttachment(r) {
      const request = r.toApiJson ? r : new RemoveAttachmentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RemoveAttachment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    getAttachmentUrl(r) {
      const request = r.toApiJson ? r : new GetAttachmentUrlRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetAttachmentUrl", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAttachmentUrlResponse.fromProto(resp)));
    }
    reorderSubtask(r) {
      const request = r.toApiJson ? r : new ReorderSubtaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/ReorderSubtask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addHistory(r) {
      const request = r.toApiJson ? r : new AddHistoryRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddHistory", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    search(r) {
      const request = r.toApiJson ? r : new SearchTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/Search", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchTaskResponse.fromProto(resp)));
    }
    encryptNotes(r) {
      const request = r.toApiJson ? r : new EncryptNotesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/EncryptNotes", request.toApiJson(), this.apiOptions()).pipe(map(resp => EncryptNotesResponse.fromProto(resp)));
    }
    decryptNotes(r) {
      const request = r.toApiJson ? r : new DecryptNotesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/DecryptNotes", request.toApiJson(), this.apiOptions()).pipe(map(resp => DecryptNotesResponse.fromProto(resp)));
    }
    sendEmail(r) {
      const request = r.toApiJson ? r : new SendEmailRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SendEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getProductEntryUrl(r) {
      const request = r.toApiJson ? r : new GetProductEntryUrlRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetProductEntryUrl", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProductEntryUrlResponse.fromProto(resp)));
    }
    getSalesPersonBySubjectId(r) {
      const request = r.toApiJson ? r : new GetSalesPersonBySubjectIDRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetSalesPersonBySubjectID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesPersonBySubjectIDResponse.fromProto(resp)));
    }
    fuzzyTaskSearch(r) {
      const request = r.toApiJson ? r : new FuzzyTaskSearchRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/FuzzyTaskSearch", request.toApiJson(), this.apiOptions()).pipe(map(resp => FuzzyTaskSearchResponse.fromProto(resp)));
    }
    getHydratedTask(r) {
      const request = r.toApiJson ? r : new GetHydratedTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetHydratedTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHydratedTaskResponse.fromProto(resp)));
    }
    getMultiHydratedTask(r) {
      const request = r.toApiJson ? r : new GetMultiHydratedTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetMultiHydratedTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiHydratedTaskResponse.fromProto(resp)));
    }
    searchHydratedTasks(r) {
      const request = r.toApiJson ? r : new SearchHydratedTaskRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/SearchHydratedTasks", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchHydratedTaskResponse.fromProto(resp)));
    }
    fuzzySearchHydratedTasks(r) {
      const request = r.toApiJson ? r : new FuzzySearchHydratedTasksRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/FuzzySearchHydratedTasks", request.toApiJson(), this.apiOptions()).pipe(map(resp => FuzzySearchHydratedTasksResponse.fromProto(resp)));
    }
    addComment(r) {
      const request = r.toApiJson ? r : new AddCommentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/AddComment", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    loadComments(r) {
      const request = r.toApiJson ? r : new LoadCommentsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/LoadComments", request.toApiJson(), this.apiOptions()).pipe(map(resp => LoadCommentsResponse.fromProto(resp)));
    }
    getCommentCount(r) {
      const request = r.toApiJson ? r : new GetCommentCountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetCommentCount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCommentCountResponse.fromProto(resp)));
    }
    getMultiCommentCount(r) {
      const request = r.toApiJson ? r : new GetMultiCommentCountRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/GetMultiCommentCount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCommentCountResponse.fromProto(resp)));
    }
    respondToSocialComment(r) {
      const request = r.toApiJson ? r : new RespondToSocialCommentRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManager/RespondToSocialComment", request.toApiJson(), this.apiOptions()).pipe(map(resp => RespondToSocialCommentResponse.fromProto(resp)));
    }
  }
  TaskManagerApiService.ɵfac = function TaskManagerApiService_Factory(t) {
    return new (t || TaskManagerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskManagerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskManagerApiService,
    factory: TaskManagerApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskManagerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TaskManagerAuthApiService = /*#__PURE__*/(() => {
  class TaskManagerAuthApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    canUserAccessVendorPartner(r) {
      const request = r.toApiJson ? r : new CanUserAccessVendorPartnerRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskManagerAuth/CanUserAccessVendorPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanUserAccessVendorPartnerResponse.fromProto(resp)));
    }
  }
  TaskManagerAuthApiService.ɵfac = function TaskManagerAuthApiService_Factory(t) {
    return new (t || TaskManagerAuthApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskManagerAuthApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskManagerAuthApiService,
    factory: TaskManagerAuthApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskManagerAuthApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TaskStatusesApiService = /*#__PURE__*/(() => {
  class TaskStatusesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTaskStatus(r) {
      const request = r.toApiJson ? r : new GetTaskStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskStatuses/GetTaskStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskStatusResponse.fromProto(resp)));
    }
    listTaskStatuses(r) {
      const request = r.toApiJson ? r : new ListTaskStatusesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskStatuses/ListTaskStatuses", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTaskStatusesResponse.fromProto(resp)));
    }
    createTaskStatus(r) {
      const request = r.toApiJson ? r : new CreateTaskStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskStatuses/CreateTaskStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTaskStatusResponse.fromProto(resp)));
    }
    updateTaskStatus(r) {
      const request = r.toApiJson ? r : new UpdateTaskStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskStatuses/UpdateTaskStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteTaskStatus(r) {
      const request = r.toApiJson ? r : new DeleteTaskStatusRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.TaskStatuses/DeleteTaskStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TaskStatusesApiService.ɵfac = function TaskStatusesApiService_Factory(t) {
    return new (t || TaskStatusesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskStatusesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskStatusesApiService,
    factory: TaskStatusesApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskStatusesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TemplatesApiService = /*#__PURE__*/(() => {
  class TemplatesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTemplate(r) {
      const request = r.toApiJson ? r : new GetTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Templates/GetTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTemplateResponse.fromProto(resp)));
    }
    listTemplates(r) {
      const request = r.toApiJson ? r : new ListTemplatesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Templates/ListTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTemplatesResponse.fromProto(resp)));
    }
    createTemplate(r) {
      const request = r.toApiJson ? r : new CreateTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Templates/CreateTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    updateTemplate(r) {
      const request = r.toApiJson ? r : new UpdateTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Templates/UpdateTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    deleteTemplate(r) {
      const request = r.toApiJson ? r : new DeleteTemplateRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Templates/DeleteTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
  }
  TemplatesApiService.ɵfac = function TemplatesApiService_Factory(t) {
    return new (t || TemplatesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TemplatesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesApiService,
    factory: TemplatesApiService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VendorApiService = /*#__PURE__*/(() => {
  class VendorApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listActivities(r) {
      const request = r.toApiJson ? r : new ListActivitiesRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Vendor/ListActivities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivitiesResponse.fromProto(resp)));
    }
    listAccounts(r) {
      const request = r.toApiJson ? r : new ListAccountsRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Vendor/ListAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAccountsResponse.fromProto(resp)));
    }
    getOwnedAppIDsByPartnerId(r) {
      const request = r.toApiJson ? r : new GetOwnedAppIDsByPartnerIDRequest(r);
      return this.http.post(this._host + "/taskmanager.v1.Vendor/GetOwnedAppIDsByPartnerID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOwnedAppIDsByPartnerIDResponse.fromProto(resp)));
    }
  }
  VendorApiService.ɵfac = function VendorApiService_Factory(t) {
    return new (t || VendorApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  VendorApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorApiService,
    factory: VendorApiService.ɵfac,
    providedIn: 'root'
  });
  return VendorApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let TaskManagerSdkService = /*#__PURE__*/(() => {
  class TaskManagerSdkService {
    constructor(taskManagerApiService) {
      this.taskManagerApiService = taskManagerApiService;
    }
    createProjectFromTemplate(partnerId, accountGroupId, templateId, idempotencyKey, fulfillingPartnerId, fulfillmentOrderId) {
      const request = new CreateProjectFromTemplateRequest({
        partnerId: partnerId,
        accountId: accountGroupId,
        templateId: templateId,
        idempotencyKey: idempotencyKey,
        fulfillingPartnerId: fulfillingPartnerId,
        fulfillmentOrderId: fulfillmentOrderId
      });
      return this.taskManagerApiService.createProjectFromTemplate(request).pipe(map(res => res.version));
    }
    createMultiProjectFromTemplate(requests) {
      const multiReq = new CreateMultiProjectFromTemplateRequest({
        createReq: requests
      });
      return this.taskManagerApiService.createMultiProjectFromTemplate(multiReq);
    }
    generate(request) {
      return this.taskManagerApiService.generate(request);
    }
    setStatus(namespace, parentPath, taskId, newStatus, newVersion) {
      const identity = {
        namespace,
        parentPath,
        taskId
      };
      const request = new SetStatusRequest({
        status: newStatus,
        identity: identity,
        version: newVersion
      });
      return this.taskManagerApiService.setStatus(request).pipe(map(res => res.version));
    }
    sendNotification(namespace, parentPath, taskId, notificationId, version) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new SendNotificationRequest({
        identity: identity,
        notificationId: notificationId,
        version: version
      });
      return this.taskManagerApiService.sendNotification(request);
    }
    setMultipleStatus(requests) {
      const multiReq = new SetMultiStatusRequest({
        statusRequests: requests
      });
      return this.taskManagerApiService.setMultiStatus(multiReq);
    }
    /**
     * Set notes the notes of a task. This is a clobber operation, the value passed in for notes will be the new value
     * @param namespace: namespace of a task
     * @param parentPath: the parent task ids separated by the task delimiter
     * @param taskId: id of the task
     * @param notes: new note value
     * @param version: current version of the task
     */
    setNotes(namespace, parentPath, taskId, notes, version) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new SetNotesRequest({
        identity,
        notes,
        version
      });
      return this.taskManagerApiService.setNotes(request).pipe(map(resp => resp.version));
    }
    createActivity(activityType, partnerId, accountGroupId, content, taskId, receivers) {
      const request = new CreateActivityRequest({
        activity: new Activity({
          activityType: activityType,
          partnerId: partnerId,
          accountGroupId: accountGroupId,
          content: content,
          taskId: taskId,
          dateHappened: new Date(),
          receivers: receivers
        })
      });
      return this.taskManagerApiService.createActivity(request);
    }
    getActivity(partnerId, accountGroupId, dateHappened, activityId) {
      const request = new GetActivityRequest({
        activityId: activityId,
        partnerId: partnerId,
        accountGroupId: accountGroupId,
        dateHappened: dateHappened
      });
      return this.taskManagerApiService.getActivity(request);
    }
    listActivities(partnerId, accountGroupId, cursor, pageSize) {
      const request = new ListActivitiesRequest({
        partnerId: partnerId,
        accountGroupId: accountGroupId,
        pagingOptions: new PagedRequestOptions({
          cursor: cursor,
          pageSize: pageSize
        })
      });
      return this.taskManagerApiService.listActivities(request);
    }
    deleteTask(namespace, parentPath, taskId, version) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new DeleteTaskRequest({
        version,
        identity
      });
      return this.taskManagerApiService.deleteTask(request).pipe(map(resp => resp.version));
    }
    sendAccountChangedEvent(partnerId, accountGroupId, fieldChanged, newValue) {
      const request = new AccountChangedRequest({
        partnerId,
        accountGroupId,
        fieldChanged,
        newValue
      });
      return this.taskManagerApiService.sendAccountChangedEvent(request);
    }
    notifyReviewComment(reviewId, reviewCommentMessage) {
      const request = new NotifyReviewCommentRequest({
        reviewId,
        reviewCommentMessage
      });
      return this.taskManagerApiService.notifyReviewComment(request);
    }
    setMeetingTaskInfo(request) {
      return this.taskManagerApiService.setMeetingTaskInfo(request).pipe(map(resp => resp.version));
    }
    getMeetingHost(hostId) {
      const request = new GetMeetingHostRequest({
        taskManagerHostId: hostId
      });
      return this.taskManagerApiService.getMeetingHost(request);
    }
    askQuestion(r) {
      const request = new AskQuestionRequest(r);
      return this.taskManagerApiService.askQuestion(request);
    }
    sendFeedback(identity, message, sendFrom, sendTo, source, conversationType) {
      const request = new SendFeedbackRequest({
        namespace: identity.namespace,
        parentPath: identity.parentPath,
        taskId: identity.taskId,
        message: message,
        sendFrom: sendFrom,
        sendTo: sendTo,
        source: source,
        conversationType: conversationType
      });
      return this.taskManagerApiService.sendFeedback(request);
    }
    addConversation(conversationType, addConversationReq) {
      const request = new AddConversationWithNotificationRequest({
        conversationType: conversationType,
        addConversationRequest: new AddConversationRequest(addConversationReq)
      });
      return this.taskManagerApiService.addConversation(request).pipe(map(resp => resp.version));
    }
    getTaskHistory(identity) {
      const request = new GetTaskHistoryRequest({
        taskIdentity: identity
      });
      return this.taskManagerApiService.getTaskHistory(request);
    }
    deleteTaskMulti(r) {
      return this.taskManagerApiService.deleteTaskMulti(r);
    }
    setStatusMulti(r) {
      return this.taskManagerApiService.setStatusMulti(r);
    }
    setNotesMulti(r) {
      return this.taskManagerApiService.setNotesMulti(r);
    }
    setTitle(r) {
      return this.taskManagerApiService.setTitle(r).pipe(map(response => response.version));
    }
    setDescription(r) {
      return this.taskManagerApiService.setDescription(r).pipe(map(response => response.version));
    }
    setData(r) {
      return this.taskManagerApiService.setData(r).pipe(map(response => response.version));
    }
    setMetadata(r) {
      return this.taskManagerApiService.setMetadata(r).pipe(map(response => response.version));
    }
    setDueDate(r) {
      return this.taskManagerApiService.setDueDate(r).pipe(map(response => response.version));
    }
    setDueDateMulti(r) {
      return this.taskManagerApiService.setDueDateMulti(r);
    }
    removeAssignee(r) {
      return this.taskManagerApiService.removeAssignee(r).pipe(map(response => response.version));
    }
    removeAssigneeMulti(r) {
      return this.taskManagerApiService.removeAssigneeMulti(r);
    }
    addAssignee(r) {
      return this.taskManagerApiService.addAssignee(r).pipe(map(response => response.version));
    }
    addAssigneeMulti(r) {
      return this.taskManagerApiService.addAssigneeMulti(r);
    }
    getTask(r) {
      return this.taskManagerApiService.getTask(r).pipe(map(response => response.task));
    }
    getTaskMulti(r) {
      return this.taskManagerApiService.getTaskMulti(r).pipe(map(response => response.tasks));
    }
    addSubtask(r) {
      return this.taskManagerApiService.addSubtask(r).pipe(map(response => response.version));
    }
    addSubtaskMulti(r) {
      return this.taskManagerApiService.addSubtaskMulti(r).pipe(map(response => response.version));
    }
    restoreTask(r) {
      return this.taskManagerApiService.restoreTask(r).pipe(map(response => response.version));
    }
    restoreTaskMulti(r) {
      return this.taskManagerApiService.restoreTaskMulti(r);
    }
    addTags(r) {
      return this.taskManagerApiService.addTags(r).pipe(map(response => response.version));
    }
    removeTags(r) {
      return this.taskManagerApiService.removeTags(r).pipe(map(response => response.version));
    }
    /**
     * Generate a file upload url for a task. This is where the file you are trying to upload ultimately ends up.
     * @param taskIdentity - identity of the task you are uploading a file to
     * @param fileName - name of the file you are uploading
     * @param contentType - mime type of the file
     */
    generateFileUploadUrl(taskIdentity, fileName, contentType) {
      const r = new GenerateFileUploadUrlRequest({
        identity: taskIdentity,
        filename: fileName,
        contentType: contentType
      });
      return this.taskManagerApiService.generateFileUploadUrl(r).pipe(map(response => {
        return [response.uploadUrl, response.shareableUrl];
      }));
    }
    addAttachment(r) {
      return this.taskManagerApiService.addAttachment(r).pipe(map(response => response.version));
    }
    getAttachmentUrl(taskIdentity, attachmentId) {
      return this.taskManagerApiService.getAttachmentUrl(new GetAttachmentUrlRequest({
        identity: taskIdentity,
        attachmentId: attachmentId
      }));
    }
    removeAttachment(r) {
      return this.taskManagerApiService.removeAttachment(r).pipe(map(response => response.version));
    }
    reorderSubtask(r) {
      return this.taskManagerApiService.reorderSubtask(r).pipe(map(response => response.version));
    }
    addHistory(r) {
      return this.taskManagerApiService.addHistory(r).pipe(map(response => response.version));
    }
    search(r) {
      return this.taskManagerApiService.search(r);
    }
    getFulfilledPartners(fulfillingPartnerId) {
      return this.taskManagerApiService.getFulfilledPartners(new GetFulfilledPartnersRequest({
        fulfillingPartnerId: fulfillingPartnerId
      })).pipe(map(response => response.partnerBrands));
    }
    sendEmail(r) {
      return this.taskManagerApiService.sendEmail(r);
    }
    encryptNotes(r) {
      return this.taskManagerApiService.encryptNotes(r).pipe(map(response => response.encryptedNote));
    }
    decryptNotes(r) {
      return this.taskManagerApiService.decryptNotes(r).pipe(map(response => response.decryptedNote));
    }
    createTemplateFromProject(r) {
      return this.taskManagerApiService.createTemplateFromProject(r);
    }
    getProductEntryUrl(r) {
      return this.taskManagerApiService.getProductEntryUrl(new GetProductEntryUrlRequest(r));
    }
    getSalespersonBySubjectId(r) {
      return this.taskManagerApiService.getSalesPersonBySubjectId(new GetSalesPersonBySubjectIDRequest(r));
    }
    fuzzyTaskSearch(r) {
      return this.taskManagerApiService.fuzzyTaskSearch(new FuzzyTaskSearchRequest(r));
    }
    getHydratedTask(r) {
      return this.taskManagerApiService.getHydratedTask(r);
    }
    getMultiHydratedTask(r) {
      return this.taskManagerApiService.getMultiHydratedTask(r);
    }
    searchHydratedTasks(r) {
      return this.taskManagerApiService.searchHydratedTasks(r);
    }
    fuzzySearchHydratedTasks(r) {
      return this.taskManagerApiService.fuzzySearchHydratedTasks(r);
    }
    // AddComment uses the new conversation service to support platform wide communication.
    // This should be used in place of AddConversation where possible
    addComment(r) {
      return this.taskManagerApiService.addComment(new AddCommentRequest(r));
    }
    loadComments(r) {
      return this.taskManagerApiService.loadComments(new LoadCommentsRequest(r));
    }
    getCommentCount(r) {
      return this.taskManagerApiService.getCommentCount(new GetCommentCountRequest(r));
    }
    getMultiCommentCount(r) {
      return this.taskManagerApiService.getMultiCommentCount(new GetMultiCommentCountRequest(r));
    }
    restoreParentAndChildrenMulti(r) {
      return this.taskManagerApiService.restoreParentAndChildrenMulti(new RestoreParentAndChildrenMultiRequest(r));
    }
    respondToSocialComment(r) {
      return this.taskManagerApiService.respondToSocialComment(r).pipe(map(response => response.socialCommentId));
    }
  }
  TaskManagerSdkService.ɵfac = function TaskManagerSdkService_Factory(t) {
    return new (t || TaskManagerSdkService)(i0.ɵɵinject(TaskManagerApiService));
  };
  TaskManagerSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskManagerSdkService,
    factory: TaskManagerSdkService.ɵfac,
    providedIn: 'root'
  });
  return TaskManagerSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Persona = /*#__PURE__*/function (Persona) {
  Persona["salesPerson"] = "sales_person";
  Persona["digitalAgent"] = "digital_agent";
  return Persona;
}(Persona || {});
var GoType = /*#__PURE__*/function (GoType) {
  GoType["STRING"] = "string";
  GoType["INT"] = "int64";
  GoType["FLOAT"] = "float64";
  GoType["BOOL"] = "bool";
  GoType["TIME"] = "time";
  return GoType;
}(GoType || {});
/**
 * Enum of the standard Task statuses. No longer enforced as the only allowable statuses
 */
var Status = /*#__PURE__*/function (Status) {
  Status["Open"] = "Open";
  Status["InProgress"] = "In Progress";
  Status["WaitingOnCustomer"] = "Waiting on Customer";
  Status["Completed"] = "Completed";
  return Status;
}(Status || {});
var KeyValueTypes = /*#__PURE__*/function (KeyValueTypes) {
  KeyValueTypes["INT64"] = "int64";
  KeyValueTypes["DOUBLE"] = "double";
  KeyValueTypes["BOOL"] = "bool";
  KeyValueTypes["STRING"] = "string";
  KeyValueTypes["TIME"] = "time";
  return KeyValueTypes;
}(KeyValueTypes || {});
let GroupSdkService = /*#__PURE__*/(() => {
  class GroupSdkService {
    constructor(groupApiService) {
      this.groupApiService = groupApiService;
    }
    createGroup(partnerId, name, pathNodes, membertype, namespace) {
      return this.groupApiService.createGroup({
        partnerId,
        name,
        pathNodes,
        membertype,
        namespace
      });
    }
    addGroupMembers(pathNodes, members) {
      return this.groupApiService.addGroupMembers({
        pathNodes,
        members
      });
    }
    removeGroupMembers(pathNodes, members) {
      return this.groupApiService.removeGroupMembers({
        pathNodes,
        members
      });
    }
    listGroupMembers(partnerId, pathNodes, cursor, pageSize) {
      return this.groupApiService.listGroupMembers({
        partnerId: partnerId,
        pathNodes: pathNodes,
        pagingOptions: {
          cursor,
          pageSize
        }
      });
    }
    listGroup(partnerId, pathNodes, memberType, namespace, cursor, pageSize) {
      return this.groupApiService.listGroup({
        pathNodes: pathNodes,
        partnerId: partnerId,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        },
        namespace: namespace,
        memberType: memberType
      });
    }
    updateGroupName(pathNodes, name) {
      return this.groupApiService.updateGroupName({
        pathNodes,
        name
      });
    }
    deleteGroup(pathNodes) {
      return this.groupApiService.deleteGroup({
        pathNodes
      });
    }
    listGroupsByMembers(partnerId, members) {
      return this.groupApiService.listGroupsByMembers({
        partnerId: partnerId,
        members: members
      });
    }
    getMulti(partnerId, paths) {
      return this.groupApiService.getMulti({
        partnerId,
        paths
      });
    }
  }
  GroupSdkService.ɵfac = function GroupSdkService_Factory(t) {
    return new (t || GroupSdkService)(i0.ɵɵinject(GroupApiService));
  };
  GroupSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GroupSdkService,
    factory: GroupSdkService.ɵfac,
    providedIn: 'root'
  });
  return GroupSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TaskStatusesSdkService = /*#__PURE__*/(() => {
  class TaskStatusesSdkService {
    constructor(statusApiService) {
      this.statusApiService = statusApiService;
    }
    getTaskStatus(partnerId, statusId) {
      return this.statusApiService.getTaskStatus({
        partnerId: partnerId,
        statusId: statusId
      }).pipe(map(response => response.status));
    }
    listTaskStatuses(partnerId, cursor, pageSize) {
      return this.statusApiService.listTaskStatuses({
        partnerId: partnerId,
        cursor: cursor,
        pageSize: pageSize
      });
    }
    createTaskStatus(partnerId, name, textColour, backgroundColour) {
      const status = {
        partnerId: partnerId,
        name: name,
        textColour: textColour,
        backgroundColour: backgroundColour
      };
      return this.statusApiService.createTaskStatus({
        status: status
      }).pipe(map(response => response.statusId));
    }
    updateTaskStatus(partnerId, statusId, textColour, backgroundColour) {
      return this.statusApiService.updateTaskStatus({
        partnerId: partnerId,
        statusId: statusId,
        backgroundColour: backgroundColour,
        textColour: textColour
      });
    }
    deleteTaskStatus(partnerId, statusId) {
      return this.statusApiService.deleteTaskStatus({
        partnerId: partnerId,
        statusId: statusId
      });
    }
  }
  TaskStatusesSdkService.ɵfac = function TaskStatusesSdkService_Factory(t) {
    return new (t || TaskStatusesSdkService)(i0.ɵɵinject(TaskStatusesApiService));
  };
  TaskStatusesSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskStatusesSdkService,
    factory: TaskStatusesSdkService.ɵfac,
    providedIn: 'root'
  });
  return TaskStatusesSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TaskMetricsSdkService = /*#__PURE__*/(() => {
  class TaskMetricsSdkService {
    constructor(metricsApiService) {
      this.metricsApiService = metricsApiService;
    }
    exportProjects(exportType, filters, columns) {
      const request = new ExportProjectsRequest({
        exportType: exportType,
        filters: filters,
        columns: columns
      });
      return this.metricsApiService.exportProjects(request);
    }
  }
  TaskMetricsSdkService.ɵfac = function TaskMetricsSdkService_Factory(t) {
    return new (t || TaskMetricsSdkService)(i0.ɵɵinject(MetricsApiService));
  };
  TaskMetricsSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskMetricsSdkService,
    factory: TaskMetricsSdkService.ɵfac,
    providedIn: 'root'
  });
  return TaskMetricsSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccountsSdkService = /*#__PURE__*/(() => {
  class AccountsSdkService {
    constructor(accountsApiService) {
      this.accountsApiService = accountsApiService;
    }
    getAccountForTask(identity, fieldMask) {
      const defaultFieldMask = {
        paths: []
      };
      const request = new GetTaskAccountsRequest({
        identities: [identity],
        fieldMask: fieldMask ? fieldMask : defaultFieldMask
      });
      return this.accountsApiService.getTaskAccounts(request).pipe(map(response => response.accounts[0]));
    }
    getAccountsForTasks(identities, fieldMask) {
      const defaultFieldMask = {
        paths: []
      };
      const request = new GetTaskAccountsRequest({
        identities: identities,
        fieldMask: fieldMask ? fieldMask : defaultFieldMask
      });
      return this.accountsApiService.getTaskAccounts(request).pipe(map(response => response.accounts));
    }
    getConciergeAccountForTask(identity) {
      return this.accountsApiService.getTaskConciergeAccount(new GetTaskConciergeAccountRequest({
        identity: identity
      })).pipe(map(response => response.conciergeAccount));
    }
    getPurchasingPartnerConciergeAccount(purchasingPartnerId, accountGroupId) {
      return this.accountsApiService.getPurchasingPartnerConciergeAccount(new GetPurchasingPartnerConciergeAccountRequest({
        purchasingPartnerId: purchasingPartnerId,
        accountGroupId: accountGroupId
      })).pipe(map(resp => resp.conciergeAccount));
    }
    getPurchasingPartnerAccount(purchasingPartnerId, accountGroupId, fieldMask) {
      const defaultFieldMask = {
        paths: []
      };
      return this.accountsApiService.getPurchasingPartnerAccount(new GetPurchasingPartnerAccountRequest({
        purchasingPartnerId: purchasingPartnerId,
        accountGroupId: accountGroupId,
        fieldMask: fieldMask ? fieldMask : defaultFieldMask
      })).pipe(map(resp => resp.accountGroup));
    }
    setAccountNote(r) {
      return this.accountsApiService.setAccountNote(r);
    }
    getAccountListingSourcesSettings(request) {
      return this.accountsApiService.getAccountListingSourcesSettings(request).pipe(map(resp => resp.sourceSettings));
    }
    updateAccountListingSource(request) {
      return this.accountsApiService.updateAccountListingSource(request);
    }
    updateAccountMultiListingSource(request) {
      return this.accountsApiService.updateAccountMultiListingSource(request);
    }
    listAccountSocialServices(r) {
      return this.accountsApiService.listAccountSocialServices(r);
    }
    listCommitmentDates(r) {
      return this.accountsApiService.listCommitmentDates(r);
    }
    getSalesOrderFormSubmissionInfo(r) {
      return this.accountsApiService.getSalesOrderFormSubmissionInfo(r);
    }
  }
  AccountsSdkService.ɵfac = function AccountsSdkService_Factory(t) {
    return new (t || AccountsSdkService)(i0.ɵɵinject(AccountsApiService));
  };
  AccountsSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountsSdkService,
    factory: AccountsSdkService.ɵfac,
    providedIn: 'root'
  });
  return AccountsSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DigitalAgentSdkService = /*#__PURE__*/(() => {
  class DigitalAgentSdkService {
    constructor(digitalAgentApiService) {
      this.digitalAgentApiService = digitalAgentApiService;
    }
    listAssigneesForPartner(partnerId, onlySameNamespace = false) {
      const r = new ListAssigneesForPartnerRequest({
        partnerId: partnerId,
        onlyIncludeSameNamespace: onlySameNamespace
      });
      return this.digitalAgentApiService.listAssigneesForPartner(r).pipe(take(1), map(resp => {
        return resp.digitalAgents;
      }));
    }
    getDigitalAgentsByUserIds(partnerId, userIds) {
      const req = new GetDigitalAgentsByUserIdsRequest({
        partnerId: partnerId,
        userIds: userIds
      });
      return this.digitalAgentApiService.getDigitalAgentsByUserIds(req).pipe(map(resp => resp.digitalAgents));
    }
    getDigitalAgentsBySubjectIds(partnerId, subjectIds) {
      const req = new GetDigitalAgentsBySubjectIdsRequest({
        partnerId: partnerId,
        subjectIds: subjectIds
      });
      return this.digitalAgentApiService.getDigitalAgentsBySubjectIds(req).pipe(map(resp => resp.digitalAgents));
    }
    sendWelcomeEmailBySubjectId(partnerId, subjectId, usePartnerDefaultDomain = false) {
      const req = new SendWelcomeEmailRequest({
        partnerId: partnerId,
        subjectId: subjectId,
        usePlatformDefaultDomain: usePartnerDefaultDomain
      });
      return this.digitalAgentApiService.sendWelcomeEmail(req).pipe(map(resp => resp.ok));
    }
    sendWelcomeEmailByUserId(partnerId, userId, usePartnerDefaultDomain = false) {
      const req = new SendWelcomeEmailRequest({
        partnerId: partnerId,
        userId: userId,
        usePlatformDefaultDomain: usePartnerDefaultDomain
      });
      return this.digitalAgentApiService.sendWelcomeEmail(req).pipe(map(resp => resp.ok));
    }
    createDigitalAgent(request) {
      return this.digitalAgentApiService.createDigitalAgent(request);
    }
    updateDigitalAgent(request) {
      return this.digitalAgentApiService.updateDigitalAgent(request);
    }
  }
  DigitalAgentSdkService.ɵfac = function DigitalAgentSdkService_Factory(t) {
    return new (t || DigitalAgentSdkService)(i0.ɵɵinject(DigitalAgentsApiService));
  };
  DigitalAgentSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DigitalAgentSdkService,
    factory: DigitalAgentSdkService.ɵfac,
    providedIn: 'root'
  });
  return DigitalAgentSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TemplatesSdkService = /*#__PURE__*/(() => {
  class TemplatesSdkService {
    constructor(templateApiService) {
      this.templateApiService = templateApiService;
    }
    getTemplate(identity) {
      const r = new GetTemplateRequest({
        identity
      });
      return this.templateApiService.getTemplate(r).pipe(map(resp => resp.template));
    }
    listTemplates(namespace, pageSize, cursor) {
      const r = new ListTemplatesRequest({
        namespace,
        pageSize,
        cursor
      });
      return this.templateApiService.listTemplates(r);
    }
    createTemplate(template) {
      const r = new CreateTemplateRequest({
        template
      });
      return this.templateApiService.createTemplate(r).pipe(map(resp => resp.version));
    }
    updateTemplate(identity, version, commands) {
      const r = new UpdateTemplateRequest({
        identity: identity,
        version: version,
        commands: commands
      });
      return this.templateApiService.updateTemplate(r).pipe(map(resp => resp.version));
    }
    deleteTemplate(identity, version) {
      const r = new DeleteTemplateRequest({
        identity,
        version
      });
      return this.templateApiService.deleteTemplate(r).pipe(map(resp => resp.version));
    }
  }
  TemplatesSdkService.ɵfac = function TemplatesSdkService_Factory(t) {
    return new (t || TemplatesSdkService)(i0.ɵɵinject(TemplatesApiService));
  };
  TemplatesSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesSdkService,
    factory: TemplatesSdkService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomTagSdkService = /*#__PURE__*/(() => {
  class CustomTagSdkService {
    constructor(customTagApiService) {
      this.customTagApiService = customTagApiService;
    }
    addCustomTag(identity, customTags, version) {
      return this.customTagApiService.addCustomTag({
        identity: identity,
        customTags: customTags,
        version: version
      }).pipe(map(resp => resp.version));
    }
    removeCustomTag(identity, customTags, version) {
      return this.customTagApiService.removeCustomTag({
        identity: identity,
        customTags: customTags,
        version: version
      }).pipe(map(resp => resp.version));
    }
    getCustomTag(partnerId, tagId) {
      return this.customTagApiService.getCustomTag({
        partnerId,
        tagId
      });
    }
    getMultiCustomTag(partnerId, tagIds) {
      return this.customTagApiService.getMultiCustomTag({
        partnerId,
        tagIds
      });
    }
    listCustomTags(partnerId) {
      return this.customTagApiService.listCustomTags({
        partnerId
      });
    }
    createCustomTag(partnerId, tagName) {
      return this.customTagApiService.createCustomTag({
        partnerId,
        tagName
      });
    }
    updateCustomTag(partnerId, tagId, newTagName) {
      return this.customTagApiService.updateCustomTag({
        partnerId,
        tagId,
        newTagName
      });
    }
    deleteCustomTag(partnerId, tagId) {
      return this.customTagApiService.deleteCustomTag({
        partnerId,
        tagId
      });
    }
  }
  CustomTagSdkService.ɵfac = function CustomTagSdkService_Factory(t) {
    return new (t || CustomTagSdkService)(i0.ɵɵinject(CustomTagsApiService));
  };
  CustomTagSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomTagSdkService,
    factory: CustomTagSdkService.ɵfac,
    providedIn: 'root'
  });
  return CustomTagSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VendorSdkService = /*#__PURE__*/(() => {
  class VendorSdkService {
    constructor(vendorApiService) {
      this.vendorApiService = vendorApiService;
    }
    listActivities(partnerId, accountGroupId, cursor, pageSize) {
      const request = new ListActivitiesRequest({
        partnerId: partnerId,
        accountGroupId: accountGroupId,
        pagingOptions: new PagedRequestOptions({
          cursor: cursor,
          pageSize: pageSize
        })
      });
      return this.vendorApiService.listActivities(request);
    }
    listAccountGroups(request) {
      const r = new ListAccountsRequest(request);
      return this.vendorApiService.listAccounts(r);
    }
    getOwnedAppIdsByPartnerId(partnerId) {
      return this.vendorApiService.getOwnedAppIDsByPartnerId(new GetOwnedAppIDsByPartnerIDRequest({
        partnerId: partnerId
      })).pipe(map(resp => resp?.appIds || []));
    }
  }
  VendorSdkService.ɵfac = function VendorSdkService_Factory(t) {
    return new (t || VendorSdkService)(i0.ɵɵinject(VendorApiService));
  };
  VendorSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorSdkService,
    factory: VendorSdkService.ɵfac,
    providedIn: 'root'
  });
  return VendorSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BusinessFulfillmentSettingsSdkService = /*#__PURE__*/(() => {
  class BusinessFulfillmentSettingsSdkService {
    constructor(businessFulfillmentSettingsApiService) {
      this.businessFulfillmentSettingsApiService = businessFulfillmentSettingsApiService;
    }
    create(businessId, productIds) {
      const req = new CreateBusinessFulfillmentSettingRequest({
        businessId,
        productIds
      });
      return this.businessFulfillmentSettingsApiService.create(req);
    }
    get(businessId) {
      const req = new GetBusinessFulfillmentSettingRequest({
        businessId
      });
      return this.businessFulfillmentSettingsApiService.get(req).pipe(map(resp => resp?.setting));
    }
    addProducts(businessId, productIds) {
      const req = new AddProductsRequest({
        businessId,
        productIds
      });
      return this.businessFulfillmentSettingsApiService.addProducts(req);
    }
    removeProducts(businessId, productIds) {
      const req = new RemoveProductsRequest({
        businessId,
        productIds
      });
      return this.businessFulfillmentSettingsApiService.removeProducts(req);
    }
    delete(businessId) {
      const req = new DeleteBusinessFulfillmentSettingRequest({
        businessId
      });
      return this.businessFulfillmentSettingsApiService.delete(req);
    }
  }
  BusinessFulfillmentSettingsSdkService.ɵfac = function BusinessFulfillmentSettingsSdkService_Factory(t) {
    return new (t || BusinessFulfillmentSettingsSdkService)(i0.ɵɵinject(BusinessFulfillmentSettingsApiService));
  };
  BusinessFulfillmentSettingsSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessFulfillmentSettingsSdkService,
    factory: BusinessFulfillmentSettingsSdkService.ɵfac,
    providedIn: 'root'
  });
  return BusinessFulfillmentSettingsSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductFulfillmentSettingsSdkService = /*#__PURE__*/(() => {
  class ProductFulfillmentSettingsSdkService {
    constructor(productFulfillmentSettingsApiService) {
      this.productFulfillmentSettingsApiService = productFulfillmentSettingsApiService;
    }
    create(productId, taskType, fulfillingPartnerId, ownerPartnerId, templateId) {
      const req = new CreateProductFulfillmentSettingRequest({
        productId,
        taskType,
        fulfillingPartnerId,
        ownerPartnerId,
        templateId
      });
      return this.productFulfillmentSettingsApiService.create(req);
    }
    getMulti(settingIds) {
      const req = new GetMultiProductFulfillmentSettingRequest({
        settingIds
      });
      return this.productFulfillmentSettingsApiService.getMulti(req).pipe(map(resp => resp?.settings || []));
    }
    lookup(lookupReq) {
      return this.productFulfillmentSettingsApiService.lookup(lookupReq);
    }
    setFulfillingPartner(productId, fulfillingPartnerId) {
      const req = new SetFulfillingPartnerRequest({
        productId,
        fulfillingPartnerId
      });
      return this.productFulfillmentSettingsApiService.setFulfillingPartner(req);
    }
    delete(productId, taskType) {
      const req = new DeleteProductFulfillmentSettingRequest({
        productId,
        taskType
      });
      return this.productFulfillmentSettingsApiService.delete(req);
    }
    setTemplate(productId, taskType, templateId) {
      const req = new SetTemplateRequest({
        productId,
        taskType,
        templateId
      });
      return this.productFulfillmentSettingsApiService.setTemplate(req);
    }
  }
  ProductFulfillmentSettingsSdkService.ɵfac = function ProductFulfillmentSettingsSdkService_Factory(t) {
    return new (t || ProductFulfillmentSettingsSdkService)(i0.ɵɵinject(ProductFulfillmentSettingsApiService));
  };
  ProductFulfillmentSettingsSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProductFulfillmentSettingsSdkService,
    factory: ProductFulfillmentSettingsSdkService.ɵfac,
    providedIn: 'root'
  });
  return ProductFulfillmentSettingsSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccessPermissions, AccountChangedRequest, AccountData, AccountGroup, AccountProductDetailsApiService, AccountSalespersonData, AccountSocialService, AccountsApiService, AccountsSdkService, Activity, ActivityTypes, AddAssigneeRequest, AddAttachmentRequest, AddCommentRequest, AddConversationRequest, AddConversationWithNotificationRequest, AddCustomTagsRequest, AddGroupMembersRequest, AddHistoryRequest, AddMultiAssigneeRequest, AddMultipleSubtasksRequest, AddProductsRequest, AddSocialPostSubtaskRequest, AddSubtaskRequest, AddTagsRequest, ArchiveAuxiliaryDataFieldSchemaRequest, AskQuestionRequest, Attachment, AuxiliaryDataFieldSchema, AuxiliaryDataFieldType, AuxiliaryDataObjectID, BusinessFulfillmentSetting, BusinessFulfillmentSettingsApiService, BusinessFulfillmentSettingsSdkService, CanUserAccessVendorPartnerRequest, CanUserAccessVendorPartnerResponse, ChildNode, CommandResponse, Comment, CommentProjectionFilter, CommentType, ConciergeAccount, ContactDetails, Conversation, ConversationTypes, CountMetricResponse, CreateActivityRequest, CreateActivityResponse, CreateAuxiliaryDataFieldSchemaRequest, CreateBusinessFulfillmentSettingRequest, CreateConciergeAccountRequest, CreateCustomTagRequest, CreateCustomTagResponse, CreateDigitalAgentRequest, CreateDigitalAgentRequestPartnerPermissionsEntry, CreateGroupRequest, CreateGroupResponse, CreateMultiProjectFromTemplateRequest, CreateProductFulfillmentSettingRequest, CreateProjectFromTemplateRequest, CreateProjectFromTemplateSynchronousResponse, CreateRecurringTaskRequest, CreateRecurringTaskResponse, CreateTaskStatusRequest, CreateTaskStatusResponse, CreateTemplateFromProjectResponse, CreateTemplateRequest, CustomTag, CustomTagSdkService, CustomTagsApiService, DateField, DateFilter, DeactivateConciergeAccountRequest, DecryptNotesRequest, DecryptNotesResponse, DeleteBusinessFulfillmentSettingRequest, DeleteCustomTagRequest, DeleteGroupRequest, DeleteMultiTaskRequest, DeleteProductFulfillmentSettingRequest, DeleteRecurringTaskRequest, DeleteTaskRequest, DeleteTaskStatusRequest, DeleteTemplateRequest, DeleteUserRequest, DigitalAgent, DigitalAgentPartnerPermissionsEntry, DigitalAgentSdkService, DigitalAgentsApiService, DropdownOption, EncryptNotesRequest, EncryptNotesResponse, ExportColumns, ExportProjectsRequest, ExportTypes, ExternalIdentifiers, FieldDataUpsertOperation, FieldMask, FieldSchemaIdentifier, Filters, FuzzyRangeField, FuzzyRangeFilter, FuzzySearchHydratedTasksRequest, FuzzySearchHydratedTasksResponse, FuzzySort, FuzzySortDirection, FuzzyTaskSearchRequest, FuzzyTaskSearchResponse, GenerateFileUploadUrlRequest, GenerateFileUploadUrlResponse, GenerateTaskRequest, GetAccountListingSourcesSettingsRequest, GetAccountProductDetailsRequest, GetAccountProductDetailsResponse, GetAccountVendorProductDetailsRequest, GetActivityRequest, GetActivityResponse, GetAttachmentUrlRequest, GetAttachmentUrlResponse, GetAuxiliaryDataFieldSchemaRequest, GetAuxiliaryDataFieldSchemaResponse, GetBusinessFulfillmentSettingRequest, GetBusinessFulfillmentSettingResponse, GetCommentCountRequest, GetCommentCountResponse, GetCustomTagRequest, GetCustomTagResponse, GetDigitalAgentsBySubjectIdsRequest, GetDigitalAgentsBySubjectIdsResponse, GetDigitalAgentsByUserIdsRequest, GetDigitalAgentsByUserIdsResponse, GetFulfilledPartnersRequest, GetFulfilledPartnersResponse, GetHydratedTaskRequest, GetHydratedTaskResponse, GetMeetingHostRequest, GetMeetingHostResponse, GetMetricsFilters, GetMetricsRequest, GetMetricsRequestMetricRequest, GetMetricsResponse, GetMultiAuxiliaryDataFieldSchemaRequest, GetMultiAuxiliaryDataFieldSchemaResponse, GetMultiCommentCountRequest, GetMultiCommentCountResponse, GetMultiCustomTagRequest, GetMultiCustomTagResponse, GetMultiHydratedTaskRequest, GetMultiHydratedTaskResponse, GetMultiProductFulfillmentSettingRequest, GetMultiProductFulfillmentSettingResponse, GetMultiUserInfoExternalRequest, GetMultiUserInfoExternalResponse, GetMultiUserInfoExternalResponseUsersEntry, GetOrderFormForProjectRequest, GetOrderFormForProjectResponse, GetOwnedAppIDsByPartnerIDRequest, GetOwnedAppIDsByPartnerIDResponse, GetProductEntryUrlRequest, GetProductEntryUrlResponse, GetPurchasingPartnerAccountRequest, GetPurchasingPartnerAccountResponse, GetPurchasingPartnerConciergeAccountRequest, GetPurchasingPartnerConciergeAccountResponse, GetRecurringTaskRequest, GetRecurringTaskResponse, GetSalesOrderFormSubmissionInfoRequest, GetSalesOrderFormSubmissionInfoResponse, GetSalesPersonBySubjectIDRequest, GetSalesPersonBySubjectIDResponse, GetTaskAccountsRequest, GetTaskAccountsResponse, GetTaskConciergeAccountRequest, GetTaskConciergeAccountResponse, GetTaskHistoryRequest, GetTaskHistoryResponse, GetTaskRequest, GetTaskResponse, GetTaskStatusRequest, GetTaskStatusResponse, GetTasksRequest, GetTasksResponse, GetTemplateRequest, GetTemplateResponse, GetTreeRequest, GetTreeResponse, GoType, GroupApiService, GroupGetMultiRequest, GroupGetMultiResponse, GroupSdkService, GroupedMetadata, GroupedTags, History, HydratedAccessPermissions, HydratedAttachment, HydratedConversationPersonaType, HydratedGroupedMetadata, HydratedGroupedTags, HydratedKeyValue, HydratedKeyValues, HydratedRangeField, HydratedSort, HydratedSortDirection, HydratedTagGroup, HydratedTask, HydratedTaskConversation, HydratedTaskHistory, HydratedTaskIdentity, HydratedTaskProjectionFilter, HydratedValue, KeyValueField, KeyValueTypes, KeyValues, KeyValuesKeyValue, KeyValuesKeyValueValue, ListAccountSocialServicesRequest, ListAccountSocialServicesResponse, ListAccountsRequest, ListAccountsResponse, ListActivitiesRequest, ListActivitiesResponse, ListAssigneesForPartnerRequest, ListAssigneesForPartnerResponse, ListAuxiliaryDataFieldSchemaRequest, ListAuxiliaryDataFieldSchemaRequestFilters, ListAuxiliaryDataFieldSchemaResponse, ListAuxiliaryDataRequest, ListAuxiliaryDataResponse, ListCommitmentDatesRequest, ListCommitmentDatesResponse, ListCommitmentDatesResponseCommitmentDateEntry, ListCustomTagsRequest, ListCustomTagsResponse, ListGroupMembersRequest, ListGroupMembersResponse, ListGroupRequest, ListGroupResponse, ListGroupsByMembersRequest, ListGroupsByMembersResponse, ListGroupsByMembersResponseGroupsEntry, ListProductsRequest, ListProductsResponse, ListTaskStatusesRequest, ListTaskStatusesResponse, ListTemplatesRequest, ListTemplatesResponse, LoadCommentsRequest, LoadCommentsResponse, LookupProductFulfillmentSettingRequest, LookupProductFulfillmentSettingResponse, MarketData, Metric, MetricResponses, MetricResponsesMetricResponse, MetricsApiService, MonthlyRecurringOptions, MultiCommandRequest, MultiCommandRequestEvent, MultiCommandResponses, MultiCommandResponsesMultiCommandResponse, MultiSearchTaskRequest, MultiString, NAPData, NotifyReviewCommentRequest, Operator, OperatorNode, OrderFormApiService, OrderFormFieldSubmission, OrderFormFileField, PagedRequestOptions, PagedResponseMetadata, ParentData, PartnerBranding, PartnerData, Path, PauseConciergeAccountRequest, Permissions, Persona, PersonaType, PlatformLocation, Post, Product, ProductDetails, ProductFilterOperator, ProductFulfillmentApiService, ProductFulfillmentSetting, ProductFulfillmentSettingKey, ProductFulfillmentSettingsApiService, ProductFulfillmentSettingsSdkService, ProjectCommentsCountData, ProjectStatusData, ProjectSubtaskCount, ProjectSubtaskCountRequest, ProjectSubtaskCountResponse, ProjectionFilter, RangeField, RecurringTask, RecurringTaskExpires, RecurringTaskFrequencies, RecurringTaskProjectionFilter, RecurringTaskTypes, RecurringTasksApiService, RemoveAssigneeRequest, RemoveAttachmentRequest, RemoveCustomTagsRequest, RemoveGroupMembersRequest, RemoveMultiAssigneeRequest, RemoveProductsRequest, RemoveTagsRequest, ReorderSubtask, ReorderSubtaskRequest, ResetEmailOptions, RespondToSocialCommentRequest, RespondToSocialCommentResponse, RestoreMultiTaskRequest, RestoreParentAndChildrenMultiRequest, RestoreTaskRequest, RuntimeField, SalesOrderFormSubmissionField, Salesperson, SearchHydratedTaskRequest, SearchHydratedTaskResponse, SearchRecurringTaskRequest, SearchRecurringTaskResponse, SearchTaskRequest, SearchTaskResponse, SendCalendarForClientFeedbackExternalRequest, SendEmailRequest, SendFeedbackRequest, SendNotificationRequest, SendNotificationResponse, SendWelcomeEmailRequest, SetAccountNoteRequest, SetDescriptionRequest, SetDueDateRequest, SetFulfillingPartnerRequest, SetKeyValue, SetKeyValuesRequest, SetMeetingTaskInfoRequest, SetMultiDueDateRequest, SetMultiNotesRequest, SetMultiStatusRequest, SetNotesRequest, SetStatusRequest, SetTemplateRequest, SetTitleRequest, SetTypeRequest, SocialCalendarApiService, Sort, SortDirection, SourceSetting, SourceSettingsResponse, Status, TagGroup, Task, TaskAuxiliaryFieldDataApiService, TaskAuxiliaryFieldSchemaApiService, TaskHistory, TaskIdentity, TaskManagerApiService, TaskManagerAuthApiService, TaskManagerGroup, TaskManagerGroupList, TaskManagerSdkService, TaskMetricsSdkService, TaskStatus, TaskStatusesApiService, TaskStatusesSdkService, TaskTree, Template, TemplateIdentity, TemplateInfo, TemplatesApiService, TemplatesSdkService, UnarchiveAuxiliaryDataFieldSchemaRequest, UpdateAccountListingSourceRequest, UpdateAccountMultiListingSourceRequest, UpdateAuxiliaryDataFieldSchemaRequest, UpdateCustomTagRequest, UpdateDigitalAgentRequest, UpdateDigitalAgentRequestPartnerPermissionsEntry, UpdateGroupNameRequest, UpdateRecurringTaskRequest, UpdateRecurringTaskResponse, UpdateTaskStatusRequest, UpdateTemplateRequest, UpdateTemplateRequestCommand, UpsertAuxiliaryDataRequest, UserInfo, UserParam, ValueMetricResponse, VendorApiService, VendorSdkService, WeeklyRecurringOptions, WelcomeEmailOptions, YearlyRecurringOptions };
